import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UntypedFormGroup, Validators, UntypedFormControl, UntypedFormBuilder, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { FormFieldsTrimer } from 'src/app/shared/Validations/FormFieldsTrimer';
import * as _moment from 'node_modules/moment/moment';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { UserMultiColumnDropdownComponent } from '../user-multi-column-dropdown/user-multi-column-dropdown.component';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/common/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ActivatedRoute, Router } from '@angular/router';
import { element } from 'protractor';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { constants } from 'src/app/shared/common/contants';
import * as fs from 'fs';
import { RowDragEnterEvent, RowDragMoveEvent, RowDragEndEvent, RowDragLeaveEvent } from 'ag-grid-community';
import { ColDef, GridReadyEvent } from 'ag-grid-community';
import { CustomCellRenderer } from '../../shared/common/CustomCellRenderer';
import { delay, filter } from 'rxjs/operators';
import { FiledownloadComponent } from 'src/app/shared/common/filedownload.component';
import { VaultObjectgroupService } from './../vaultobject-popup-screen/vault-objectgroup.service';
import { BuildButton } from 'src/app/shared/common/BuildButton';
import { DatasetActionButtons } from 'src/app/shared/common/DatasetActionButtons';
import { AccessPermissionComponent } from './access-permission/access-permission.component';
import { FilterspopupComponent } from '../filters/filterspopup/filterspopup.component';
import { SelectFiltersPopUpComponent } from './select-filters-pop-up/select-filters-pop-up.component';
import { EtlService } from '../vault-data-migration-etl/etl.service';
import { RpmSearchFilterComponent } from './rpm-search-filter/rpm-search-filter.component';
import { ImportDialogComponent } from './import-dialog/import-dialog.component';
import { ExportDialogComponent } from './export-dialog/export-dialog.component';
import { MatSelectChange } from '@angular/material/select';
import { UserRoutingModule } from 'src/app/user/user-routing/user-routing.module';
import { CopydatasetDialogComponent } from 'src/app/user/report-configuration/copydataset-dialog/copydataset-dialog.component';
import { RetrieveScreenAccess } from 'src/app/shared/models/userrole'
import {IncrementalDataLoadSchedulePopupComponent} from '../baseline-data-load/incremental-data-load-schedule-popup/incremental-data-load-schedule-popup.component';
import { ConditionInfoDialogComponent } from './condition-info-dialog/condition-info-dialog.component';
import { lookup } from 'dns';




const moment = _moment;

export interface ConditionalOPeratorTypeWhere {
  name: string,
  value: string
}

export interface Constants {
  name: string,
  value: string
}

export interface LogicalOperatorTypeWhere {
  name: string,
  value: string
}

export interface ArrangeTypeOrderBy {
  name: string,
  value: string
}

export interface AggregateDataBy {
  name: string,
  value: string
}

export interface ArrangeMyDataBy {
  name: string,
  value: string
}

export interface ArrangeMyTypeBy {
  name: string,
  value: string
}

export interface Types {
  type: string;
}

export interface dataLakeTypes{
  name: string,
  value: string
}

/* Chaitanya
*  Manage Datasets
*  20-07-2022
*/
@Component({
    selector: 'app-report-configuration',
    templateUrl: './report-configuration.component.html',
    styleUrls: ['./report-configuration.component.scss'],
    standalone: false
})
export class ReportConfigurationComponent implements OnInit {


  /**
   * modified by Ashwin M
   * 28/02/2024
   * flag added for dataset refresh upon incremantal load
   */
  jsuitepropertyValue: any;
  sharedData: any;
  autoRefreshDataset: any = false;
  generateDefaultTemplate: any = true;
  applyRecordFilter: any = false;
  public UserRolesWithRoleId: any[];
  private responserequest: any;

  //ngModel
  columnFilter = [];
  columnFilterData = { "name": "", "object": "", "alias": "", "filters": [] };
  columnFilterDataObject = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };

  whereData = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };

  recordfilterData = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };

  rollingupdata = { "parentObjectName": "", "parentattribute": "", "childObjectName": "", "childattributes": "", "parentAttributesalias": "", "childAttributesalias": "", "rollupColumnAlias": "", "rollingUpLevel": "1","rollupseprator":"," };

  rollingupdatatemp = { "childattributes": [], "childAttributesalias": [] };

  barArray = { "type": "column", "xKey": "", "yKeys": "", "grouped": "true", "label": "{}", "strokeWidth": "0" };

  groupByData = { "fieldsGroupBy": "" };

  orderByData = { "objectOrderBy": "", "fieldsOrderBy": "", "arrangeOrderBy": "" };
  headerTypeObj = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" };


  //aggregateByData = { "objectAggregateBy": "", "fieldsAggregateBy": "", "arrangeaggregateBy": "" };

  aggregateByData = {
    "aggregateOn": "", "aggregateFunction": "", "partionOn": "", "distinctColumns": "", "columnAlias": "", "conditionalValue": "", "groupByNeeded": false, "groupByFunction": ""
  };
  pivotAggregateData: any[] = [];
  selectedPivotAggregates: any[] = [];
  pivotAggregateByData={
    "pivotType":'pivotAggregate',
    "columnAlias":"",
    "caseColumn":"",
    "pivotColumn":"",
    "childColumns":"",
    "headerValueColumn":"",
    "orderByColumn":"",
    "parentcolumns":"",
    "headersToNull":"",
    "distinctCount":"",
    "pivotAlias":"",
    "grandTotalGroupby":""
    
  }
  subAggregateLevelData = { "groupByColumn": "", "groupByNeeded": true, "alias": "" };
  datasetFormByData = { "namedatasetBy": "", "typedatasetBy": "", "detailsdatasetBy": "", "accesstypedatasetBy": "" };

  formulaFieldsByData = { "labelformulafieldsBy": "", "returntypeformulafieldsBy": "", "objectformulafieldsBy": "", "functionsformulafieldsBy": "", "oprationsformulafieldsBy": "" };

  reportingObject = { "from": "", "queryArray": [], "join": [], "firstJoin": [], "secondJoin": [], "thirdJoin": [], "fourthJoin": [] };

  reportingObjectSend = { "reportMainConfigurationId": "", "object": "", "queryArray": [], "from": "", "joins": [], "where": [], "groupBy": [], "orderBy": [], "type": "", "name": "", "userAccess": "", "aggregateBy": [] };

  reportCreationDataduplicate = { "datasetname": "", "reporttemplatename": "", "details": "", "type": "", "accesstype": "", "vaultDocumentType": "", "documentsubtype": "", "vaultClasification": "", "vaultTemplate": "", "vaultbinderTemplate": "", "description": "", "objectGroup": "" };

  datasetQuickSight = { "s3Path": "", "dataSetId": "", "dataSetName": "", "dnsId": "", "filterList": [], "visualType": "", "visualId": 0 };
  /**
   * modified by Ashwin M
   * 28/02/2024
   * code modified to add refresh dataset flag in dataset creation request object
   */
  /* modified by Chandra R
   *  Added two two values to reportCreationData property
   *  30-06-2024
   */
  /*
   *  Modified by Prasanna Jeebi
   *  Added the field as datasetRefreshDateTime
   *  30-06-2025
   */
  reportCreationData = { "datasetname": "", "datasetObjectname": "", "datasetobjectattributes": [], "type": "", "description": "", "objectGroup": "", "datalakeType": "", "filters": [], "sorting": [], "aggregate": [], "columns": [], "concatination": [], "rollingUp": [], "rollupExclusionObjects": [], "transformation": [], "columnFilters": [], "generateDefaultTemplate": "", "autoRefreshDataset": "", "datasetAccessType": "", "dataset_rolesIds": "", "createdBy": "", "createdDateAndTime": "", "headersType": [],"pivotAggregation":[], "datasetRefreshDateTime": "", "datasetOutputFormat": ""}

  rollupExclusionObjectTemplate = { "exclusionObject": "" };
  transformationObjectData = { "object": "", "attribute": "", "alias":"", "referenceObjects": "", "sql": "" };

  transformationReferenceList: string[] = [];
  transformationReferenceListTemp = [];

  rollupExclusionObjects: any;


  finalReportCreation = {
    "datasets": [
      {
        "name": "",
        "datasetType": "",
        "columns": []
      }
    ],
    "reports": []
  }
  selectedValue: boolean = true;

  columnDefsForObjects;

  //columnDefsForTables;

  columnDefsForTablesFields;

  columnDefsForReportingConfiguration;

  columnDefsForWhere;

  columnDefsForAggregate;

  columnDefsForOrderBy;

  rowSelection;

  rowSelectionForTablesFields;

  //gridApi;

  gridApiForTablesFields;

  gridApiForReportingConfiguration;

  gridApiForWhere;

  gridApiForOrderBy;

  gridApiForAggregate;

  tablesFields = [];
  tableFields = [];

  defaultColDefs;

  ngModelObjectDivision = [];

  tableNames = [];
  join = [];
  firstJoin = [];
  secondJoin = [];
  thirdJoin = [];
  fourthJoin = [];
  from = [];
  whereValueDateFormat = moment(null)

  selectedObject;
  selectedObjectName;

  selectObjectId;

  //selectedTable;

  paginationPageSize;

  paginationNumberFormatter;

  rowClassRules;
  getRowStyle;

  lastpage;

  currentpage;

  nextpage;

  nextpageplusone;

  totalpages;

  pagesize;

  screenNames;

  columnNames = [];

  rowsData: any = [];
  rollupSeparatorList = [{'rollupseparator':'Comma Seperated','rollupseperatorvalue':','  }];
  

  formValidWhere: FormGroup;
  formValidAttributes: FormGroup;
  formulaFields: FormGroup;
  datasetForm: FormGroup;
  transformationFormGroup: FormGroup;
  columnFilterFormGroup: FormGroup;

  validationMessagesWhere;

  fieldsData: any = [];

  fieldsTemp: any = [];

  aggregateArray: any = [];

  where = [];
  recordWhere = [];

  rollingUp = [];

  transformation: any = []

  formValidGroupBy: FormGroup;

  validationMessagesGroupBy;

  groupBy = [];

  formValidOrderBy: UntypedFormGroup;
  formValidHeaderType: FormGroup;
  formValidPivotType: FormGroup;

  validationMessagesOrderBy;

  xdummydata: String;

  orderBy = [];
  headersTypeArr = [];

  whereAgGrid = [];

  components: any;

  orderByAgGrid = [];

  aggregateAgGrid = [];

  aggregateBy = [];
  pivotAggregateBy=[];
  subLevelAggregateBy = [];

  showFilters: boolean = true;
  show: boolean = false;
  expand: boolean = false;
  isExpandFilters: boolean = false;
  showAggregate: boolean = false;
  showPivotAggregate: boolean = false;
  showSubLevelAggregate: boolean = false;
  isExpandAggregate: boolean = false;
  showOrderBy: boolean = false;
  showHeaderType: boolean = false;
  isExpandOrderBy: boolean = false;
  allFields: any = [];
  wherefields: any = [];
  sortingfields: any = [];
  aggregatefields: any = [];
  columnDefsForSelectedFields: any;
  gridApiForSelectedTablesFields: any;
  fieldsDataToRemove: any = [];
  selectedFieldsData: any = [];
  selectedFieldsDatatemp: any = [];
  selectedFieldsDataToPush: any = [];
  temp: any = [];
  selectedFields: any = [];

  transformationField: any;
  validations_form: UntypedFormGroup;
  defaultColDef
  ngModelObjectTemporary
  butttonname = "Create Dataset"
  reportCreationUpdateid
  validation_messages
  editMyDataSet: any
  orderByShow: boolean = false;
  aggreageShow: boolean = false;
  fieldChange: boolean = true;
  dateChange: boolean = false;
  showFilter: boolean = false;
  showRollingUp: boolean = false;
  showTransform: boolean = false;
  saveButton: boolean = true;
  updateButton: boolean = false;
  showgridData: boolean = true;
  barChartData: boolean = false;
  pieChartData: boolean = false;
  showChartData: boolean = false;
  betweenField: boolean = false;
  dateField: boolean = false;
  valueField: boolean = true;
  multiselect: boolean = false;
  scheduleRange: boolean = false;

  recordBetweenField: boolean = false;
  recordDateField: boolean = false;
  recordValueField: boolean = true;
  recordMultiselect: boolean = false;
  recordMultiField: boolean = true;
  recordMultiDate: boolean = false;
  recordscheduleRange: boolean = false;

  columnBetweenField: boolean = false;
  columnDateChange: boolean = false;
  columnFieldChange: boolean = true;
  columnMultiselect: boolean = false;
  columnMultiField: boolean = false;
  columnMultiDate: boolean = false;
  columnScheduleRange: boolean = false;
  columnDateField: boolean = false;
  columnValueField: boolean = true;
  showColumnFilter: boolean = false;

  tableNamestemp = [];
  keyStrings = [];
  aggretaefields = [];
  group = [];
  aliasString
  aggregateValue
  xKeydata: any = [];
  ykeydata: any = []

  getdata: any = []

  xdata = [];

  eachBar = [];
  filterData = [];
  recordLevelFilterData = [];
  columnLevelFilterData = [];
  xAxis1;
  yAxis1;

  editresponse: any = []

  gridApi;
  datasetOutputFormat: string = ''; // New property for Dataset output format

  options: any;

  public listItems: Array<string> = [];

  eachxdata
  paramstemp
  selectedTableFields
  objectGroup: boolean = false;
  datasetGroup: boolean = false;

  multiSelectVaules = [];

  recordFilterSelectionEvent;

  dataSetObject = {
    datasetname: '',
    accesstype: '',
    fieldslist: '',
    userid: '',
    objectid: '',
    createdDate: '',
    createdBy: '',
    lastModifiedDate: '',
    lastModifiedBy: ''
  }

  filterListBody = []
  gridOptions = {
    animateRows: true,
    enableSorting: true,
    enableCellChangeFlash: true,
    components: { numericCellEditor: getNumericCellEditor() },
    onGridReady: params => {
      params.api.expandAll();
    }
  };

  backgroundColorButton = "";

  //need to remove

  save
  update
  barChart
  value;
  gridColumnAPI;
  overlayNoRowsTemplate;
  columnDefs
  rowData
  private gridColumnApi;
  grid

  backgroundColorScreen = "";
  buttonColor = "";
  isExpand: boolean = true
  tablefields: any = [];
  k;
  vaultGroup: any = []
  datasetGroups: any = []
  ObjectsData: any = []
  rowbindingdata;
  ObjectGrid;
  addedColumnsTemp: any = []
  columnname: any = []
  columns: any = []
  dataset_rolesIds
  sortActive
  filterActive
  immutableStore: any = [];
  sortingOrder
  rollingupDatasettwo: any = []
  concatination: any = []
  finalunconcatination: any = [];
  filterObjects: any = [];
  multiSelectKeyAttributes: any = [];
  referenceObjects: any = [];
  datasetIdToRetrieveObjectsdata;
  tempObjectsData;
  objectAttributes;
  conditionalOperatorDataWhere: ConditionalOPeratorTypeWhere[] = [
    { name: "Matches", value: "=" },
    { name: "Does Not Matches", value: "<>" },
    { name: "Matches At Least One", value: "IN" },
    { name: "Starts With", value: "Starts with" },
    { name: "Ends With", value: "Ends with" },
    { name: "Contains", value: "contains" },
    { name: "Greater Than Or Equals", value: ">=" },
    { name: "Is Greater Than", value: ">" },
    { name: "Less Than Or Equals", value: "<=" },
    { name: "Is Less Than", value: "<" },
    { name: "Between", value: "BETWEEN" },
    { name: "Current Schedule Range", value: "schedule range" }
  ];

  rollingUpconstants: Constants[] = [
    { name: "And", value: "And" },
    { name: "OR", value: "OR" },
    { name: "/", value: "/" },
    { name: "_", value: "_" },
    { name: "-", value: "-" },
    { name: ".", value: "." },
    { name: ",", value: "," }
  ];

  dataLakeTypes : dataLakeTypes[] = [
  { name: "JSON Data Lake", value: "jsonDatalake" },
    { name: "Parquet Data Lake", value: "parquetDatalake" },
    { name: "Case Wise JSON Datalake", value: "caseWiseJsonDatalake" }
];
// Add new array for Dataset Output Format if different options needed
datasetOutputTypes: dataLakeTypes[] = [];



  types: Types[] = [
    {
      type: "Object Group"
    },
    {
      type: "Dataset Group"
    }
  ]


  logicalOperatorDataWhere: LogicalOperatorTypeWhere[] = [
    { name: "And", value: "And" },
    { name: "Or", value: "Or" }
  ];

  arrangeDataOrderBy: ArrangeTypeOrderBy[] = [
    { name: "Ascending", value: "ASC" },
    { name: "Descending", value: "DESC" }
  ];

  arrangeDataBy: AggregateDataBy[] = [
    { name: "Avg", value: "avg" },
    { name: "Count", value: "count" },
    //   { name: "Group Concate", value: "group_concat" },
    { name: "Max", value: "max" },
    { name: "Min", value: "min" },
    { name: "Sum", value: "sum" },
  ];
  arrangeDataByForHeaderType: AggregateDataBy[] = [
    { name: "StringType", value: "StringType" },
    { name: "IntegerType", value: "IntegerType" },
    { name: "LongType", value: "LongType" },
    { name: "FloatType", value: "FloatType" },
    { name: "DoubleType", value: "DoubleType" },
    { name: "BooleanType", value: "BooleanType" },
    { name: "ShortType", value: "ShortType" },
    { name: "DateType", value: "DateType" },
    { name: "TimestampType", value: "TimestampType" },
    { name: "BinaryType", value: "BinaryType" },



  ];


  arrangeDatasetBy: ArrangeMyDataBy[] = [
    { name: "Public", value: "public" },
    { name: "Private", value: "private" }
  ];

  arrangeTypeBy: ArrangeMyTypeBy[] = [
    { name: "Type 1", value: "type1" },
    { name: "Type 2", value: "type2" }
  ];
  ExportObjectGroups: any;
  orderedPartitionSelection: string[] = [];
  orderedOrderBySelection: string[] = [];
  groupByColumnSelections: string[] = [];

  orderedChildColumns:string[] = [];
  orderedHeadersToNull:string[] = [];
  orderedOrderByColumn:string[] = [];
  orderedParentcolumns:string[] = [];
   buttonIdList = []
  constructor(private retrieveScreenAccess: RetrieveScreenAccess, private userRoutingModule: UserRoutingModule, private msg: ErrorMessages, private validation: validationmethod, private service: ReportingServiceService, private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, private dialog: MatDialog, private fb: FormBuilder, private localStorageSettings: LocalStorageSettingsService, private formFieldsTrimer: FormFieldsTrimer, private linkservice: ReportlinksserviceService, private constants: constants, private vaultObjectService: VaultObjectgroupService, private router: Router, private etlService: EtlService) {
    //messages for validations
    this.UserRolesWithRoleId = [];
    this.validation_messages = this.msg.reportConfiguration;
    this.validationMessagesGroupBy = this.msg.groupByMessages;

    this.validationMessagesGroupBy = this.msg.orderByMessages;
    //cell rendering in ag-grid
    /**
      * modified by Ashwin M
      * 28/02/2024
      * code modified to change button renderer for datasets grid
    */
    this.components = {
      buttonRenderer: DatasetActionButtons,
    }

  }

  formValidation() {
    this.validations_form = new FormGroup({
      selectdataSet: new FormControl('', [Validators.required, this.validation.specialCharacterValidator, this.validation.noWhitespaceValidator, Validators.maxLength(100)]),
      // reporttemplatename: new FormControl('',[Validators.required, this.validation.noWhitespaceValidator, Validators.maxLength(100),Validators.pattern('^[a-zA-Z]+$')]),
      // details: new FormControl('',[Validators.required, this.validation.noWhitespaceValidator, Validators.maxLength(100),Validators.pattern('^[a-zA-Z]+$')]),
      type: new FormControl('', [Validators.required]),
      // accesstype: new FormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      // vaultDocumentType:new FormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      // documentsubtype:new FormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      // vaultClasification:new FormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      // vaultTemplate:new FormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      // vaultbinderTemplate:new FormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      objectGroup: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required, this.validation.specialCharacterValidator, this.validation.noWhitespaceValidator]),
      access: new FormControl(' ', [Validators.required]),
      dataLakeType: new FormControl('', [Validators.required]),
     datasetOutputFormat: new FormControl('', [Validators.required]) // Add this line
    });
  }

  formulaFieldsValidation() {
    this.formulaFields = new UntypedFormGroup({
      label: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator, Validators.maxLength(100), Validators.pattern('^[a-zA-Z]+$')]),
      returntype: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator]),
      object: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator]),
      functions: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator]),
      oprations: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator])
    })
  }

  formValidationsWhere(pivotType: string = 'pivotAggregate', values: any = {}) {
    // form validations
    this.formValidWhere = new UntypedFormGroup({
      fieldsWhere: new UntypedFormControl('', []),
      conditionalOperatorWhere: new UntypedFormControl('', []),
      enterValueWhere: new UntypedFormControl('', []),
      logicalOperatorWhere: new UntypedFormControl('', []),
      fieldsOrderBy: new UntypedFormControl('', []),
      arrangeOrderBy: new UntypedFormControl('', []),
      // fieldsAggredateBy: new UntypedFormControl('', []),
      // arrangeaggregateBy: new UntypedFormControl('', []),
      objectWhere: new UntypedFormControl('', []),
      objectOrderBy: new UntypedFormControl('', []),
      // objectAggregateBy: new UntypedFormControl('', []),
      multiselect: new UntypedFormControl('', []),
      aggregateOn: new UntypedFormControl('', []),
      aggregateFunction: new UntypedFormControl('', []),
      partionOn: new UntypedFormControl('', []),
      orderBy: new UntypedFormControl('', []),
      columnAlias: new UntypedFormControl('', []),
      conditionalValue: new UntypedFormControl('', []),
      groupBysecondary: new UntypedFormControl('', []),
      goupByColumnAlias: new UntypedFormControl('', []),
      //headerKey: new UntypedFormControl('', [Validators.required]),
      //headerKeyType: new UntypedFormControl('', [Validators.required])

     
    });
  }

  formValidationsRollingUp() {
    this.formValidAttributes = new FormGroup({
      datasetNameone: new FormControl('', []),
      attributes: new FormControl('', []),
      constant: new FormControl('', []),
      datasetNametwo: new FormControl('', []),
      attributestwo: new FormControl('', []),
      selectedChildDataSet: new UntypedFormControl('', []),
      recordFilter: new UntypedFormControl('', []),
      recordConditionalOperatorWhere: new UntypedFormControl('', []),
      recordMultiselect: new UntypedFormControl('', []),
      fieldsWhere: new UntypedFormControl('', []),
      conditionalOperatorWhere: new UntypedFormControl('', []),
      enterValueWhere: new UntypedFormControl('', []),
      logicalOperatorWhere: new UntypedFormControl('', []),
      fieldsOrderBy: new UntypedFormControl('', []),
      arrangeOrderBy: new UntypedFormControl('', []),
      fieldsAggredateBy: new UntypedFormControl('', []),
      arrangeaggregateBy: new UntypedFormControl('', []),
      objectWhere: new UntypedFormControl('', []),
      objectOrderBy: new UntypedFormControl('', []),
      objectAggregateBy: new UntypedFormControl('', []),
      multiselect: new UntypedFormControl('', []),
      rollupExclusion: new UntypedFormControl('', []),
      aggregateOn: new UntypedFormControl('', []),
      aggregateFunction: new UntypedFormControl('', []),
      partionOn: new UntypedFormControl('', []),
      orderBy: new UntypedFormControl('', []),
      columnAlias: new UntypedFormControl('', []),
      rollupSeparator:new UntypedFormControl('', []),

    });

  }


  datasetFormValidation() {
    this.datasetForm = new UntypedFormGroup({
      name: new UntypedFormControl(''),
      type: new UntypedFormControl(''),
      details: new UntypedFormControl(''),
      accesstype: new UntypedFormControl('')
    })
  }

  formValidationForTranformation() {
    // form validations
    this.transformationFormGroup = new UntypedFormGroup({
      transformationObject: new UntypedFormControl('', []),
      transformationAttribute: new UntypedFormControl('', []),
      transformationReference: new UntypedFormControl('', []),
      transformationSql: new UntypedFormControl('', []),
    });
  }

  formValidationsGroupBy() {
    // form validations
    this.formValidGroupBy = new UntypedFormGroup({
      fieldsGroupBy: new UntypedFormControl('', [Validators.required])
    });
  }

  formValidationsOrderBy() {
    // form validations
    this.formValidOrderBy = new UntypedFormGroup({

    });
  }
  formValidationsHeaderType() {
    // form validations
    this.formValidHeaderType = new UntypedFormGroup({
      headerKey: new UntypedFormControl(''),
      headerKeyAlias: new UntypedFormControl(''),
      headerKeyType: new UntypedFormControl('')

    });
  }

   formValidationsPivotType(pivotType: string = 'pivotAggregate', values: any = {}) {
    // form validations
    this.formValidPivotType = new UntypedFormGroup({
       pivotColumnAlias: new UntypedFormControl(values.pivotColumnAlias || '', []),
    caseColumn: new UntypedFormControl(values.caseColumn || '', []),
    pivotColumn: new UntypedFormControl(values.pivotColumn || '', []),
    childColumns: new UntypedFormControl(values.childColumns || '', []),
    headersToNull: new UntypedFormControl(values.headersToNull || '', []),
    orderByColumn: new UntypedFormControl(values.orderByColumn || '', []),
    parentcolumns: new UntypedFormControl(values.parentcolumns || '', []),
    headerValueColumn: new UntypedFormControl(values.headerValueColumn || '', []),
    pivotType: new UntypedFormControl(pivotType),
    distinctCount: new UntypedFormControl(values.distinctCount || '', []),
    pivotAlias: new UntypedFormControl(values.pivotAlias || '', []),
    grandTotalGroupby: new UntypedFormControl(values.grandTotalGroupby || '', []),

    });
        this.onPivotTypeChange(pivotType);
  }

  validateColumnFilterFormGroup() {
    this.columnFilterFormGroup = new UntypedFormGroup({
      columnObject: new UntypedFormControl('', []),
      columnAttribute: new UntypedFormControl('', []),
      columnObjectList: new UntypedFormControl('', []),
      columnObjectAttributes: new UntypedFormControl('', []),
      columnLogicalOperatorWhere: new UntypedFormControl('', []),
      columnTextfield: new UntypedFormControl('', []),
      columnDatefield: new UntypedFormControl('', []),
      columnMultiSelect: new UntypedFormControl('', []),
      objectOrderBy: new UntypedFormControl('', []),
      // objectAggregateBy: new UntypedFormControl('', []),
      multiselect: new UntypedFormControl('', []),
      aggregateOn: new UntypedFormControl('', []),
      aggregateFunction: new UntypedFormControl('', []),
      partionOn: new UntypedFormControl('', []),
      orderBy: new UntypedFormControl('', []),
      columnAlias: new UntypedFormControl('', []),


    });
  }

  toggletextbox() {
    this.selectedValue = !this.selectedValue;
  }

  ngOnInit() {

    this.linkservice.fetchUserRole(this.localStorageSettings.getSettings("dnsName"), this.localStorageSettings.getSettings("AuthUsername")).subscribe(res => {
      console.log(res);
      this.responserequest = res;
    });
    this.retrieveLookupValuebyLookupType("RollupSeparator");
    // this.setDefaultSeparator();
    /* modified by Chandra R
       *  calling the Userroles method to assign the rolenames for IDs in gride
       *  30-06-2024
    */
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    this.retrieveScreenAccess.find(screenPath);
    this.linkservice.screenoperationspermission(screenPath, this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      // const buttonIdList: number[] = [];
      let responsedata: any;
      responsedata = res;
      for (let i = 0; i < responsedata.length; i++) {

        this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
      }
      this.buttonIdList.push('screen');
      console.log('Button ID List:', this.buttonIdList);
      console.log("Button inside grid rendered");
      const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
      console.log("Found buttons:", buttons.length);
      buttons.forEach(button => {
        const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
        if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
          if (!this.buttonIdList.includes(buttonId)) {
            button.setAttribute('disabled', 'true'); // Disable the button
          } else {
            button.removeAttribute('disabled'); // Enable the button
          }
        }
      });
      
    });

this.service.retrieveLookupValuebyLookupType("DataSetOutputFormat").subscribe(response => {
    console.log('Dataset Output Formats:', response);
    if (response && response.length > 0) {
      this.datasetOutputTypes = response.map(lookup => ({
        name: lookup.lookupcode,  // Adjust property names based on your API response
        value: lookup.lookupvalue
      }));
    }
  });
    this.Useroles();
    this.formValidWhere = this.fb.group({
      fieldsWhere: '',
      conditionalOperatorWhere: '',
      enterValueWhere: '',
      fieldsOrderBy: '',
      arrangeOrderBy: '',
      //  fieldsAggredateBy: '',
      //  arrangeaggregateBy: '',
      multiselect: '',
      aggregateOn: '',
      aggregateFunction: '',
      partionOn: '',
      orderBy: '',
      columnAlias: '',
      conditionalValue: '',
      //groupBy:'',
      pivotType: [''],
  pivotColumn: [''],
  caseColumn: [''],
  childColumns: [[]],
  headersToNull: [[]],
  orderByColumn: [[]],
  parentcolumns: [[]],
  headerValueColumn: [''],
  pivotAlias: [''],
  distinctCount: [''],
  grandTotalGroupby: ['']


    });

    this.transformationFormGroup = this.fb.group({
      transformationObject: '',
      transformationAttribute: '',
      transformationReference: '',
      transformationSql: '',
    });

    this.formValidAttributes = this.fb.group({
      datasetNameone: "",
      attributes: "",
      constant: "",
      datasetNametwo: "",
      attributestwo: "",
      recordFilter: '',
      selectedChildDataSet: '',
      recordConditionalOperatorWhere: '',
      recordMultiselect: '',
      fieldsWhere: '',
      conditionalOperatorWhere: '',
      enterValueWhere: '',
      fieldsOrderBy: '',
      arrangeOrderBy: '',
      // fieldsAggredateBy: '',
      // arrangeaggregateBy: '',
      multiselect: '',
      logicalOperatorWhere: '',
      objectWhere: '',
      objectOrderBy: '',
      //objectAggregateBy: '',
      rollupExclusion: '',
      aggregateOn: '',
      aggregateFunction: '',
      partionOn: '',
      orderBy: '',
      columnAlias: '',
      conditionalValue: '',
      rollupSeparator:','

    });

    this.datasetForm = this.fb.group({
      name: '',
      type: '',
      details: '',
      accesstype: ''
    })

    this.validations_form = this.fb.group({
      selectdataSet: '',
      // reporttemplatename: '',
      // details: '',
      type: '',
      dataLakeType: '',
      objectGroup: '',
      description: '',
      datasetOutputFormat: '', // Add this

      // accesstype: '',
      // vaultDocumentType:'',
      // documentsubtype:'',
      // vaultClasification:'',
      // vaultTemplate:'',
      // vaultbinderTemplate:''
    });

    this.columnFilterFormGroup = this.fb.group({
      columnObject: '',
      columnAttribute: '',
      columnObjectList: '',
      columnObjectAttributes: '',
      columnLogicalOperatorWhere: '',
      columnTextfield: '',
      columnDatefield: '',
      columnMultiSelect: '',
      // objectOrderBy: new UntypedFormControl('', []),
      // objectAggregateBy: new UntypedFormControl('', []),
      // multiselect: new UntypedFormControl('', []),

    });
    this.formValidHeaderType = this.fb.group({
      headerKeyAlias: "",
      headerKeyType: "",

    });
    this.formValidationsWhere();
    this.formValidationsPivotType();
    // this.butttonname = "Save";
    this.formValidation();

    this.formulaFieldsValidation();
    this.validateColumnFilterFormGroup();
    this.datasetFormValidation();
    this.lookupVaultGroup();

    this.butttonname = "Create Dataset";

    this.columnDefsForObjects = [
      {
        headerName: " Objects",
        headerTooltip: "Objects",
        tooltipValueGetter: params => "Vault Objects : " + params.value,
        field: "objectlabel",
        filter: "agTextColumnFilter",
        width: 400,
        headerClass: 'headerClassName'
      }
    ];

    this.columnDefsForTablesFields = [
      {
        headerName: "Attributes ",
        headerTooltip: "Attributes",
        tooltipValueGetter: params => "Attributes : " + params.value,
        field: "label",
        filter: "agTextColumnFilter",
        width: 400,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" }
      }
    ];

    this.columnDefsForSelectedFields = [
      {
        headerName: "Selected Attributes",
        tooltipValueGetter: params => "Selected Attributes : " + params.value,
        field: "attributeNameWithFields",
        filter: "agTextColumnFilter",
        width: 400,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" },
        editable: true,
        rowDrag: true
      }
    ];

    this.sortingOrder = ["asc", "desc", null]

    /**
     * modified by Ashwin M
     * 28/02/2024
     * code modified to add refresh dataset request to dataset grid to generate datasets on demand
    */
    this.columnDefs = [
      {
        headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
        pinned: 'left',
        lockPinned: true,
        cellRendererParams: {
          values: this.buttonIdList,
          refreshDataset: this.refreshDataset.bind(this),
          edit: this.EditIcon.bind(this),
          delete: this.deleteIcon.bind(this),
          access: this.access_permission.bind(this),
          redirecttoQuickSight: this.analysis.bind(this),
          copyDatasetandupdate: this.copyDatasetandupdate.bind(this),
          copyDataset: this.copyDataset.bind(this)
        }, width: 300

      },

      { headerName: 'Dataset Name', headerTooltip: 'Dataset Name', tooltipValueGetter: (params) => 'Dataset Name : ' + params.value, field: 'datasetname', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Dataset Creation Status', headerTooltip: 'Dataset Creation Status', tooltipValueGetter: (params) => 'Dataset Creation Status : ' + params.value, field: 'generationStatus', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Description', headerTooltip: 'Description', tooltipValueGetter: (params) => 'Description : ' + params.value, field: 'description', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Type', headerTooltip: 'Type', tooltipValueGetter: (params) => 'Type : ' + params.value, field: 'type', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Auto Refresh', headerTooltip: 'Auto Refresh', 
        tooltipValueGetter: (params) => {
          const val = params.value === "false" ? 'No' : 'Yes';
          return 'Auto Refresh : ' + val;
        }, field: 'autoRefreshDataset', filter: 'agTextColumnFilter', width: 150, 
        valueFormatter: (params) => {
          console.log('Auto Refresh - Value:', params.value, '| Type:', typeof params.value);
          return params.value === "false" ? 'No' : 'Yes';
        },
      },
      { headerName: 'Columns', headerTooltip: 'Columns', tooltipValueGetter: (params) => 'Columns : ' + params.value, field: 'columns', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Concatenation', headerTooltip: 'Concatenation', tooltipValueGetter: (params) => 'Concatenation : ' + params.value, field: 'concatination', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Transformation', headerTooltip: 'Transformation', tooltipValueGetter: (params) => 'Transformation : ' + params.value, field: 'transformation', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Rollingup', headerTooltip: 'Rollingup', tooltipValueGetter: (params) => 'Rollingup : ' + params.value, field: 'rollingUp', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Rollup Exclusion Object', headerTooltip: 'Rollup Exclusion Object', tooltipValueGetter: (params) => 'Rollup Exclusion Object : ' + params.value, field: 'rollupExclusionObjects', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Column Filters', headerTooltip: 'Column Filters', tooltipValueGetter: (params) => 'Column Filters : ' + params.value, field: 'columnFilters', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Inclusion Filters', headerTooltip: 'Inclusion Filters', tooltipValueGetter: (params) => 'Filters : ' + params.value, field: 'filters', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Sorting', headerTooltip: 'Sorting', tooltipValueGetter: (params) => 'Sorting : ' + params.value, field: 'sorting', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Aggregate', headerTooltip: 'Aggregate', tooltipValueGetter: (params) => 'Aggregate : ' + params.value, field: 'aggregate', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Calculated Fields', headerTooltip: 'Calculated Fields', tooltipValueGetter: (params) => 'Calculated Fields : ' + params.value, field: 'calculatedfields', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'OwnerRoleName', headerTooltip: 'OwnerRoleName', tooltipValueGetter: (params) => 'OwnerRoleName : ' + params.value, field: 'dataset_ownerRoleid', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'DatasetAccessType', headerTooltip: 'DatasetAccessType', tooltipValueGetter: (params) => 'DatasetAccessType : ' + params.value, field: 'datasetAccessType', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Associated Roles', headerTooltip: 'Associated Roles', tooltipValueGetter: (params) => 'Associated Roles : ' + params.value, field: 'dataset_rolesIdStrings', filter: 'agTextColumnFilter', width: 150 },

      {
        headerName: 'Download Generated Template',
        headerTooltip: 'Download Generated Template',
        cellRenderer: FiledownloadComponent,
        cellRendererParams: {
          docdownload: this.downloadDataset.bind(this,"excelTemplate")
        },
        width: 250
      },
      {
        headerName: 'Download Word Template',
        headerTooltip: 'Download Word Template',
        cellRenderer: FiledownloadComponent,
        cellRendererParams: {
          docdownload: this.downloadDataset.bind(this,"wordTemplate")
        },
        width: 250
      },
      {
        headerName: 'Download Word-Configuration Template',
        headerTooltip: 'Download Word-Configuration Template',
        cellRenderer: FiledownloadComponent,
        cellRendererParams: {
          docdownload: this.downloadDataset.bind(this,"excelConfig")
        },
        width: 300
      },
      { headerName: 'Status', headerTooltip: 'Status', tooltipValueGetter: (params) => 'Status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Created By', headerTooltip: 'Created By', tooltipValueGetter: (params) => 'Created By : ' + params.value, field: 'createdBy', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Created DateAndTime', headerTooltip: 'Created DateAndTime', tooltipValueGetter: (params) => 'Created DateAndTime : ' + params.value, field: 'createdDateAndTime', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Modified By', headerTooltip: 'Modified By', tooltipValueGetter: (params) => 'Modified By : ' + params.value, field: 'lastmodifiedBy', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Modified DateAndTime', headerTooltip: 'Modified DateAndTime', tooltipValueGetter: (params) => 'Modified DateAndTime : ' + params.value, field: 'lastModifiedDateAndTime', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Dataset Refreshed DateAndTime', headerTooltip: 'Dataset Refreshed DateAndTime', tooltipValueGetter: (params) => 'Dataset Refreshed DateAndTime : ' + params.value, field: 'datasetRefreshDateTime', filter: 'agTextColumnFilter', width: 150 },

    ]
    // if the record has status==no , row color will change
    this.rowClassRules = {
      "sick": function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },

    };
    this.getRowStyle = (params: any) => {
      console.log(params)
      console.log(params.data.status)
      if (params.data.status === 'No') {
        return { backgroundColor: 'rgb(211, 211, 211)' }; // Inline style for deleted rows
      }
      // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
    };
    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.rowSelectionForTablesFields = 'multiple';
    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };


    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    



  }









  //excel export function
  onBtExport() {
    this.rowbindingdata.api.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.rowbindingdata.api) {
      this.lastpage = this.rowbindingdata.api.paginationIsLastPageFound();
      this.currentpage = this.rowbindingdata.api.paginationGetCurrentPage() + 1
      this.nextpage = this.rowbindingdata.api.paginationGetCurrentPage() + 1 + 1
      this.nextpageplusone = this.rowbindingdata.api.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalpages = this.rowbindingdata.api.paginationGetTotalPages()
    }
  }
  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.rowbindingdata.api.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    var value = this.pagesize
    this.rowbindingdata.api.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.rowbindingdata.api.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.rowbindingdata.api.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    console.log("first")
    this.rowbindingdata.api.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    console.log("last")
    this.rowbindingdata.api.paginationGoToLastPage();
  }
  //pagination code ends

  refreshRun() {
    console.log("Inside the refreshmethod");
    this.spinner.start();
    this.onGridReady(this.rowbindingdata);
    this.spinner.stop();
  }

  onGridReady(params) {
    this.rowbindingdata = params;
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    console.log(params.columnApi)
    console.log(this.localStorageSettings.getSettings("AuthUsername") + "--------" + this.localStorageSettings.getSettings("dnsName") + "-----" + this.localStorageSettings.getSettings("UserId"))
    this.linkservice.retrievereport(this.localStorageSettings.getSettings("UserId"), this.localStorageSettings.getSettings("dnsName"), this.localStorageSettings.getSettings("AuthUsername")).subscribe(response => {
      this.spinner.start();
      console.log(response);
      // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.rowbindingdata.setGridOption('rowData', [])

      } else {
        // below code added for dispaly associated roles of Dataset in the Grid
        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        for (let i = 0; i < this.getdata.length; i++) {
          let stringValues = "";
          if (this.getdata[i].dataset_rolesIds) {
            let subString = this.getdata[i].dataset_rolesIds.split(",");
            console.log(subString);
            for (let j = 0; j < subString.length; j++) {
              console.log(this.UserRolesWithRoleId);
              for (let k = 0; k < this.UserRolesWithRoleId.length; k++) {
                console.log(this.UserRolesWithRoleId[k][0]);
                if (this.UserRolesWithRoleId[k][0] == subString[j]) {
                  if (stringValues.length == 0) {
                    stringValues = this.UserRolesWithRoleId[k][1]
                    break;
                  } else {
                    stringValues = stringValues + "," + this.UserRolesWithRoleId[k][1]
                    break;
                  }

                }
              }
            }
            this.getdata[i]["dataset_rolesIdStrings"] = stringValues
          }
        }
        this.rowbindingdata.api.setGridOption('rowData', this.getdata)

      }
      this.spinner.stop();
    });
  }

  lookupVaultGroup() {
    // this.linkservice.retrevegroupvalues().subscribe(res => {
    //   console.log(res)
    // this.vaultGroup = res
    //   console.log("++++++++++++++++++++++++++++++++++++++++++");

    // });
    this.vaultObjectService.retrieveAllObjectGroupForDataset(this.localStorageSettings.getSettings("dnsName")).subscribe(res => {
      this.vaultGroup = res;
      console.log(res);
      this.spinner.stop();
    })

    this.vaultObjectService.retrieveDatasetGroup().subscribe(res => {

      this.datasetGroups = res;
      //this.vaultGroup=res;
      console.log(res);
      this.spinner.stop();
    })
  }

  valutGroupcheck(e) {
    console.log(e.value)
    this.onGridReadyForObjects(this.ObjectGrid, e.value)
    // console.log(e)
  }

  onGridReadyForObjects(params, vaultgroup) {
    this.ObjectGrid = params;
    if (vaultgroup === undefined) {
      this.ObjectGrid.api.setGridOption('rowData', []);
      this.paramstemp.api.setGridOption('rowData', []);
    } else if (this.objectGroup === true) {
      this.service.retrieveObjectGroupObject(vaultgroup).subscribe((res) => {
        console.log("--------------" + vaultgroup);
        this.spinner.start();

        console.log(res);

        // checking if response is true or not
        if (res.error === true) {
          this.spinner.stop();

          this.snackbar.open(res.message, "OK", { duration: 5000 });

          this.ObjectGrid.api.setGridOption('rowData', []);
        } else {

          this.ObjectsData = res;
          console.log(res)
          this.ObjectGrid.api.setGridOption('rowData', res);
          this.paramstemp.api.setGridOption('rowData', []);
          this.spinner.stop();
        }
      });
    } else {
      this.spinner.start();
      this.service.retrieveDatasetObjects(vaultgroup).subscribe(res => {
        console.log(res)
        // checking if response is true or not
        if (res.error === true) {
          this.spinner.stop();

          this.snackbar.open(res.message, "OK", { duration: 5000 });

          this.ObjectGrid.api.setGridOption('rowData', []);
        } else {

          this.ObjectsData = res;
          console.log(res)
          let response = JSON.parse(JSON.stringify(res));

          const keys = Object.keys(res);
          const objects = keys.map(key => ({ objectlabel: key, value: JSON.parse(response[key][0]) }));
          objects.sort((a, b) => a.objectlabel.localeCompare(b.objectlabel));
          console.log(objects)


          this.ObjectGrid.api.setGridOption('rowData', objects);
          this.paramstemp.api.setGridOption('rowData', []);
          this.spinner.stop();
        }
      })
    }
  }

  onGridReadyForTablesFields(params, tableName, objectName) {
    this.tableFields = [];
    this.fieldsData = [];
    this.selectedFieldsData = [];
    this.paramstemp = params;
    console.log(tableName)
    console.log(params)
    if (tableName === undefined) {
      this.paramstemp.api.setGridOption('rowData', []);
    } else {
      if (this.objectGroup) {
        this.tablefields = JSON.parse(tableName.attributeNameAndFields);
      } else {
        this.tablefields = tableName;
      }
      let constant = {
        "attributeNameWithFields": "Constant String",
        "isControlledVocabulary": null,
        "label": "Constant String",
        "list_column": true,
        "max_type_value": null,
        "min_type_value": null,
        "name": "Constant String",
        "required": false,
        "tempfieldindex": 1000001,
        "type": "__constant",
        "type_value": ""
      }
      /**
       * Modified By Ravi G
       * 23/01/2023
       * Made attributes name unique by adding name field after label name
       */
      if (this.objectGroup) {
        this.tablefields.forEach(fields => {
          fields.tempfieldindex = this.tablefields.indexOf(fields)
          // console.log(fields);
          fields.label = fields.label + " (" + fields.name + ")";
          fields.attributeNameWithFields = objectName + " " + fields.label;
        })
        let tempTableFields = this.tablefields;
        this.tablefields = [];
        this.tablefields.push(constant);
        console.log(tempTableFields)
        console.log(this.tablefields)
        tempTableFields.forEach(tableField => {
          this.tablefields.push(tableField);
        })
        console.log(this.tablefields)
        this.tablefields.forEach(object => {
          if (object.type != "__constant") {
            this.filterData.push(object)
          }
        });
        console.log(this.filterData);
      }
      console.log(this.tablefields)
      let objectAttributes;
      this.gridApiForTablesFields = params;
      this.paramstemp.api.setGridOption('rowData', this.tablefields);
      //this.selectedTableFields.api.setGridOption('rowData', []);
    }
    //this.gridApiForTablesFields.setGridOption('rowData', res);

    //this.gridApiForTablesFields = params.api;

  }

  onGridReadyForWhere(params) {

    this.gridApiForWhere = params.api;

    if (this.whereAgGrid.length == 0) {

      params.api.setGridOption('rowData', []);

    }

    else {

      this.gridApiForWhere.setGridOption('rowData', this.whereAgGrid);

    }

  }

  onGridReadyForAggregate(params) {

    this.gridApiForAggregate = params.api;

    if (this.aggregateAgGrid.length == 0) {

      params.api.setGridOption('rowData', []);

    }

    else {

      this.gridApiForAggregate.setGridOption('rowData', this.aggregateAgGrid);

    }

  }

  onGridReadyForOrderBy(params) {

    this.gridApiForOrderBy = params.api;

    if (this.orderByAgGrid.length == 0) {

      params.api.setGridOption('rowData', []);

    }

    else {

      this.gridApiForOrderBy.setGridOption('rowData', this.orderByAgGrid);

    }

  }

  onGridReadyForSelectedTableFields(params, tableName) {
    console.log(tableName)
    console.log(params)
    this.selectedTableFields = params
    this.gridColumnApi = params.columnApi
    //this.gridApiForTablesFields = params.api;
    console.log('Before setRowData:', tableName);
    this.selectedTableFields.api.setGridOption('rowData', tableName);
    console.log('After setRowData:', tableName);
    //tableName.columnApi.getColumn('attributeNameWithFields').rowDrag = true;
    //this.whereKey(tableName)
    //this.sortingKey(tableName)
    //this.aggregateKey(tableName)
    //this.fieldsData = this.selectedTableFields.api.getSelectedRows();

  }

  cellClickedObjects(e) {

    console.log(e)

    console.log(e.value);
    if (this.objectGroup) {
      this.service.retrieveTablesFieldsForDataset(e.data.id).subscribe(res => {

        this.spinner.start();

        console.log(res);

        // checking if response is true or not
        if (res.error === true) {

          this.spinner.stop();

          this.snackbar.open(res.message, "OK", { duration: 5000 });

          this.allFields = [];

          this.selectedFieldsData = [];

          this.gridApiForTablesFields.setGridOption('rowData', []);

        } else {

          this.spinner.stop();
          console.log(e)
          this.allFields = res[0];

          this.selectedObject = e.value;
          this.selectedObjectName = e.data.objectname;
          console.log("+++++++++++++++++++++  " + this.selectedObjectName)
          // if(this.reportCreationData.datasetObjectname === ""){
          //   this.reportCreationData.datasetObjectname = e.value;
          // }else{
          // this.reportCreationData.datasetObjectname = this.reportCreationData.datasetObjectname+","+ e.value;
          // }

          this.selectObjectId = e.data.id;

          console.log(this.selectedObject)
          this.onGridReadyForTablesFields(this.paramstemp, this.allFields, e.value)

          this.columnDefsForReportingConfiguration = [];

        }

      });
    } else {
      console.log(e)
      //console.log(type)
      console.log(this.datasetIdToRetrieveObjectsdata)
      if (this.datasetIdToRetrieveObjectsdata != undefined) {
        this.service.retrieveDatasetObjects(this.datasetIdToRetrieveObjectsdata).subscribe(res => {
          console.log(res)
          // checking if response is true or not
          if (res.error === true) {
            this.spinner.stop();
            this.snackbar.open(res.message, "OK", { duration: 5000 });
            this.ObjectGrid.api.setGridOption('rowData', []);
          } else {
            this.ObjectsData = res;
            console.log(res)
          }
        })
      }

      this.selectedObject = e.value;
      this.selectedObjectName = e.data.value.object;
      console.log("+++++++++++++++++++++  " + this.selectedObjectName)
      this.tempObjectsData = this.ObjectsData
      console.log(this.tempObjectsData + "=========================000000")
      console.log(this.ObjectsData)
      console.log(this.selectedObject)
      console.log(this.ObjectsData[this.selectedObject]);
      this.objectAttributes = this.ObjectsData[this.selectedObject];
      console.log(typeof (this.objectAttributes[0]))
      console.log((this.objectAttributes))
      if (typeof (this.objectAttributes[0]) == "string") {
        for (let i = 0; i < this.objectAttributes.length; i++) {
          this.objectAttributes[i] = JSON.parse(this.objectAttributes[i]);
        }
      }

      this.ObjectsData = this.objectAttributes
      this.allFields = this.objectAttributes;
      this.onGridReadyForTablesFields(
        this.paramstemp,
        this.allFields,
        e.value
      );
      this.ObjectsData = this.tempObjectsData

    }
  }


  whereKey(event) {
    this.filterData = []
    console.log(this.filterObjects);
    // this.wherefields=event
    // console.log(this.wherefields)
    this.whereData.fieldsWhere = "";
    var tempColumnData = this.columns;
    var filterAttributes = [];
    var objectName = "";
    this.filterObjects.forEach((object) => {
      console.log(object.object, ",", event.value);
      if (object.object === event.value) {
        objectName = object.object;
      }
    })
    console.log(objectName);
    tempColumnData.forEach((object) => {
      if (object.object === objectName && object.type != "" && !object.type.includes(",") && object.type != "__constant") {
        console.log(object);
        filterAttributes.push(object)
      }
    })
    this.filterData = filterAttributes;
    this.service.retrieveMultiselect(this.localStorageSettings.getSettings("vaultDnsname"), this.reportCreationData.objectGroup, "Keys").subscribe(response => {
      if (response != null) {
        console.log(response);
        this.multiSelectKeyAttributes = response;
        console.log(this.multiSelectKeyAttributes);
      }
    });
  }

  sortingKey(fields) {

    this.sortingfields = fields
    console.log(this.sortingfields)
    this.orderByData.fieldsOrderBy = "";
  }


  // aggregateKey(fields) {

  //   this.aggregatefields = fields
  //   console.log(this.aggregatefields)
  //   this.aggregateByData.fieldsAggregateBy = "";
  // }

  cancel() {
    this.transformation = []
    this.concatination = []
    this.rollingUp = []
    this.groupconcattemp = []
    this.rollupExclusionObjects = []
    this.columns = []
    this.butttonname = "Create Dataset"
    this.temp = [];
    this.filterObjects = [];
    this.rollingUp = [];
    this.fieldsDataToRemove = [];
    this.selectedObjectsData = []
    this.selectedFieldsDatatemp = [];
    this.selectedFieldsDataToPush = [];
    this.selectedFieldsData = [];
    console.log(this.show)
    this.ObjectGrid.api.setGridOption('rowData', []);
    this.paramstemp.api.setGridOption('rowData', []);
    this.tablefields = [];
    this.selectedTableFields.api.setGridOption('rowData', []);
    this.columnDefsForReportingConfiguration = [];
    this.headersTypeArr = [];
    this.datasetOutputFormat = ''; // Reset the new field


    /**
     * modified by Ashwin M
     * 28/02/2024
     * code modified to reset refresh dataset flag in dataset creation request object
    */
   /**
     * modified by Prasanna Jeebi
     * 30/06/2025
     * Added the field in reportCreationData as datasetRefreshDateTime
    */
    this.reportCreationData = {
      datasetname: "",
      datasetObjectname: "",
      datasetobjectattributes: [],
      type: "",
      datalakeType: "",
      description: "",
      objectGroup: "",
      filters: [],
      sorting: [],
      aggregate: [],
      columns: [],
      concatination: [],
      rollingUp: [],
      rollupExclusionObjects: [],
      transformation: [],
      columnFilters: [],
      generateDefaultTemplate: "",
      autoRefreshDataset: "",
      datasetAccessType: "",
      dataset_rolesIds: "",
      createdBy: "",
      createdDateAndTime: "",
      datasetRefreshDateTime: "",
      headersType: [],
      pivotAggregation:[],
      datasetOutputFormat: '' // Reset the new field

    }
    this.where = [];
    this.groupBy = [];

    this.orderBy = [];

    this.fieldsData = [];

    this.aggregateBy = [];
    this.pivotAggregateBy=[];
    this.aggregateArray = [];
    this.showRollingUp = false;
    this.showTransform = false;
    this.showOrderBy = false;
    this.showFilters = false;
    this.showFilter = false;
    this.show = false;
    this.orderByShow = false;
    this.aggreageShow = false;
    this.dateChange = false;
    this.expand = false;
    this.showColumnFilter = false;
    this.showPivotAggregate=false;
    /**
     * modified by Ashwin M
     * 28/02/2024
     * code modified to reset refresh dataset flag
    */
    this.autoRefreshDataset = false;
    this.generateDefaultTemplate = true;
    this.formValidationsWhere();
    // this.butttonname = "Save";
    this.formValidation();
    this.formValidationsRollingUp();
    this.formulaFieldsValidation();
    this.datasetFormValidation();
    this.formValidationForTranformation();
    this.validateColumnFilterFormGroup();
    this.formValidHeaderType.reset();
    this.formValidationsPivotType();
    this.formValidationsHeaderType();

    this.columnFilter = [];
    this.headersTypeArr = [];
    this.headerTypeObj = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" };
    this.columnFilterData = { "name": "", "object": "", "alias": "", "filters": [] };
    this.columnFilterDataObject = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };
    this.rollingupdata = { "parentObjectName": "", "parentattribute": "", "childObjectName": "", "childattributes": "", "parentAttributesalias": "", "childAttributesalias": "", "rollupColumnAlias": "", "rollingUpLevel": "1","rollupseprator":"" };
    this.orderByData = { "objectOrderBy": "", "fieldsOrderBy": "", "arrangeOrderBy": "" };
    this.whereData = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };
    this.recordfilterData = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };
    this.transformationObjectData = { "object": "", "attribute": "", "alias":"", "referenceObjects": "", "sql": "" };
    this.finalReportCreation = {
      "datasets": [
        {
          "name": "",
          "datasetType": "",
          "columns": []
        }
      ],
      "reports": []
    }
    // set the bydefault value of rollup separator as comma
    this.formValidAttributes.get('rollupSeparator')?.setValue(",");
    this.rollingupdata.rollupseprator=",";
  }

  openSaveForm() {
    this.expand = true
    this.show = true
    this.ClearData()
  }


  // reportConfigurationRun() {

  //   console.log(this.columnNames);

  //   console.log(this.rowsData);

  //   var columnsDefsAnother = [];

  //   for (var i = 0; i < this.columnNames.length; i++) {
  //     columnsDefsAnother.push({
  //       headerName: this.columnNames[i],
  //       headerTooltip: this.columnNames[i],
  //       tooltipValueGetter: params => params.value,
  //       field: this.columnNames[i],
  //       filter: 'agTextColumnFilter',
  //       width: 150
  //     });
  //   }

  //   //Array to bind data to ag-grid.
  //   this.columnDefsForReportingConfiguration = columnsDefsAnother;

  //   this.gridApiForReportingConfiguration.setGridOption('rowData', []);

  //   this.gridApiForReportingConfiguration.setGridOption('rowData', this.rowsData);

  // }



  //Excel export function.

  reportConfigurationRun() {

    //this.columnNames = this.data.columnNames;

    console.log(this.columnNames);

    console.log(this.rowsData);

    var columnsDefsAnother = [];

    for (var i = 0; i < this.columnNames.length; i++) {
      columnsDefsAnother.push({
        headerName: this.columnNames[i],
        headerTooltip: this.columnNames[i],
        tooltipValueGetter: params => params.value,
        field: this.columnNames[i],
        filter: 'agTextColumnFilter',
        width: 150
      });
    }
    console.log(this.xKeydata)
    console.log(this.ykeydata)
    //   this.options = {
    //     data: this.rowsData,
    //     padding: {
    //       top: 40,
    //       right: 40,
    //       bottom: 40,
    //       left: 40,
    //     },
    //     series: [{
    //         type: 'column',
    //         xKey: this.xKeydata,
    //         yKeys: this.ykeydata,
    //         grouped: true,
    //         label: {},
    //         strokeWidth: 0,
    //     }],
    //     legend: {
    //       spacing: 40,
    //     },
    // };

    //Array to bind data to ag-grid.
    this.columnDefsForReportingConfiguration = columnsDefsAnother;

    this.gridApiForReportingConfiguration.setGridOption('rowData', []);

    this.gridApiForReportingConfiguration.setGridOption('rowData', this.rowsData);


  }

  modifingCharts() {
    let xAxis2;
    let yAxis2;
    let data: any = [];
    this.xdata = [];
    console.log(this.rowsData)
    console.log(this.xKeydata)
    console.log(this.ykeydata)
    for (let i = 0; i <= this.rowsData.length - 1; i++) {
      let xdummy = "";
      let ydummy = "";
      console.log(Object.keys(this.rowsData[i]))
      console.log(Object.values(this.rowsData[i]))
      for (let j = 0; j <= this.xKeydata.length - 1; j++) {
        if (Object.keys(this.rowsData[i]).includes(this.xKeydata[j])) {
          this.xAxis1 = this.rowsData[i]
          xAxis2 = this.xKeydata[j]
          if (xdummy == "") {
            xdummy = this.xAxis1[xAxis2];
          } else {
            xdummy = xdummy + "," + this.xAxis1[xAxis2];
          }
        }
      }
      for (let y = 0; y <= this.ykeydata.length - 1; y++) {
        if (Object.keys(this.rowsData[i]).includes(this.ykeydata[y])) {
          this.yAxis1 = this.rowsData[i]
          yAxis2 = this.ykeydata[y]
          ydummy = this.yAxis1[yAxis2];

        }
        let tempData = { "xAxis": xdummy, "yAxis": ydummy };

        this.xdata.push(tempData);
        console.log(this.xdata)
      }



    }
    this.xdummydata = "";
  }

  pieChart() {
    this.modifingCharts()
    console.log(this.ykeydata.length)
    this.pieChartData = !this.pieChartData
    if (this.pieChartData == false) {
      this.showgridData = true;
    } else {
      this.showgridData = false;
    }
    this.barChartData = false;
    if (this.ykeydata.length > 1) {
      this.showgridData = true;
      this.pieChartData = !this.pieChartData
      this.snackbar.open("Pie chart not available", "OK", { duration: 5000 })
    } else {
      this.options = {
        data: this.xdata,
        series: [{
          type: 'pie',
          labelKey: ['xAxis'],
          angleKey: ['yAxis'],
          angleNames: [this.ykeydata]
        }],
        legend: {
          position: 'bottom',
        },
      };
    }
  }

  // onExport() {
  //   this.gridApiForReportingConfiguration.exportDataAsCsv();
  // }

  // //Pagination code.
  // onPaginationChanged() {
  //   if (this.gridApiForReportingConfiguration) {
  //     this.lastPage = this.gridApiForReportingConfiguration.paginationIsLastPageFound();
  //     this.currentPage = this.gridApiForReportingConfiguration.paginationGetCurrentPage() + 1;
  //     this.nextPage = this.gridApiForReportingConfiguration.paginationGetCurrentPage() + 1 + 1;
  //     this.nextPagePlusOne = this.gridApiForReportingConfiguration.paginationGetCurrentPage() + 1 + 1 + 1;
  //     this.totalPages = this.gridApiForReportingConfiguration.paginationGetTotalPages();
  //   }
  // }

  // //Below function is to load the ag-grid.
  // onGridReadyForReportingConfiguration(params) {

  //   this.gridApiForReportingConfiguration = params.api;

  //   // params.api.setGridOption('rowData', this.rowsData);

  // }

  // //this function is for going to the given page number.
  // onSearchChange(searchValue: number) {
  //   this.gridApiForReportingConfiguration.paginationGoToPage(searchValue - 1);
  // }

  // //Below function is for changing the no of rows per page.
  // onPageSizeChanged() {
  //   var value = this.pageSize;
  //   this.gridApiForReportingConfiguration.setGridOption('paginationPageSize', Number(value));
  // }

  // //Below function is for going to next page.
  // onNext() {
  //   this.gridApiForReportingConfiguration.paginationGoToNextPage();
  // }

  // //Below function is for going to previous page.
  // onPrevious() {
  //   this.gridApiForReportingConfiguration.paginationGoToPreviousPage();
  // }

  // //Below function is for going to first page.
  // onFirst() {
  //   this.gridApiForReportingConfiguration.paginationGoToFirstPage();
  // }

  // //Below function is for going to last page.
  // onLast() {
  //   this.gridApiForReportingConfiguration.paginationGoToLastPage();
  // }

  cellClickedFields(e) {
    console.log(e)
  }

  onselection(params) {
    console.log(params)
  }

  onRowSelected(event) {
    console.log(this.paramstemp)
    console.log(this.paramstemp.api.getSelectedRows())
    this.fieldsData = this.paramstemp.api.getSelectedRows();

    console.log(this.fieldsData)

    this.selectedFieldsData = this.fieldsData;

    console.log(this.selectedFieldsData);


  }


  connect() {

    console.log(this.whereData);

    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {

      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.whereData);

      this.formFieldsTrimer.clean(this.whereData);

    }

  }

  addRollingup() {
    if (!this.formValidAttributes.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidAttributes);

      this.validation.getvalidationmessage();

    } else {
      this.onRollupAliasChange(this.rollingupdata.rollupColumnAlias);
      /**
       * Modified by Ashiwn M
       * 22/02/2023
       * modified child object attributes
       */
      if (this.rollingupdata.parentObjectName === undefined || this.rollingupdata.childObjectName === undefined ||
        this.rollingupdata.rollupColumnAlias === undefined || this.rollingupdata.rollupColumnAlias === "") {
        this.snackbar.open("Not a valid Rolling Up", "OK", { duration: 5000 });
        return;
      } else if (this.rollingupdata.parentObjectName === "" || this.rollingupdata.childObjectName === "" ||
        this.rollingupdata.rollupColumnAlias === "" || this.rollingupdata.childattributes === "") {
        this.snackbar.open("Not a valid Rolling Up", "OK", { duration: 5000 });
        return;
      } else if(this.rollingupdata.rollupseprator==="" || this.rollingupdata.rollupseprator===undefined ){
        this.snackbar.open("Please provide Rollup Separator", "OK", { duration: 5000 });
        return;
      }
       else {
        console.log(this.rollingupdata)
        this.formFieldsTrimer.trimFormfieldsData(this.rollingupdata);
        this.formFieldsTrimer.clean(this.rollingupdata);
        this.selectedTableFields.api.forEachNode((rowNode, index) => {
          console.log(rowNode.data);
          console.log(index);
        });
        /**
         * Modified by Ashwin M
         * 13/03/2023
         * Modified to remove "." from the json object feilds
         */
        this.rollingupdata.parentObjectName = this.replaceCharecter(this.rollingupdata.parentObjectName, this.constants.charecterDot, this.constants.charecterUnderScore);
        this.rollingupdata.parentattribute = this.replaceCharecter(this.rollingupdata.parentattribute, this.constants.charecterDot, this.constants.charecterUnderScore);
        this.rollingupdata.childObjectName = this.replaceCharecter(this.rollingupdata.childObjectName, this.constants.charecterDot, this.constants.charecterUnderScore);
        this.rollingupdata.childattributes = this.replaceCharecter(this.rollingupdata.childattributes, this.constants.charecterDot, this.constants.charecterUnderScore);
        this.rollingupdata.parentAttributesalias = this.replaceCharecter(this.rollingupdata.parentAttributesalias, this.constants.charecterDot, this.constants.charecterUnderScore);
        this.rollingupdata.childAttributesalias = this.replaceCharecter(this.rollingupdata.childAttributesalias, this.constants.charecterDot, this.constants.charecterUnderScore);
        let tempRolling = {
          "parentObjectName": this.rollingupdata.parentObjectName,
          "parentattribute": this.rollingupdata.parentattribute, "childObjectName": this.rollingupdata.childObjectName,
          "childattributes": this.rollingupdata.childattributes, "parentAttributesalias": this.rollingupdata.parentAttributesalias,
          "childAttributesalias": this.rollingupdata.childAttributesalias, "rollupColumnAlias": this.rollingupdata.rollupColumnAlias, "rollingUpLevel": "1", "filters": this.recordWhere,"rollupseprator":this.rollingupdata.rollupseprator
        }
        /**
       * Modified by Ashiwn M
       * 22/02/2023
       * added rollup column alias
       */
        if (this.rollingupdata.rollupColumnAlias === "") {
          tempRolling.rollupColumnAlias = tempRolling.parentAttributesalias + "(" + tempRolling.childAttributesalias + ")";
        }
        tempRolling.rollupColumnAlias = this.replaceCharecter(tempRolling.rollupColumnAlias, this.constants.charecterDot, this.constants.charecterUnderScore);
        this.updateColumnValues(this.rollingupdata.parentAttributesalias, this.rollingupdata.childAttributesalias);

        this.rollingUp.push(tempRolling);
        this.showRollingUp = true;
        this.rollingupdatatemp = { "childattributes": [], "childAttributesalias": [] };
        this.rollingupdata = {
          "parentObjectName": "", "parentattribute": "", "childObjectName": "",
          "childattributes": "", "parentAttributesalias": "", "childAttributesalias": "", "rollupColumnAlias": "", "rollingUpLevel": "1","rollupseprator":""
        };
        tempRolling = {
          "parentObjectName": "", "parentattribute": "", "childObjectName": "", "childattributes": "",
          "parentAttributesalias": "", "childAttributesalias": "", "rollupColumnAlias": "", "rollingUpLevel": "1", "filters": [],"rollupseprator":""
        };
        this.recordWhere = [];
      }
      console.log(this.rollingUp);

      this.formValidAttributes.reset();

      this.formValidationsRollingUp();
      this.childattributestemp = [];
      if (this.applyRecordFilter) {
        this.applyRecordFilterSelection();
      }
    }
    this.formValidAttributes.get('rollupSeparator')?.setValue(",");
    this.rollingupdata.rollupseprator=",";

  }

  /**
   * @author Ashwin M
   * 22/02/2023
   * @param parentattributes parent object attributes selected for rollup
   * @param childattributes child object attributes selected for rollup
   */
  updateColumnValues(parentattributes: any, childattributes: any) {
    let childattributesArray = childattributes.split(",");
    console.log(childattributesArray.length);
    for (let arrayIndex = 0; arrayIndex < childattributesArray.length; arrayIndex++) {
      let attributeElement = childattributesArray[arrayIndex];
      if (attributeElement.includes(".")) {
        attributeElement = this.replaceCharecter(attributeElement, this.constants.charecterDot,
          this.constants.charecterUnderScore);
        childattributesArray[arrayIndex] = attributeElement
      }
      console.log("Compare -> " + attributeElement);
    }
  }

  childattributestemp = []
  changeRollingUpChildAttributes(e) {
    console.log(e)
    console.log(e.value)
    this.rollingupdata.childattributes = e.value.attributeNameWithFields;
    this.rollingupdata.childAttributesalias = e.value.attributeNameWithFields;
    this.rollingupdata.rollupColumnAlias = this.rollingupdata.parentAttributesalias + "(" + this.rollingupdata.childAttributesalias + ")";
  }
  parentattribute = "";
  changeRollingUpParentAttributes(e) {
    console.log(e)
    console.log(e.value)
    this.parentattribute = e.value;
    this.rollingupdata.parentattribute = e.value.attributeNameWithFields;
    this.rollingupdata.parentAttributesalias = e.value.attributeNameWithFields;
    console.log(this.rollingupdata)
  }

  addWhere() {
    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {
      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.whereData);
      this.formFieldsTrimer.clean(this.whereData);
      if (this.whereData.objectWhere == undefined || this.whereData.fieldsWhere == undefined || this.whereData.conditionalOperatorWhere == undefined) {
        this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });
      } else {
        this.whereData.logicalOperatorWhere = "AND";
        console.log(this.whereData.enterValueWhereDate)
        console.log(this.whereData.enterValueWhere)
        let objectName = "";
        this.filterData.forEach(object => {
          if (object.alias === this.whereData.fieldsWhere) {
            objectName = object.name;
          }
        })
        var whereValue;
        if (this.whereData.conditionalOperatorWhere === "IN") {
          var multipleValue;
          var multiValue = "";
          multipleValue = this.whereData.multiSelect;
          let value = multipleValue.split(",")
          if (value.length == 0) {
            this.snackbar.open("Not a valid filter. Please select value to Add filter", "OK", { duration: 5000 });
          }
          for (let index = 0; index < value.length; index++) {
            const element = value[index];
            multiValue = multiValue + "'" + element + "'";
            if (index != value.length - 1) {
              multiValue = multiValue + ",";
            }
          };
          whereValue = "(" + multiValue + ")";
          let tempWhere = {
            "objectWhere": this.whereData.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.whereData.fieldsWhere,
            "whereCondition": this.whereData.conditionalOperatorWhere,
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere
          }

          this.where.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        } else if (this.whereData.conditionalOperatorWhere === "BETWEEN") {
          if (this.dateChange) {
            this.whereValueDateFormat = moment(this.whereData.enterValueBetweenStart)
            this.whereData.enterValueBetweenStart = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
            console.log(this.whereData.enterValueBetweenStart)
            this.whereValueDateFormat = moment(this.whereData.enterValueBetweenEnd)
            this.whereData.enterValueBetweenEnd = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
            console.log(this.whereData.enterValueBetweenEnd)
            let tempWhere = {
              "objectWhere": this.whereData.objectWhere,
              "whereKey": objectName,
              "whereKeyAlias": this.whereData.fieldsWhere,
              "whereCondition": this.whereData.conditionalOperatorWhere,
              "whereValue": "'" + this.whereData.enterValueBetweenStart + "'",
              "whereValue1": "'" + this.whereData.enterValueBetweenEnd + "'",
              "whereLogic": this.whereData.logicalOperatorWhere
            }
            this.where.push(tempWhere);
            tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
          } else {
            let tempWhere = {
              "objectWhere": this.whereData.objectWhere,
              "whereKey": objectName,
              "whereKeyAlias": this.whereData.fieldsWhere,
              "whereCondition": this.whereData.conditionalOperatorWhere,
              "whereValue": "'" + this.whereData.enterValueBetweenStart + "'",
              "whereValue1": "'" + this.whereData.enterValueBetweenEnd + "'",
              "whereLogic": this.whereData.logicalOperatorWhere
            }
            this.where.push(tempWhere);
            tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
          }
        } else if (this.whereData.conditionalOperatorWhere === "schedule range") {
          let tempWhere = {
            "objectWhere": this.whereData.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.whereData.fieldsWhere,
            "whereCondition": this.whereData.conditionalOperatorWhere,
            "whereValue": "",
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere
          }
          this.where.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        } else if (this.whereData.conditionalOperatorWhere === "Ends with") {
          whereValue = "'%" + this.whereData.enterValueWhere + "'";
          let tempWhere = {
            "objectWhere": this.whereData.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.whereData.fieldsWhere,
            "whereCondition": "LIKE",
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere
          }

          this.where.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" };
        } else if (this.whereData.conditionalOperatorWhere === "Starts with") {
          whereValue = "'" + this.whereData.enterValueWhere + "%'";
          let tempWhere = {
            "objectWhere": this.whereData.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.whereData.fieldsWhere,
            "whereCondition": "LIKE",
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere
          }

          this.where.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        } else if (this.whereData.conditionalOperatorWhere === "contains") {
          whereValue = "'%" + this.whereData.enterValueWhere + "%'";
          let tempWhere = {
            "objectWhere": this.whereData.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.whereData.fieldsWhere,
            "whereCondition": "LIKE",
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere
          }

          this.where.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        } else {
          if (this.dateField) {
            this.whereValueDateFormat = moment(this.whereData.enterValueWhereDate)
            whereValue = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
          } else {
            whereValue = "'" + this.whereData.enterValueWhere + "'";
            this.whereData.enterValueWhere = whereValue;
          }
          let tempWhere = {
            "objectWhere": this.whereData.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.whereData.fieldsWhere,
            "whereCondition": this.whereData.conditionalOperatorWhere,
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.whereData.logicalOperatorWhere
          }

          this.where.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" };
        }
        this.showFilter = true;
        this.whereData = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };
        this.dateChange = false;
        this.dateField = false;
        this.multiselect = false;
        this.fieldChange = true;
        this.scheduleRange = false;
        this.betweenField = false;

        console.log(this.where);

        this.formValidWhere.reset();

        this.formValidationsWhere();
        this.multiSelectVaules = [];
        this.filterData = [];
      }

    }

  }

  addOrderBy() {
    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {
      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.orderByData);
      this.formFieldsTrimer.clean(this.orderByData);
      // this.orderByData.objectOrderBy == undefined ||
      if (this.orderByData.fieldsOrderBy == undefined || this.orderByData.arrangeOrderBy == undefined) {
        this.snackbar.open("Not a valid sort operation", "OK", { duration: 5000 });
      } else {
        if (this.orderByData.arrangeOrderBy == undefined) {
          this.orderByData.arrangeOrderBy = "AND"
        }
        console.log(this.orderByData.fieldsOrderBy)
        console.log(this.orderByData.fieldsOrderBy)
        let objectName = "";
        let valutObject = "";
        console.log("DataLength", this.filterData.length);
        this.columns.forEach(object => {
          if (object.alias === this.orderByData.fieldsOrderBy) {
            objectName = object.name;
            valutObject = object.object;
          }
        })
        let tempOrder = {
          "orderObject": valutObject,
          "objectOrderBy": this.orderByData.objectOrderBy,
          "orderKey": objectName,
          "orderKeyAlias": this.orderByData.fieldsOrderBy,
          "orderAllign": this.orderByData.arrangeOrderBy
        }

        this.orderBy.push(tempOrder);
        this.showOrderBy = true;
        this.orderByData = { "objectOrderBy": "", "fieldsOrderBy": "", "arrangeOrderBy": "" };

        tempOrder = { "orderObject": "", "objectOrderBy": "", "orderKey": "", "orderKeyAlias": "", "orderAllign": "", }

        console.log(this.orderBy);

        this.formValidWhere.reset();

        this.formValidationsWhere();
      }

    }
  }
  addHeaderType() {
    console.log(this.columns);
    console.log(this.headerTypeObj);
    console.log(this.headersTypeArr)

    if (!this.formValidHeaderType.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidHeaderType);

      this.validation.getvalidationmessage();

    }

    else {


      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.headerTypeObj);
      this.formFieldsTrimer.clean(this.headerTypeObj);
      // this.orderByData.objectOrderBy == undefined ||
      // headerTypeObj = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" };

      if (this.headerTypeObj.headerKeyAlias == undefined || this.headerTypeObj.headerKeyType == undefined) {
        this.snackbar.open("Not a valid Header", "OK", { duration: 5000 });
      } else {


        console.log(this.headerTypeObj.headerKey);

        let headerKeyAliasArr = this.headerTypeObj.headerKeyAlias.split(",");
        for (let j = 0; j < headerKeyAliasArr.length; j++) {
          let filteredArr = this.headersTypeArr.filter(item => item.headerKeyAlias == headerKeyAliasArr[j])
          console.log(filteredArr)
          if (filteredArr.length > 0) {
            this.snackbar.open("Header Key Alias [" + filteredArr[0].headerKeyAlias + "] Already Exists", "OK", { duration: 5000 });
            this.headerTypeObj = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" };
            this.formValidHeaderType.reset();

            this.formValidationsHeaderType();

            return;
          }
        }
        for (let a = 0; a < headerKeyAliasArr.length; a++) {
          this.columns.forEach(object => {

            if (object.alias === headerKeyAliasArr[a]) {

              let tempHeader = {
                "headerKey": object.name,
                "headerKeyObject": object.object,
                "headerKeyType": this.headerTypeObj.headerKeyType,
                "headerKeyAlias": headerKeyAliasArr[a],

              }
              this.headersTypeArr.push(tempHeader)
              tempHeader = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" }

            }
          })
        }




        // this.mofifyHeadersTypeObjects(this.headersTypeArr)
        if (this.headersTypeArr.length > 0) {
          this.showHeaderType = true;
        }
        // this.orderByData = { "objectOrderBy": "", "fieldsOrderBy": "", "arrangeOrderBy": "" };
        this.headerTypeObj = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" };


        // tempHeader = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" }

        console.log(this.orderBy);

        this.formValidHeaderType.reset();

        this.formValidationsHeaderType();
      }

    }


  }


  addAggregate() {
    console.log(this.aggregateByData);
    console.log(this.aggregateByData.aggregateOn);
    console.log(this.aggregateByData.aggregateFunction);
    console.log(this.aggregateByData.partionOn);
    console.log(this.aggregateByData.distinctColumns);
    console.log(this.aggregateByData.columnAlias);
    console.log(this.aggregateByData.distinctColumns);

    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {

      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.aggregateByData);
      this.formFieldsTrimer.clean(this.aggregateByData);
      if (this.aggregateByData.aggregateOn == undefined || this.aggregateByData.aggregateFunction == undefined || this.aggregateByData.partionOn == undefined ||  this.aggregateByData.columnAlias == undefined) {
        this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });
      } else {
        // Update aggregateByData with ordered selections
        this.aggregateByData.partionOn = this.orderedPartitionSelection.join(',');
        this.aggregateByData.distinctColumns = this.orderedOrderBySelection.join(',');

        if (this.aggregateByData.aggregateFunction == undefined) {
          this.aggregateByData.aggregateFunction = "AND"
        }
        let tempAggregate = { "aggregateColumn": this.aggregateByData.aggregateOn, "aggregateFunction": this.aggregateByData.aggregateFunction, "partitionByColumn": this.aggregateByData.partionOn, "reporting": "Y", "distinctColumns": this.aggregateByData.distinctColumns, "alias": this.aggregateByData.columnAlias, "conditionalValue": this.aggregateByData.conditionalValue, "groupByFunction": this.aggregateByData.groupByFunction, "groupByNeeded": false };

        if (this.aggregateByData.conditionalValue == undefined) {
          tempAggregate = { "aggregateColumn": this.aggregateByData.aggregateOn, "aggregateFunction": this.aggregateByData.aggregateFunction, "partitionByColumn": this.aggregateByData.partionOn, "reporting": "Y", "distinctColumns": this.aggregateByData.distinctColumns, "alias": this.aggregateByData.columnAlias, "conditionalValue": "", "groupByFunction": this.aggregateByData.groupByFunction, "groupByNeeded": false };

        }
        if (this.aggregateBy.length > 0) {
          for (let i = 0; i < this.aggregateBy.length; i++) {
            if (this.aggregateBy[i].alias === tempAggregate.alias) {
              this.snackbar.open("Please enter Unique Alias for Aggregate", "OK", { duration: 5000 });

              return;
            }
          }
        }
        //   let tempAggregate = { "aggregateObject": this.aggregateByData.objectAggregateBy, "aggregateKey": this.aggregateByData.fieldsAggregateBy, "aggregate": this.aggregateByData.arrangeaggregateBy }
        this.aggregateBy.push(tempAggregate);
        if (this.aggregateBy.length > 0) {
          this.showAggregate = true;

        }
        this.aggregateByData = { "aggregateOn": "", "aggregateFunction": "", "partionOn": "", "distinctColumns": "", "columnAlias": "", "conditionalValue": "", "groupByNeeded": false, "groupByFunction": "" };

        tempAggregate = { "aggregateColumn": "", "aggregateFunction": "", "partitionByColumn": "", "distinctColumns": "", "reporting": "Y", "alias": "", "conditionalValue": "", "groupByFunction": "", "groupByNeeded": false };



        console.log(this.aggregateBy);

        this.formValidWhere.reset();

        this.formValidationsWhere();
      }
    }

  }

 onPivotTypeChange(selectedType: string): void {
  this.pivotAggregateByData.pivotType = selectedType;


  Object.keys(this.formValidPivotType.controls).forEach(field => {
    const control = this.formValidPivotType.get(field);

    control?.clearValidators();
    control?.updateValueAndValidity();
  });

  const required = Validators.required;

  if (selectedType === 'pivotAggregate') {
    [
      'pivotColumnAlias',
      'caseColumn',
      'pivotColumn',
      'childColumns',
      'headersToNull',
      'orderByColumn',
      'parentcolumns',
      'headerValueColumn'

    ].forEach(field => this.formValidPivotType.get(field)?.setValidators(required));

  }

  if (selectedType === 'pivotTable') {
    [
      'pivotColumnAlias',
      'caseColumn',
      'pivotColumn',
      'childColumns',
      'pivotAlias',
      'orderByColumn',
      'parentcolumns',
      'distinctCount',
      /*Modified By Renuka
      * Date 25-11-2025
      * Removed mandatory validation for grandtotalgroupby 
      */
      // 'grandTotalGroupby'

    ].forEach(field => this.formValidPivotType.get(field)?.setValidators(required));
  }

  Object.values(this.formValidPivotType.controls).forEach(control => {

    control.updateValueAndValidity();
  });
}



  addPivotAggregate(){
    if (!this.formValidPivotType.valid) {
      this.validation.validateAllFormFields(this.formValidPivotType);
      this.validation.getvalidationmessage();
    }else {
      this.formFieldsTrimer.trimFormfieldsData(this.pivotAggregateByData);
      this.formFieldsTrimer.clean(this.pivotAggregateByData);

       // Modified by Renuka, parse json data for pivot column alias
      if (this.pivotAggregateByData.pivotType === 'pivotTable' && this.pivotAggregateByData.pivotAlias) {
    try {
      this.pivotAggregateByData.pivotAlias = JSON.parse(this.pivotAggregateByData.pivotAlias);
    } catch (error) {
      alert('Invalid JSON in Pivot Column Alias');
      return;
    }
  }

        let tempPivotAggregate={
          "pivotType": this.pivotAggregateByData.pivotType,
          "alias":this.pivotAggregateByData.columnAlias,
          "caseColumn":this.pivotAggregateByData.caseColumn,
          "pivotColumn":this.pivotAggregateByData.pivotColumn,
          "childColumns":this.pivotAggregateByData.childColumns,
          "headersToNull":this.pivotAggregateByData.headersToNull,
          "orderByColumn":this.pivotAggregateByData.orderByColumn,
          "parentcolumns":this.pivotAggregateByData.parentcolumns,
          "headerValueColumn":this.pivotAggregateByData.headerValueColumn,
          // // Modified by Renuka, Added pivot type feilds
           distinctCount: this.pivotAggregateByData.distinctCount || '',
  pivotAlias: this.pivotAggregateByData.pivotAlias || '',
  grandTotalGroupby: this.pivotAggregateByData.grandTotalGroupby || ''

        }
        console.log(this.pivotAggregateByData);

        if (this.pivotAggregateBy.length > 0) {
          for (let i = 0; i < this.pivotAggregateBy.length; i++) {
            if (this.pivotAggregateBy[i].alias === tempPivotAggregate.alias) {
              this.snackbar.open("Please enter Unique Alias for Pivot Aggregate", "OK", { duration: 5000 });

              return;
            }
          }
        }
                // Modified by Renuka 
                if (this.pivotAggregateByData.pivotType === 'pivotAggregate') {
          this.pivotAggregateBy.push({
            caseColumn: this.pivotAggregateByData.caseColumn,
            pivotTable: "No",
            totalAlias: this.pivotAggregateByData.columnAlias,
            pivotColumn: this.pivotAggregateByData.pivotColumn,
            childColumns: this.pivotAggregateByData.childColumns,
            orderByColumn: this.pivotAggregateByData.orderByColumn,
            parentcolumns: this.pivotAggregateByData.parentcolumns,
            headerValueColumn: this.pivotAggregateByData.headerValueColumn
          });
        } else if (this.pivotAggregateByData.pivotType === 'pivotTable') {
          const pivotMeta = {
            caseColumn: this.pivotAggregateByData.caseColumn,
            totalAlias: this.pivotAggregateByData.columnAlias,
            pivotColumn: this.pivotAggregateByData.pivotColumn,
            childColumns: this.pivotAggregateByData.childColumns,
            distinctCount: this.pivotAggregateByData.distinctCount || '',
            orderByColumn: this.pivotAggregateByData.orderByColumn,
            parentcolumns: this.pivotAggregateByData.parentcolumns,
            pivotColumnAlias: this.pivotAggregateByData.pivotAlias || {},
            grandTotalGroupby: this.pivotAggregateByData.grandTotalGroupby || ''
          };

          let pivotTableObj = this.pivotAggregateBy.find(e => e.pivotTable === "Yes");
          if (!pivotTableObj) {
            pivotTableObj = { pivotTable: "Yes", pivotMetadata: [] };
            this.pivotAggregateBy.push(pivotTableObj);
          }
          pivotTableObj.pivotMetadata.push(pivotMeta);
        }



        if (this.pivotAggregateBy.length > 0) {
          this.showPivotAggregate = true;

        }
        const selectedPivotType = this.pivotAggregateByData.pivotType;
        this.pivotAggregateByData={
          "pivotType":selectedPivotType,
          "columnAlias":"",
          "caseColumn":"",
          "pivotColumn":"",
          "childColumns":"",
          "headerValueColumn":"",
          "orderByColumn":"",
          "parentcolumns":"",
          "headersToNull":"",
           
          // Modified by Renuka
          "distinctCount":"",
          "pivotAlias":"",
          "grandTotalGroupby":""
          
        }

        tempPivotAggregate={
          "pivotType":selectedPivotType,
          "alias":"",
          "caseColumn":"",
          "pivotColumn":"",
          "childColumns":"",
          "headerValueColumn":"",
          "orderByColumn":"",
          "parentcolumns":"",
          "headersToNull":"",
          "distinctCount":"",
          "pivotAlias":"",
          "grandTotalGroupby":""
          
        }

if (this.formValidPivotType.valid) {
        this.formValidPivotType.reset();
        this.formValidationsPivotType(selectedPivotType,this.pivotAggregateByData);

      }

    }
  }

  addSubAggregateLevel() {
    console.log("===================================");
    console.log(this.subAggregateLevelData);
    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {
      this.formFieldsTrimer.trimFormfieldsData(this.subAggregateLevelData);
      this.formFieldsTrimer.clean(this.subAggregateLevelData);



      // Push a copy of the data to avoid reference issues

      if (this.subAggregateLevelData.groupByColumn == "" || this.subAggregateLevelData.groupByColumn == null || this.subAggregateLevelData.groupByColumn == undefined || this.subAggregateLevelData.alias == "" || this.subAggregateLevelData == null) {
        this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });

      } else {

        console.log("groupByColumnSelections before update: ", this.groupByColumnSelections);
        this.subAggregateLevelData.groupByColumn = this.orderedOrderBySelection.join(',');
        console.log("groupByColumn after update: ", this.subAggregateLevelData.groupByColumn);


        let subAggregateLevelDataCopy = { "groupByColumn": this.subAggregateLevelData.groupByColumn, "groupByNeeded": true, "alias": this.subAggregateLevelData.alias }
        this.subLevelAggregateBy.push(subAggregateLevelDataCopy);

        this.showSubLevelAggregate = true;
        this.subAggregateLevelData = { "groupByColumn": "", "groupByNeeded": true, "alias": "" }
        subAggregateLevelDataCopy = { "groupByColumn": "", "groupByNeeded": true, "alias": "" }

        // Now reset the form
        this.formValidWhere.reset();
        this.formValidationsWhere();

        console.log(this.subLevelAggregateBy);

      }
    }
  }
  //   mofifyHeadersTypeObjects(arr) {
  //     let result = [];
  //     console.log(arr)
  //     console.log(this.columns)
  //     for (let a = 0; a < arr.length; a++){
  //       let headerKeyarr = arr[a].headerKey.split(",");
  //       for (let b = 0; b < headerKeyarr.length; b++){
  //         for (let c = 0; c < this.columns.length; c++){
  //           if (headerKeyarr[b] == this.columns[c].name) {
  //             let obj = { "headerKey": this.columns[c].name, "headerKeyObject": this.columns[c].object, "headerKeyType": arr[a].headerKeyType, "headerKeyAlias": this.columns[c].alias }
  //             result.push(obj)
  //           }
  //         }
  //       }
  //     }
  //     console.log(result);
  //     return result;
  // }

/**
 * Code Modified by Rahul vk 
 * Date :- 06/05/25
 * Jira id :-JRAAP-4649 
 * Fix - 25R1
 *
 * 
 * Modifications:
 * - Added logic to assign `uiIndex` to each column and concat field based on alias and label matching.
 * - Ensured unique `uiIndex` values across columns and concatenations.
 * - Each attributes Now have UI index Which is sent to backend for sorting in order 
 */
  createreport() {
    console.log(this.columns)
    if (!this.validations_form.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.validations_form);

      this.validation.getvalidationmessage();

    } else {
      this.spinner.start();
      let parentKey = 0;
      this.columns.forEach(column => {
        if (column.type === "__constant") {
          column.name = column.alias.substring(0, column.alias.indexOf("Seperator"));
          column.object = "constants";
        }
      })
      console.log(this.subLevelAggregateBy)
      if (this.subLevelAggregateBy.length > 0) {
       
        for (let a = 0; a < this.subLevelAggregateBy.length; a++) {
          this.aggregateBy.push(this.subLevelAggregateBy[a]);
        }
      }
      console.log(this.aggregateBy);



      if (this.headersTypeArr == null || this.headersTypeArr == undefined) {
        this.headersTypeArr = [];
      }


    

// 1) Update temp array indices for each drag and drop
this.temp.forEach((item, idx) => {
  item.uiIndex = idx;
});

// STEP 1: Index existing temp (COLUMNS)
this.columns.forEach(col => {
  console.group(`Processing column: "${col.alias}"`);

  // A) exact alias+label match
  let match = this.temp.find(t =>
    t.alias === col.alias &&
    this.replaceCharecter(t.label, this.constants.charecterDot,this.constants.charecterUnderScore) === this.replaceCharecter(col.label, this.constants.charecterDot,this.constants.charecterUnderScore)
  );

  if (match) {
    col.uiIndex = match.uiIndex;
    console.log(` Exact Match Column "${col.alias}" → uiIndex = ${col.uiIndex}`);

  } else {
    const aliasOnly = this.temp.find(t => t.alias === col.alias);
    const labelOnly = this.temp.find(t => this.replaceCharecter(t.label, this.constants.charecterDot,this.constants.charecterUnderScore) === this.replaceCharecter(col.label, this.constants.charecterDot,this.constants.charecterUnderScore));

    if (aliasOnly && !labelOnly) {
      // Case B: alias same, label changed → keep index
      col.uiIndex = aliasOnly.uiIndex;
      console.log(` Alias-only match column "${col.alias}" → uiIndex = ${col.uiIndex}`);

    } else if (!aliasOnly && labelOnly) {
      // Case C: label same, alias changed → keep index
      col.uiIndex = labelOnly.uiIndex;
      console.log(` Label-only match column "${col.alias}" → uiIndex = ${col.uiIndex}`);

    } else {
      // Case D: new field
      col.uiIndex = this.temp.length;
      this.temp.push({
        uiIndex: col.uiIndex,
      });
      console.info(` New column → uiIndex = ${col.uiIndex}`);
    }
  }

  console.groupEnd();
});

// STEP 2: Index CONCATS
const concatTemps = this.temp.filter(t => t.isConcat);
this.concatination.forEach(concat => {
  console.group(`Processing concat: "${concat.alias}"`);

  let match = concatTemps.find(t =>
    t.alias === concat.alias &&
    this.replaceCharecter(t.label,this.constants.charecterDot,this.constants.charecterUnderScore) 
    === 
    this.replaceCharecter(concat.label, this.constants.charecterDot,this.constants.charecterUnderScore) 
  );

  if (match) {
    concat.uiIndex = match.uiIndex;
    console.log(`Exact match concat "${concat.alias}" → uiIndex = ${concat.uiIndex}`);

  } else {
    const aliasOnly = concatTemps.find(t => t.alias === concat.alias);
    const labelOnly = concatTemps.find(t =>  this.replaceCharecter(t.label,this.constants.charecterDot,this.constants.charecterUnderScore) 
    === 
    this.replaceCharecter(concat.label, this.constants.charecterDot,this.constants.charecterUnderScore) );

    if (aliasOnly && !labelOnly) {
      concat.uiIndex = aliasOnly.uiIndex;
      console.log(` Alias-only match "${concat.alias}" → uiIndex = ${concat.uiIndex}`);

    } else if (!aliasOnly && labelOnly) {
      concat.uiIndex = labelOnly.uiIndex;
      console.log(` Label-only match "${concat.alias}" → uiIndex = ${concat.uiIndex}`);

    } else {
      concat.uiIndex = this.temp.length;
      this.temp.push({
        uiIndex:  concat.uiIndex,
      });
      console.info(`Appended new concat field "${concat.label}" at uiIndex ${concat.uiIndex}`);
    }
  }

  console.groupEnd();
});


// 4) Final validation to ensure unique indices
const allIndices = [
  ...this.columns.map(c => c.uiIndex),
  ...this.concatination.map(c => c.uiIndex)
].filter(i => i !== undefined);

const hasDuplicates = new Set(allIndices).size !== allIndices.length;
if (hasDuplicates) {
  console.warn('⚠️ Duplicate uiIndex detected! Recommend reviewing field assignments');
}

      this.reportCreationData.headersType = this.headersTypeArr;
      this.reportCreationData.filters = this.where
      this.reportCreationData.sorting = this.orderBy
      this.reportCreationData.aggregate = this.aggregateBy
      this.reportCreationData.columns = this.columns
      this.reportCreationData.concatination = this.concatination
      this.reportCreationData.rollingUp = this.rollingUp
      this.reportCreationData.generateDefaultTemplate = this.generateDefaultTemplate;
      this.reportCreationData.pivotAggregation=this.pivotAggregateBy
      /**
       * modified by Ashwin M
       * 28/02/2024
       * code modified to send auto refresh tag for datasets
       */
      this.reportCreationData.autoRefreshDataset = this.autoRefreshDataset;
      console.log(this.reportCreationData.autoRefreshDataset)
      this.reportCreationData.transformation = this.transformation;
      this.reportCreationData.columnFilters = this.columnFilter;
    this.reportCreationData.datasetOutputFormat = this.datasetOutputFormat;

      console.log(this.reportCreationData)
      if (this.butttonname === "Update Dataset") {
        parentKey = this.reportCreationUpdateid
      }
      this.linkservice.insertreportlinks(this.reportCreationData, parentKey).subscribe(response => {
        console.log(response);
        // checking if response is true or not
        /**
         * modified by Ashwin M
         * 28/02/2024
         * code modified to show both stauts and associated data in the snackbar
         */
        this.snackbar.open(response.statusMessage + response.data, "OK", {
          duration: 5000,
        });
        this.spinner.stop();
        if (!response.error) {
          this.showRollingUp = false;
          this.objectGroup = false;
          this.datasetGroup = false;
          this.onGridReady(this.rowbindingdata);
          this.cancel();
        }
        this.aggregateBy = []
        this.pivotAggregateBy=[]
        this.subLevelAggregateBy = [];
        this.subAggregateLevelData = { "groupByColumn": "", "groupByNeeded": true, "alias": "" };
        this.headersTypeArr = [];
        this.headerTypeObj = { "headerKey": "", "headerKeyObject": "", "headerKeyType": "", "headerKeyAlias": "" };
      });
      this.showAggregate = false;
      this.showHeaderType = false;
      this.showSubLevelAggregate = false;
      this.showPivotAggregate=false;
    }






    this.spinner.stopAll();
     this.formValidAttributes.get('rollupSeparator')?.setValue(",");
    this.rollingupdata.rollupseprator=",";

  }

  addGroupBy() {

    if (!this.formValidGroupBy.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidGroupBy);

      this.validation.getvalidationmessage();

    }

    else {

      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.groupByData);

      this.formFieldsTrimer.clean(this.groupByData);

      console.log(this.groupByData.fieldsGroupBy);

      this.groupBy.push(this.groupByData.fieldsGroupBy);

      console.log(this.groupBy);

      this.groupByData = { "fieldsGroupBy": "" };

      console.log(this.groupByData);

      this.formValidGroupBy.reset();

      this.formValidationsGroupBy();

    }

  }

  Useroles(): void {
    const dnsid = this.localStorageSettings.getSettings("dnsName");
    if (dnsid) {
      this.service.getUserRoles(dnsid).subscribe(
        (response) => {
          this.UserRolesWithRoleId = response; // Assign fetched user roles to the types array
          console.log(this.UserRolesWithRoleId);
        },
        (error) => {
          console.error('Error fetching user roles:', error);
        }
      );
    }
  }


  access_permission(data) {



    console.log(data)
    this.sharedData = data.rowData;

    if (data.rowData.status === "No") {
      this.snackbar.open(this.constants.Deleted_Dataset, "OK", { duration: 5000 });
      return;
    }


    if (this.responserequest.roleName !== data.rowData.dataset_ownerRoleid) {
      this.snackbar.open(this.constants.Access_Denied, "OK", { duration: 5000 });
      return;
    }





    let dialogRef = this.dialog.open(AccessPermissionComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '55%',
      autoFocus: false,
      data: { edata: this.sharedData },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((message: string) => {

      if (message === 'updated') {
        this.refreshRun();
      }
    });



  }


  public sharerowData() {
    console.log(this.sharedData);
    return this.sharedData;
  }



  analysis(data) {

    /*
    Added By->Abhishek T
    Date-24-06-2024
    adding select filter popup for analysis
    */

    console.log(data);


    let dialogRef = this.dialog.open(SelectFiltersPopUpComponent, {
      width: "80%",
      autoFocus: false,
      maxWidth: '100vw',
      height: "96%",
      disableClose: true,
      data: { dataSetId: data.rowData.reportcreationid, objectGroup: data.rowData.objectGroup, columnsData: data.rowData.columns, datasetData: data.rowData, showVisualDropDowns: true }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);


      let getdata = result.selectedFiltersListString
      if (getdata) {
        let filterList = JSON.parse(getdata);
        console.log(filterList);
        let dnsId = localStorage.getItem("dnsName");
        this.etlService.retrieveJsuiteProperty(dnsId, "UIDateFormat").subscribe(res => {
          this.spinner.start();
          console.log("Test string");
          console.log(res)
          if (res) {
            this.jsuitepropertyValue = res.propertyvalue;
            console.log(this.jsuitepropertyValue);
            this.filterListBody = []
            for (let i = 0; i < filterList.length; i++) {
              if(filterList[i].whereCondition !== "CalculatedFieldForReports"&&filterList[i].whereCondition !=="count"){
              console.log(filterList[i].whereValue.length);
              let filterValue;
              let showInQuicksightVisuals: any = "";
              if (filterList[i].showInQuicksightVisuals) {
                showInQuicksightVisuals = filterList[i].showInQuicksightVisuals
              } else {
                showInQuicksightVisuals = false
              }
              let displayCalculatedFieldsIn = "columns"
              if (filterList[i].displayCalculatedFieldsIn) {
                displayCalculatedFieldsIn = filterList[i].displayCalculatedFieldsIn
              } else {
                displayCalculatedFieldsIn = "columns"
              }
              if (filterList[i].whereCondition == "IN" || filterList[i].whereCondition == "NOT IN") {
                // filterValue = this.convertArrayToString(filterList[i].whereValue)
                filterValue = JSON.stringify(filterList[i].whereValue);
              } else if (filterList[i].whereCondition == "BETWEEN") {

                if (filterList[i].type == "DateTime" || filterList[i].type == "Date") {

                  if (filterList[i].whereValue.length > 0) {
                    const parsedDate = moment(filterList[i].whereValue, 'YYYY-MM-DD').startOf('day');
                    filterList[i].whereValue = parsedDate.format(this.jsuitepropertyValue)
                  } else {
                    filterList[i].whereValue = ""
                  }

                  if (filterList[i].whereValue1.length > 0) {
                    const parsedDate2 = moment(filterList[i].whereValue1, 'YYYY-MM-DD').startOf('day');
                    filterList[i].whereValue1 = parsedDate2.format(this.jsuitepropertyValue)
                  }


                }
                filterValue = [this.removeSingleQuotes(filterList[i].whereValue), this.removeSingleQuotes(filterList[i].whereValue1)]
                filterValue = JSON.stringify(filterValue);
              } else {
                filterValue = this.removeSingleQuotes(filterList[i].whereValue)
                if (filterList[i].type == "DateTime" || filterList[i].type == "Date") {

                  if (filterList[i].whereValue.length > 0) {
                    const parsedDate = moment(filterList[i].whereValue, 'YYYY-MM-DD').startOf('day');
                    filterValue = parsedDate.format(this.jsuitepropertyValue);
                  } else {
                    filterValue = ""
                  }


                }
              }
              console.log(filterList[i].whereValue.length);
              console.log(filterValue);
              console.log(filterList[i].excludeNull);

              if (filterList[i].excludeNull == undefined) {
                let priority=''
                if(filterList[i].priority){
                  priority=filterList[i].priority
                }else{
                  priority=''
                }
                let listObject = {
                  label: filterList[i].label,
                  columnName: filterList[i].whereKeyAlias,
                  matchOperator: filterList[i].whereCondition,
                  filterValue: filterValue,
                  filterType: "String",
                  excludeNull: false,
                  showOnlyNulls: false,
                  showInQuicksightVisuals: showInQuicksightVisuals,
                  displayCalculatedFieldsIn: displayCalculatedFieldsIn,
                  priority:priority

                }
                if (filterList[i].type == "DateTime" || filterList[i].type == "Date") {
                  listObject.filterType = filterList[i].type
                }
                this.filterListBody.push(listObject)
              } else if ((filterList[i].whereValue.length > 0 && filterValue != "undefined") || filterList[i].excludeNull || filterList[i].showOnlyNulls) {
                let priority=''
                if(filterList[i].priority){
                  priority=filterList[i].priority
                }else{
                  priority=''
                }
                let listObject = {
                  label: filterList[i].label,
                  columnName: filterList[i].whereKeyAlias,
                  matchOperator: filterList[i].whereCondition,
                  filterValue: filterValue,
                  filterType: "String",
                  excludeNull: filterList[i].excludeNull,
                  showOnlyNulls: filterList[i].showOnlyNulls,
                  showInQuicksightVisuals: showInQuicksightVisuals,
                  displayCalculatedFieldsIn: displayCalculatedFieldsIn,
                  priority:priority
                }
                if (filterList[i].type == "DateTime" || filterList[i].type == "Date") {
                  listObject.filterType = filterList[i].type
                }
                this.filterListBody.push(listObject)
              }
            }
            }


            for (let i = 0; i < this.filterListBody.length; i++) {
              const followUp = this.filterListBody[i];
            
              if (
                followUp.label?.toLowerCase() === 'followup date' &&
                followUp.matchOperator === 'BETWEEN' &&
                (followUp.filterType === 'DateTime' || followUp.filterType === 'Date') &&
                followUp.filterValue?.length > 0
              ) {
                let datesArray: any[] = [];
            
                try {
                  datesArray = JSON.parse(followUp.filterValue);
                } catch (err) {
                  console.error('Invalid JSON in filterValue:', followUp.filterValue);
                  continue; // skip this loop if JSON parsing fails
                }
            
                const startDateValue = moment(datesArray[0]).format('YYYY-MM-DD');
                const endDateValue = moment(datesArray[1]).format('YYYY-MM-DD');
            
                for (let j = this.filterListBody.length - 1; j >= 0; j--) {
                  const calculated = this.filterListBody[j];
            
                  if (
                    calculated.matchOperator === 'CalculatedFieldWithFilter' &&
                    calculated.label === 'Max_Case_Version'
                  ) {
                    if (calculated.priority === 'postMax') {
                      let calculatedFieldValue = calculated.filterValue;
            
                      if (calculatedFieldValue) {
                        calculatedFieldValue = calculatedFieldValue
                          .replaceAll('${startDate}', `"${startDateValue}"`)
                          .replaceAll('${endDate}', `"${endDateValue}"`);
            
                        this.filterListBody[j].filterValue = calculatedFieldValue;
                        console.log('Updated:', calculatedFieldValue);
                      }
                    } else if (calculated.priority === 'preMax') {
                      this.filterListBody.splice(j, 1);
                    }
                  }
                }
                break;
              }
            }
            
            // If no followup date found, remove Max_Case_Version postMax block
            const hasFollowup = this.filterListBody.some(
              (f) =>
                f.label?.toLowerCase() === 'followup date' &&
                f.matchOperator === 'BETWEEN' &&
                (f.filterType === 'DateTime' || f.filterType === 'Date')
            );
            
            if (!hasFollowup) {
              const index = this.filterListBody.findIndex(
                (f) =>
                  f.matchOperator === 'CalculatedFieldWithFilter' &&
                  f.priority === 'postMax' &&
                  f.label === 'Max_Case_Version'
              );
              if (index !== -1) {
                this.filterListBody.splice(index, 1);
              }
            }
            
            this.datasetQuickSight.filterList = this.filterListBody
            console.log(this.datasetQuickSight);
            // this.spinner.stop();

            if (data.rowData.status === "No") {
              this.snackbar.open(this.constants.Deleted_Dataset, "OK", { duration: 5000 });
              return;
            }
            this.datasetQuickSight.dataSetId = data.rowData.reportcreationid;
            this.datasetQuickSight.dataSetName = data.rowData.datasetname;
            this.datasetQuickSight.dnsId = this.localStorageSettings.getSettings("dnsName");
            this.datasetQuickSight.s3Path = data.rowData.dataSets3Path;
            if (result.visualType) {
              this.datasetQuickSight.visualType = result.visualType;
            } else {
              this.datasetQuickSight.visualType = "Tabular"
            }

            if (result.visualId > 0) {
              this.datasetQuickSight.visualId = result.visualId
            } else {
              this.datasetQuickSight.visualId = 0
            }
            console.log(this.datasetQuickSight);

            this.linkservice.generateDatasetAnalysis(this.datasetQuickSight).subscribe(result => {
              this.snackbar.open(result.data, "OK", {
                duration: 5000,
              });
              this.spinner.stop();
              if (result.data === "Analysis Generated") {
                const analysisReference = data.rowData.analysisreference;
                const url = this.router.serializeUrl(
                  this.router.createUrlTree(['/user/Menubar/quickSight'], { queryParams: { analysis: analysisReference } })
                );
                window.open(url, '_blank');
                // this.router.navigateByUrl('/user/Menubar', { skipLocationChange: true }).then(() =>
                //   this.router.navigate(["/user/Menubar/quickSight"], { queryParams: { analysis: data.rowData } }));
              }
            });
          }
        });
      } else {
        this.filterListBody = []
      }




    });



  }

  convertArrayToString(array: string[]): string {
    // Join the array elements with "','" and add parentheses and single quotes
    let result = "('" + array.join("','") + "')";
    return result;
  }
  removeSingleQuotes(str) {
    console.log(str);

    return str.replace(/['%]/g, "");
  }

  EditIcon(updatedata) {

    if (updatedata.rowData.status === "No") {
      this.snackbar.open(this.constants.Deleted_Dataset, "OK", { duration: 5000 });
      return;
    }




    console.log(updatedata)
    this.sharedData = updatedata.rowData;



    if (this.responserequest.roleName !== updatedata.rowData.dataset_ownerRoleid) {
      this.snackbar.open(this.constants.Access_Denied, "OK", { duration: 5000 });
      return;

    }
    else {
      this.spinner.start();
      this.service.checkDatasetIsEditable(updatedata.rowData.reportcreationid).subscribe(result => {
        this.spinner.stop();
        console.log(result);
        if (result.error) {
          if (confirm("Dataset is linked to report Template, editing dataset may affect reports. Do you wish to continue?")) {
          } else {
            return;
          }
        }
        this.butttonname = "Update Dataset"
        this.expand = true
        this.show = true
        this.ObjectGrid.api.setGridOption('rowData', []);
        this.selectedTableFields.api.setGridOption('rowData', []);
        this.editData(updatedata)
      });
    }



  }



  editData(updatedata) {

    this.spinner.start();
    this.where = [];
    this.recordWhere = [];
    this.orderBy = [];
    this.aggregateBy = [];
    this.pivotAggregateBy=[];
    this.transformation = [];
    this.columns = [];
    this.temp = [];
    this.concatination = [];
    this.rollingUp = [];
    this.groupconcattemp = [];
    this.filterObjects = [];
    this.headersTypeArr = [];
    let columnstemp = [];
    let concatinationtemp = [];
    let rollingUptemp = [];
    let filters = [];
    let rollupExclusionObjects = [];
    let sorting = [];
    let transformationTemp = [];
    let columnFilterTemp = [];
    this.selectedFieldsData = []
    let headersTypeArr = [];
    this.showHeaderType = false;
    this.reportCreationUpdateid = updatedata.rowData.reportcreationid;
    console.log(updatedata.rowData.autoRefreshDataset)
    if (updatedata.rowData.autoRefreshDataset != "false") {
      this.autoRefreshDataset = updatedata.rowData.autoRefreshDataset;
    }
    console.log(this.reportCreationUpdateid);
    this.reportCreationData.datasetname = updatedata.rowData.datasetname
    this.reportCreationData.description = updatedata.rowData.description
    this.reportCreationData.type = updatedata.rowData.type
    this.reportCreationData.datasetAccessType = updatedata.rowData.datasetAccessType
    this.reportCreationData.dataset_rolesIds = updatedata.rowData.dataset_rolesIds
    this.reportCreationData.createdBy = updatedata.rowData.createdBy
    this.reportCreationData.createdDateAndTime = updatedata.rowData.createdDateAndTime
    /**
     * Modified by Prasanna Jeebi
     * date: 30-06-2025
     */
    this.reportCreationData.datasetRefreshDateTime = updatedata.rowData.datasetRefreshDateTime

    this.reportCreationData.datalakeType = updatedata.rowData.datalakeType
      this.datasetOutputFormat = updatedata.rowData.datasetOutputFormat || '';

    let obgroup = Number(updatedata.rowData.objectGroup);
    this.datasetIdToRetrieveObjectsdata = obgroup;
    console.log(obgroup);
    console.log(this.vaultGroup);
    console.log(this.datasetGroup);
    if (this.reportCreationData.type === "Object Group") {
      this.objectGroup = true;
      this.datasetGroup = false;
      console.log(this.reportCreationData.type)
      this.vaultGroup.forEach(eachGroup => {
        if (eachGroup.objectGroupId === obgroup) {
          this.reportCreationData.objectGroup = eachGroup.objectGroupId;
        }
      })
    } else if (this.reportCreationData.type === "Dataset Group") {
      console.log("inside dataset group===================  ")
      this.objectGroup = false;
      this.datasetGroup = true;

      this.datasetGroups.forEach(eachGroup => {
        if (eachGroup.datasetGroupId === obgroup) {
          this.reportCreationData.objectGroup = eachGroup.datasetGroupId;
        }

      })
    } else {
      this.objectGroup = false;
      this.datasetGroup = false;
    }
    console.log(this.reportCreationData)
    this.onGridReadyForObjects(this.ObjectGrid, obgroup);

    columnstemp = JSON.parse(updatedata.rowData.columns);
    concatinationtemp = JSON.parse(updatedata.rowData.concatination);
    rollingUptemp = JSON.parse(updatedata.rowData.rollingUp);
    filters = JSON.parse(updatedata.rowData.filters);
    sorting = JSON.parse(updatedata.rowData.sorting);


    if (updatedata.rowData.headersType != undefined || updatedata.rowData.headersType != null) {
      headersTypeArr = JSON.parse(updatedata.rowData.headersType);
    } else {
      headersTypeArr = [];
    }



    rollupExclusionObjects = JSON.parse(updatedata.rowData.rollupExclusionObjects);
    transformationTemp = JSON.parse(updatedata.rowData.transformation);
    columnFilterTemp = JSON.parse(updatedata.rowData.columnFilters);
    this.aggregateBy = JSON.parse(updatedata.rowData.aggregate);
    if(updatedata.rowData.pivotAggregation){
      this.pivotAggregateBy=JSON.parse(updatedata.rowData.pivotAggregation);
    }
    
    console.log(this.aggregateBy)
    if (this.aggregateBy.length > 0) {
      this.showAggregate = true;

    }
    if(this.pivotAggregateBy.length > 0){
      this.showPivotAggregate=true
    }
    this.subLevelAggregateBy = [];
    // Temporary array to hold items to keep
    const remainingAggregateBy = [];
    for (let a = 0; a < this.aggregateBy.length; a++) {
      if (this.aggregateBy[a].groupByNeeded === true) {
        this.subLevelAggregateBy.push(this.aggregateBy[a]);
      } else {
        remainingAggregateBy.push(this.aggregateBy[a]);
      }
    }
    this.aggregateBy = remainingAggregateBy;
    console.log(this.subLevelAggregateBy);
    console.log(this.aggregateBy)
    if (this.subLevelAggregateBy.length > 0) {
      this.showSubLevelAggregate = true;

    }

    for (let columnstempindex = 0; columnstempindex < columnstemp.length; columnstempindex++) {
      columnstemp[columnstempindex].attributeNameWithFields = columnstemp[columnstempindex].alias;
      this.selectedFieldsData.push(columnstemp[columnstempindex]);
    }

    for (let rollingUptempindex = 0; rollingUptempindex < rollingUptemp.length; rollingUptempindex++) {
      const rollingupData = rollingUptemp[rollingUptempindex];
      this.rollingUp.push(rollingupData);
      this.showRollingUp = true;
    }
    for (let concatinationtempindex = 0; concatinationtempindex < concatinationtemp.length; concatinationtempindex++) {
      let concat = {
        "objectId": "",
        "object": "",
        "attributeNameWithFields": "",
        "name": "",
        "label": "",
        "type": "",
        "isConcat": true ,//existing concat fields have this flag in temp array
        "uiIndex":0
      };
      for (let concatinationtempchildindex = 0; concatinationtempchildindex < concatinationtemp[concatinationtempindex].columns.length; concatinationtempchildindex++) {
        if (concat.name === "") {
          concat.name = concatinationtemp[concatinationtempindex].columns[concatinationtempchildindex]
        } else {
          concat.name = concat.name + "/" + concatinationtemp[concatinationtempindex].columns[concatinationtempchildindex];
        }
      }
      concat.label = concatinationtemp[concatinationtempindex].label;
      concat.type = concatinationtemp[concatinationtempindex].type;
      concat.object = concatinationtemp[concatinationtempindex].object
      concat.attributeNameWithFields = concatinationtemp[concatinationtempindex].alias;
      concat.uiIndex = concatinationtemp[concatinationtempindex].uiIndex; //taking uiIndex of concat fields
      this.groupconcattemp.push(concat)
    }

    for (let tranformationIndex = 0; tranformationIndex < transformationTemp.length; tranformationIndex++) {
      const tranformationObject = transformationTemp[tranformationIndex];
      console.log(tranformationObject);
      this.showTransform = true;
      this.transformation.push(tranformationObject);
    }
    console.log(this.transformation)

    this.concatination = concatinationtemp;
    console.log(this.concatination)

     
    
       /**
       * Code Modified by Rahul vk 
       * Date :- 06/05/25
       * jira-ID :- JRAAP-4649 
       * Fix - 25R1
       * 
       * Modifications:
       * - Ensured concat fields no longer appear at the top by default — they are now ordered along with columns
       *   based on their computed `uiIndex` using a combined and sorted array (`selectedFieldsData` + `groupconcattemp`).
       * - Final `temp` array now reflects correctly ordered fields as per `uiIndex`.
       * 
       */
      const allFieldsCombined = [ ...this.selectedFieldsData, ...this.groupconcattemp ];
      allFieldsCombined.sort((a, b) => {
        const aIdx = (typeof a.uiIndex === 'number' && a.uiIndex >= 0)
          ? a.uiIndex
          : Number.MAX_SAFE_INTEGER;
        const bIdx = (typeof b.uiIndex === 'number' && b.uiIndex >= 0)
          ? b.uiIndex
          : Number.MAX_SAFE_INTEGER;
        return aIdx - bIdx;
      });
      this.temp = allFieldsCombined;
          console.log(this.temp)

    for (let filterIndex = 0; filterIndex < filters.length; filterIndex++) {
      const filter = filters[filterIndex];
      this.showFilter = true;
      this.where.push(filter);
    }

    for (let sortingIndex = 0; sortingIndex < sorting.length; sortingIndex++) {
      const sort = sorting[sortingIndex];
      this.showOrderBy = true;
      this.orderBy.push(sort);
    }
    //let modifiedHeaders = groupHeadersByType(headersTypeArr);

    for (let headerIndex = 0; headerIndex < headersTypeArr.length; headerIndex++) {
      const sort = headersTypeArr[headerIndex];
      this.showHeaderType = true;
      this.headersTypeArr.push(sort);
    }
    if (this.headersTypeArr.length <= 0) {
      this.showHeaderType = false;
    }


    this.rollupExclusionObjects = [];
    for (let exclusionIndex = 0; exclusionIndex < rollupExclusionObjects.length; exclusionIndex++) {
      const element = rollupExclusionObjects[exclusionIndex];
      this.rollupExclusionObjects.push(element.exclusionObject);
    }

    for (let columnFilterIndex = 0; columnFilterIndex < columnFilterTemp.length; columnFilterIndex++) {
      const element = columnFilterTemp[columnFilterIndex];
      this.columnFilter.push(element);
      this.showColumnFilter = true;
    }
    this.rollupExclusionObjectSelection();
    this.spinner.stop();
    console.log(this.selectedFieldsData)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)
    // this.onGridReadyForObjects(this.ObjectGrid, obgroup)
    this.getObjectsData(obgroup);
    console.log(this.columns)


  }

  getObjectsData(vaultgroup) {

    if (this.objectGroup) {
      this.service.retrieveObjectGroupObject(vaultgroup).subscribe((res) => {
        console.log(res);
        this.spinner.start();
        // checking if response is true or not
        if (res.error === true) {
          this.snackbar.open(res.message, "OK", { duration: 5000 });
        } else {
          this.ObjectsData = res;
          this.pushDataToSelectedFieldsGrid("update");
        }
        this.spinner.stop();
      });
    } else if (this.datasetGroup) {
      this.service.retrieveDatasetObjects(vaultgroup).subscribe(res => {
        console.log(res)
        // checking if response is true or not
        if (res.error === true) {
          this.spinner.stop();

          this.snackbar.open(res.message, "OK", { duration: 5000 });

          this.ObjectGrid.api.setGridOption('rowData', []);
        } else {


          this.ObjectsData = res;
          console.log(res)

          let response = JSON.parse(JSON.stringify(res));

          const keys = Object.keys(res);
          const objects = keys.map(key => ({ objectlabel: key, value: JSON.parse(response[key][0]) }));
          objects.sort((a, b) => a.objectlabel.localeCompare(b.objectlabel));
          console.log(objects)
          //this.ObjectsData = objects;   
          this.tempObjectsData = objects;
          console.log(this.ObjectsData)
          console.log(this.tempObjectsData)
          this.pushDataToSelectedFieldsGrid("update");
          // this.ObjectGrid.api.setGridOption('rowData', objects);
          // this.paramstemp.api.setGridOption('rowData', []);
          this.spinner.stop();
        }
      })

    }
  }

  deleteRollingUp(k) {
    console.log(k)
    this.rollingUp.splice(k, 1);
    if (this.rollingUp.length == 0) {
      this.showRollingUp = false;
    }
    console.log(this.rollingUp)
  }

openConditionInfo(whereData: any): void {
    const dialogRef = this.dialog.open(ConditionInfoDialogComponent, {
      width: '90vw', 
      data: {
        object: whereData.object,
      name: whereData.name,
      filters: whereData.filters
      }
    });
    dialogRef.afterClosed().subscribe(updatedData => {
      if (updatedData) {
        whereData.filters = updatedData.filters;
      }
    });
    console.log(whereData);
    console.log(this.columnFilterData);
    console.log(this.columnFilterData.filters)
  }

  deleteColumnFilter(k) {
    console.log(k)
    this.columnFilter.splice(k, 1);
    if (this.columnFilter.length == 0) {
      this.showColumnFilter = false;
    }
  }
  deleteWhere(k) {
    console.log(k)
    this.where.splice(k, 1);
    if (this.where.length == 0) {
      this.showFilter = false;
    }
  }
  deleteOrder(k) {
    console.log(k)
    this.orderBy.splice(k, 1);
    if (this.orderBy.length == 0) {
      this.showOrderBy = false;
    }
  }
  deleteHeader(k) {
    console.log(k)
    this.headersTypeArr.splice(k, 1);
    if (this.headersTypeArr.length == 0) {
      this.showHeaderType = false;
    }
  }
  deleteAggregate(k) {
    console.log(k)
    this.aggregateBy.splice(k, 1);
    if (this.aggregateBy.length == 0) {
      this.showAggregate = false;
      this.subLevelAggregateBy = [];
      this.subAggregateLevelData = { "groupByColumn": "", "groupByNeeded": true, "alias": "" };
    }
  }

 /**
    * Modified by Renuka chama
    * 01/08/2025
    * code modified to remove filters for pivot aggregate
    */
deletePivotAggregate(parentIndex: number, childIndex?: number): void {
  if (childIndex !== undefined) {
    const metadata = this.pivotAggregateBy[parentIndex].pivotMetadata;
    if (metadata && metadata.length > childIndex) {
      metadata.splice(childIndex, 1);
      if (metadata.length === 0) {
        this.pivotAggregateBy.splice(parentIndex, 1);
      }
    }
  } else {
    this.pivotAggregateBy.splice(parentIndex, 1);
  }
  this.showPivotAggregate = this.pivotAggregateBy.length > 0;
}

  deleteSubLevelAggregate(k) {
    console.log(k)
    this.subLevelAggregateBy.splice(k, 1);
    if (this.subLevelAggregateBy.length == 0) {
      this.showSubLevelAggregate = false;
    }
    for (let a = 0; a < this.aggregateBy.length; a++) {
      if (this.aggregateBy[a].groupByNeeded == true) {
        this.aggregateBy.splice(a, 1);
      }
    }
  }

  deleteTransformation(k) {
    this.transformation.splice(k, 1);
    if (this.transformation.length === 0) {
      this.showTransform = false;
    }
  }

  ClearData() {
    this.transformation = []
    this.concatination = []
    this.groupconcattemp = []
    this.columns = []
    this.selectedFieldsDataToPush.length = 0
    this.temp.length = 0
    this.dataSetObject.objectid = ""
    this.dataSetObject.datasetname = ""
    this.editMyDataSet = ""
    this.dataSetObject.accesstype = "public"
    this.ObjectGrid.api.setGridOption('rowData', []);
    //this.gridApiForSelectedTablesFields.api.setGridOption('rowData', []);
    //this.validations_form.controls['dataSet'].reset();
    this.temp = [];
    this.rollingUp = [];
    this.fieldsDataToRemove = [];
    this.selectedObjectsData = []
    this.selectedFieldsDatatemp = [];
    this.selectedFieldsDataToPush = [];
    this.selectedFieldsData = [];
    console.log(this.show)
    this.paramstemp.api.setGridOption('rowData', []);
    this.tablefields = [];
    this.selectedTableFields.api.setGridOption('rowData', []);
    this.columnDefsForReportingConfiguration = [];
    /**
     * modified by Ashwin M
     * 28/02/2024
     * code modified to reset refresh dataset flag in dataset creation request object
    */
   /**
     * modified by Prasanna Jeebi
     * 30/06/2025
     * code modified to add datasetRefreshDateTime
    */
    this.reportCreationData = {
      datasetname: "",
      datasetObjectname: "",
      datasetobjectattributes: [],
      type: "",
      datalakeType: "",
      description: "",
      objectGroup: "",
      filters: [],
      sorting: [],
      aggregate: [],
      columns: [],
      concatination: [],
      rollingUp: [],
      rollupExclusionObjects: [],
      transformation: [],
      columnFilters: [],
      generateDefaultTemplate: "",
      autoRefreshDataset: "",
      dataset_rolesIds: "",
      datasetAccessType: "",
      createdBy: "",
      createdDateAndTime: "",
      datasetRefreshDateTime: "",
      headersType: [],
      pivotAggregation:[],
      datasetOutputFormat: "", 


    }
    this.where = [];

    this.groupBy = [];

    this.orderBy = [];

    this.fieldsData = [];

    this.aggregateBy = [];
    this.pivotAggregateBy=[]
    this.aggregateArray = [];
    this.orderByShow = false;
    this.aggreageShow = false;
    this.dateChange = false;
    this.expand = false;
    this.formValidationsWhere();
    // this.butttonname = "Save";
    this.formValidation();

    this.formulaFieldsValidation();
    this.datasetFormValidation();
    this.finalReportCreation = {
      "datasets": [
        {
          "name": "",
          "datasetType": "",
          "columns": []
        }
      ],
      "reports": []
    }
    this.butttonname = "Create Dataset"

  }

  selectedObjectsData = []
  selectedObjects(value) {
    this.selectedObjectsData = value
  }

  //forward Icon Function decleation
  pushDataToSelectedFieldsGrid(type) {
    console.log(this.tempObjectsData)
    if (this.datasetGroup) {
      this.ObjectsData = this.tempObjectsData
    }
    console.log(this.ObjectsData)
    console.log(type)
    this.fieldsDataToRemove = [];
    this.selectedFieldsDatatemp.length = 0;
    this.selectedFieldsDataToPush.length = 0;
    this.selectedFieldsDatatemp = this.selectedFieldsData;
    let uniq = {}
    console.log(this.selectedFieldsData);
    console.log(this.selectedFieldsDatatemp);
    for (let i = 0; i < this.selectedFieldsDatatemp.length; i++) {
      var addColumn = true;
      var objectData =
      {
        "name": "",
        "object": "",
      }
      this.addedColumnsTemp =
      {
        "name": "",
        "alias": "",
        "object": "",
        "type": "",
        "label": "",
        "reporting": "",
        "objectLabel": ""
      }
      var alias;
      if (type === "insert") {
        console.log(this.selectedFieldsDatatemp)
        console.log(this.selectedFieldsDatatemp[i].object)
        console.log(this.selectedObject)
        this.addedColumnsTemp.objectLabel = this.selectedObject
        console.log(this.addedColumnsTemp.objectLabel)
        this.selectedFieldsDatatemp[i].object = this.selectedObject;
        if (this.selectedFieldsDatatemp[i].type == "__constant") {
          this.selectedFieldsDatatemp[i].attributeNameWithFields = this.selectedFieldsDatatemp[i].label;
          this.addedColumnsTemp.name = this.selectedFieldsDatatemp[i].attributeNameWithFields;
        } else {
          this.addedColumnsTemp.name = this.selectedFieldsDatatemp[i].name;
          this.selectedFieldsDatatemp[i].attributeNameWithFields = this.selectedObject + " " + this.selectedFieldsDatatemp[i].label;
        }
        alias = this.selectedFieldsDatatemp[i].attributeNameWithFields;
      } else {
        console.log(this.selectedFieldsDatatemp[i].object);
        if (this.selectedFieldsDatatemp[i].type == "__constant") {
          console.log(this.selectedFieldsDatatemp[i].alias);
          this.selectedFieldsDatatemp[i].attributeNameWithFields = this.selectedFieldsDatatemp[i].alias.substring(0, this.selectedFieldsDatatemp[i].alias.indexOf("Seperator"));
          this.addedColumnsTemp.name = this.selectedFieldsDatatemp[i].attributeNameWithFields;
          console.log(this.selectedFieldsDatatemp[i].alias);
        } else {
          this.addedColumnsTemp.name = this.selectedFieldsDatatemp[i].name;
          this.selectedFieldsDatatemp[i].attributeNameWithFields = this.selectedFieldsDatatemp[i].alias;
        }
        alias = this.selectedFieldsDatatemp[i].alias;
      }
      if (alias.includes(".")) {
        alias = alias.replace(".", "_");
      }
      var label = this.selectedFieldsDatatemp[i].label;
      if (label.includes(".")) {
        label = label.replace(".", "_");
      }
      let objectName = "";
      let objectAlias = this.selectedFieldsDatatemp[i].object;
      this.selectedFieldsDataToPush.push(this.selectedFieldsDatatemp[i]);
      this.addedColumnsTemp.alias = alias;
      if (type === "insert") {
        console.log(this.ObjectsData)
        if (this.datasetGroup) {
          console.log(this.objectAttributes)
          this.ObjectsData = this.objectAttributes
        }
        console.log(this.ObjectsData)
        this.ObjectsData.forEach(object => {
          console.log(object, objectAlias);
          console.log(object.objectlabel, objectAlias)
          console.log(object.objectlabel === objectAlias)
          console.log(object.name)
          console.log(object.objecname)

          if (this.datasetGroup) {
            if (object.objectLabel === objectAlias) {
              console.log(object, objectAlias);
              objectName = object.name;
            }
          } else {
            if (object.objectlabel === objectAlias) {
              console.log(object, objectAlias);
              objectName = object.objectname;
            }
          }
        })
        console.log(objectName);
        console.log(this.selectedObjectName)
        this.addedColumnsTemp.object = objectName;
        if (this.datasetGroup) {
          this.addedColumnsTemp.object = this.selectedObjectName;
        }
      } else {

        this.ObjectsData.forEach(object => {
          console.log(object, objectAlias);

          // if(this.datasetGroup){
          //   if (object.objectLabel === objectAlias) {
          //     console.log(object, objectAlias);
          //     objectName = object.name;
          //   }
          // }else {
          if (object.objectname === objectAlias) {
            console.log(object, objectAlias);
            objectName = object.objectlabel;
          }
          if (this.datasetGroup) {
            objectName = object.objectlabel;
            console.log(objectName)
          }
          // }
        })
        console.log(objectName);
        this.addedColumnsTemp.object = objectAlias;
        this.addedColumnsTemp.objectLabel = objectName;
      }
      this.addedColumnsTemp.type = this.selectedFieldsDatatemp[i].type
      this.addedColumnsTemp.label = label
      this.addedColumnsTemp.reporting = "Y"
      console.log(this.addedColumnsTemp);

      this.columns.forEach((eachcolumn) => {
        console.log(eachcolumn.alias, this.addedColumnsTemp.alias)
        if (eachcolumn.alias === this.addedColumnsTemp.alias) {
          console.log(eachcolumn.alias);
          eachcolumn.reporting = "Y";
          addColumn = false;
        }
      })
      if (addColumn) {
        this.columns.push(this.addedColumnsTemp)
      }
      if (this.filterObjects.length == 0) {
        var addvalue = true;
      } else {
        var addvalue = true;
        this.filterObjects.forEach((filterobject) => {
          console.log(filterobject.object, this.addedColumnsTemp.object, objectName);
          if (filterobject.object === this.addedColumnsTemp.object || filterobject.object === objectName) {
            addvalue = false;
          }
        })
      }

      if (addvalue && this.addedColumnsTemp.object != 'constants') {
        if (type === "insert") {
          objectData.name = objectAlias;
          objectData.object = this.addedColumnsTemp.object;
        } else {
          objectData.name = objectName;
          objectData.object = this.addedColumnsTemp.object;
        }
        this.filterObjects.push(objectData)
        console.log(this.filterObjects)
      }
      console.log(this.filterObjects);
      console.log(this.columns)
    }
    console.log(this.columns)
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp.push(...this.selectedFieldsDataToPush)
    this.temp = this.temp.filter(obj => !uniq[obj.attributeNameWithFields] && (uniq[obj.attributeNameWithFields] = true));
    console.log(this.temp)

    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
    this.selectedObjectsData = this.temp.filter(obj => !uniq[obj.object] && (uniq[obj.object] = true));
    console.log(this.selectedObjectsData)
    this.selectedObjects(this.selectedObjectsData)
    this.paramstemp.api.deselectAll();
    if (this.datasetGroup) {
      this.ObjectsData = this.tempObjectsData
    }
  }

  // //double forward Icon Function decleation
  pushDataToSelectedFieldsGridComplete() {
    //this.fieldsDataToRemove=[];
    let uniq = {}
    console.log(this.tablefields);
    for (let i = 0; i < this.tablefields.length; i++) {
      var addColumn = true;
      this.addedColumnsTemp =
      {
        "name": "",
        "alias": "",
        "object": "",
        "type": "",
        "label": "",
        "reporting": "",
        "objectLabel": ""
      }
      /**
       * Modified by Ashwin M
       * 16/03/2023
       * changed reference to retrive value from correct variable
       */
      var alias = this.replaceCharecter(this.selectedObject + " " + this.tablefields[i].label, this.constants.charecterDot, this.constants.charecterUnderScore);
      var label = this.replaceCharecter(this.tablefields[i].label, this.constants.charecterDot, this.constants.charecterUnderScore);
      if (this.tablefields[i].type == "__constant") {
        this.tablefields[i].attributeNameWithFields = this.tablefields[i].label;
      } else {
        this.tablefields[i].attributeNameWithFields = alias;
      }
      this.addedColumnsTemp.name = this.tablefields[i].name
      this.addedColumnsTemp.alias = alias;
      this.addedColumnsTemp.object = this.selectedObjectName
      this.addedColumnsTemp.type = this.tablefields[i].type
      this.addedColumnsTemp.label = label
      this.addedColumnsTemp.reporting = "Y"
      this.tablefields[i].object = this.selectedObject;
      this.tablefields[i].alias = alias;
      this.tablefields[i].label = label
      this.addedColumnsTemp.objectLabel = this.tablefields[i].object
      this.columns.forEach((eachcolumn) => {
        if (eachcolumn.alias === this.addedColumnsTemp.alias) {
          console.log(eachcolumn.alias);
          eachcolumn.reporting = "Y";
          addColumn = false;
        }
      })
      if (addColumn) {
        this.columns.push(this.addedColumnsTemp)
      }
      console.log(this.columns)
      this.selectedFieldsDataToPush.push(this.tablefields[i]);
    }
    var objectData = {
      "name": this.selectedObject,
      "object": this.selectedObjectName
    }
    console.log(objectData);
    let addFilterObject = true;
    console.log(this.filterObjects)
    this.filterObjects.forEach(object => {
      if (object.name === objectData.name && object.object === objectData.object) {
        addFilterObject = false;
      }
    })
    if (addFilterObject) {
      this.filterObjects.push(objectData);
    }
    console.log(this.addedColumnsTemp)
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp.push(...this.selectedFieldsDataToPush)
    this.temp = this.selectedFieldsDataToPush.filter(obj => !uniq[obj.attributeNameWithFields] && (uniq[obj.attributeNameWithFields] = true));
    console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
    //this.pushDataToSelectedFieldsGrid();
    this.selectedObjectsData = this.temp.filter(obj => !uniq[obj.object] && (uniq[obj.object] = true));
    this.selectedObjects(this.selectedObjectsData)
    this.paramstemp.api.deselectAll();
  }

  // //double backward Icon Function decleation
  popDataToSelectedFieldsGridComplete() {
    this.selectedFieldsDataToPush.length = 0
    this.temp.length = 0
    this.addedColumnsTemp =
    {
      "name": "",
      "alias": "",
      "object": "",
      "type": "",
      "label": ""
    }
    this.filterData = [];
    this.filterObjects = [];
    console.log(this.addedColumnsTemp)
    this.columns = [];
    this.concatination = [];
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, [])
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', []);
    this.selectedFieldsData = []
    this.selectedObjectsData = [];
    this.selectedObjects(this.selectedObjectsData)
  }

  //backward Icon Function decleation
  popDataToSelectedFieldsGrid() {
    this.addedColumnsTemp = [];
    this.temp = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
    console.log(this.temp)
    let columntemp = [];
    let concattemp = [];
    this.columns.forEach(eachtemp => {
      this.fieldsDataToRemove.forEach(eachfield => {
        if (eachtemp.alias === eachfield.attributeNameWithFields || eachtemp.alias == (eachfield.attributeNameWithFields + 'Seperator')) {
          console.log(eachtemp)
          columntemp.push(this.columns.indexOf(eachtemp))
        }
      })
    });
    this.concatination.forEach(eachtemp => {
      this.fieldsDataToRemove.forEach(eachfield => {
        if (eachtemp.alias === eachfield.attributeNameWithFields) {
          console.log(eachtemp)
          concattemp.push(this.concatination.indexOf(eachtemp))
        }
      })
    });
    this.columns = this.columns.filter(eachtemp => !columntemp.includes(this.columns.indexOf(eachtemp)));
    this.concatination = this.concatination.filter(eachtemp => !concattemp.includes(this.concatination.indexOf(eachtemp)))
    console.log(this.temp)
    console.log(this.addedColumnsTemp)
    console.log(this.columns)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
    this.selectedFieldsDataToPush = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
    this.selectedFieldsData = [];
    this.fieldsDataToRemove = [];
    let uniq = {}
    this.selectedObjectsData = this.temp.filter(obj => !uniq[obj.object] && (uniq[obj.object] = true));
    this.selectedObjects(this.selectedObjectsData)
  }

  onRowSelectedToRemove(ev) {
    console.log(ev);
    console.log(ev.rowIndex);
    if (ev.node.isSelected() === true) {
      var newKey = "rowIndex";
      var newValue = ev.rowIndex;
      ev.api.getColumn('attributeNameWithFields').editable = true;
      ev.api.getColumn('attributeNameWithFields').rowDrag = true;
      ev.node.data[newKey] = newValue
      this.fieldsDataToRemove.push(ev.node.data)
    } else {
      this.fieldsDataToRemove.forEach(eachunselecteddata => {
        if (eachunselecteddata.rowIndex === ev.rowIndex) {
          let index = this.fieldsDataToRemove.indexOf(eachunselecteddata)
          this.fieldsDataToRemove.splice(index, 1)
        }
      })
    }
    console.log(this.fieldsDataToRemove);
    this.fieldsDataToRemove.forEach(eachconcat => {
      this.concatination.forEach(eachalias => {
        if (eachalias.label === eachconcat.label) {
          eachalias.alias = eachconcat.attributeNameWithFields
          console.log(eachalias.alias)
          console.log(eachconcat.attributeNameWithFields)
        }
      })
    })
    console.log(this.concatination)
  }

  previousAlias: any;

  onCellEditingStarted(event) {
    this.previousAlias = this.replaceCharecter(event.data.attributeNameWithFields, ".", "_");
    console.log(event.data.attributeNameWithFields);
  }


  onCellValueChanged(e) {
    console.log(e)
    this.selectedTableFields.api.deselectAll();
    this.changealisaname(e)
  }
  changealias = []
  changealisaname(e) {
    console.log(this.columns)
    this.changealias = []
    this.changealias.push(e.data)
    for (let changealiasIndex = 0; changealiasIndex < this.changealias.length; changealiasIndex++) {
      let duplicateObjectData: any;
      const eachalias = this.changealias[changealiasIndex];
      var duplicate = false;
      for (let concatIndex = 0; concatIndex < this.concatination.length; concatIndex++) {
        const eachconcat = this.concatination[concatIndex];
        console.log(eachconcat);
        if (eachconcat.alias === eachalias.attributeNameWithFields) {
          duplicate = true;
          duplicateObjectData = eachalias.attributeNameWithFields;
        }
      }
      for (let columnIndex = 0; columnIndex < this.columns.length; columnIndex++) {
        const eachcolumn = this.columns[columnIndex];
        if (eachcolumn.type != "__constant") {
          if (eachcolumn.alias === eachalias.attributeNameWithFields) {
            duplicate = true;
            duplicateObjectData = eachalias.attributeNameWithFields;
          }
        } else {
          if (eachcolumn.alias.substring(0, eachcolumn.alias.indexOf("Seperator")) === eachalias.attributeNameWithFields) {
            duplicate = true;
            duplicateObjectData = eachcolumn.alias.substring(0, eachcolumn.alias.indexOf("Seperator"));
          }
        }
      }
      for (let rollupIndex = 0; rollupIndex < this.rollingUp.length; rollupIndex++) {
        const rollup = this.rollingUp[rollupIndex];
        if (rollup.rollupColumnAlias === eachalias.attributeNameWithFields) {
          duplicate = true;
          duplicateObjectData = eachalias.attributeNameWithFields;
          break;
        }
      }
      for (let aggregateByIndex = 0; aggregateByIndex < this.aggregateBy.length; aggregateByIndex++) {
        console.log(this.aggregateBy[aggregateByIndex])
        const agree = this.aggregateBy[aggregateByIndex];
        console.log(agree.columnAlias + "==-=================" + eachalias.attributeNameWithFields)
        if (agree.alias === eachalias.attributeNameWithFields) {
          duplicate = true;
          duplicateObjectData = eachalias.attributeNameWithFields;
          break;
        }
      }
      console.log(duplicate);
      if (!duplicate) {
        let objecName = "";
        this.ObjectsData.forEach(object => {
          if (eachalias.object === object.objectlabel || eachalias.object === object.objectname) {
            objecName = object.objectname;
          }
        })
        console.log(objecName);
        for (let concatIndex = 0; concatIndex < this.concatination.length; concatIndex++) {
          const eachconcat = this.concatination[concatIndex];
          if (eachalias.label === eachconcat.label) {
            this.concatination[concatIndex].alias = eachalias.attributeNameWithFields
            console.log(eachconcat.alias)
            console.log(eachalias.attributeNameWithFields)
            break;
          }
        }
        for (let columnIndex = 0; columnIndex < this.columns.length; columnIndex++) {
          const eachcolumn = this.columns[columnIndex];
          let label = this.replaceCharecter(eachalias.label, ".", "_");
          console.log(label, eachcolumn.label, eachcolumn.object, objecName);
          if (eachcolumn.type === "__constant") {
            if (eachcolumn.alias.includes("Seperator")) {
              if (eachcolumn.alias.substring(0, eachcolumn.alias.indexOf("Seperator")) === this.previousAlias) {
                this.columns[columnIndex].alias = eachalias.attributeNameWithFields + "Seperator";
              }
            } else if (eachalias.attributeNameWithFields.length === 1) {
              this.columns[columnIndex].alias = eachalias.attributeNameWithFields + "Seperator";
            }
          } else {
            if (eachcolumn.alias === this.previousAlias) {
              this.columns[columnIndex].alias = eachalias.attributeNameWithFields;
              console.log(eachcolumn.alias);
              console.log(eachalias.attributeNameWithFields);
            }
          }
        }
      } else {
        let oldAliasName = [];
        let tempIndex = e.rowIndex;
        console.log(this.temp[tempIndex]);
        const object = this.temp[tempIndex];
        let updateColumnData: any;
        if (object.attributeNameWithFields === duplicateObjectData) {
          console.log(this.butttonname);
          let objectName = this.temp[tempIndex].object;
          if (this.temp[tempIndex].type != "__constant") {
            this.ObjectsData.forEach(objectData => {
              if (objectData.objectname === objectName) {
                objectName = objectData.object;
              }
            })
            this.temp[tempIndex].attributeNameWithFields = objectName + " " + this.temp[tempIndex].label
            oldAliasName.push(objectName + " " + this.temp[tempIndex].label);
          } else {
            this.temp[tempIndex].attributeNameWithFields = this.temp[tempIndex].label;
            oldAliasName.push(this.temp[tempIndex].label);
          }
          updateColumnData = this.temp[tempIndex];
        }
        this.columns.forEach(column => {
          console.log(column);
          let objectName = "";
          if (column.alias === this.previousAlias) {
            if (column.type != "__constant") {
              this.ObjectsData.forEach(objectData => {
                if (objectData.objectname === column.object) {
                  objectName = objectData.object;
                }
              })
              column.alias = objectName + " " + column.label;
            } else {
              column.alias = column.label;
            }
          }
        })
        this.concatination.forEach(column => {
          let objectName = "";
          if (column.alias === duplicateObjectData) {
            if (this.butttonname === "Update Dataset") {
              this.ObjectsData.forEach(objectData => {
                if (objectData.objectname === column.object) {
                  objectName = objectData.object;
                }
              })
            }
            column.alias = objectName + " " + column.label;
            oldAliasName.push(column.alias);
          }
        })
        this.snackbar.open("Please enter Unique name for " + oldAliasName + " Attribute ", "OK", {
          duration: 10000,
        });
      }

      console.log(this.temp);
      this.selectedObjects(this.temp);
      this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp);
      if (this.selectedObject != undefined) {
        this.cellClickedObjectsforValueChange(this.selectedObject)
      }
    }
    console.log(this.temp)
    console.log(this.concatination)
  }

  cellClickedObjectsforValueChange(e) {

    console.log(e);
    console.log(this.selectObjectId);


    this.service.retrieveTablesFieldsForDataset(this.selectObjectId).subscribe(res => {

      this.spinner.start();

      console.log(res);

      // checking if response is true or not
      if (res.error === true) {

        this.spinner.stop();

        this.snackbar.open(res.message, "OK", { duration: 5000 });

        this.allFields = [];

        this.selectedFieldsData = [];

        this.gridApiForTablesFields.setGridOption('rowData', []);

      } else {

        this.spinner.stop();

        this.allFields = res[0];

        console.log(this.selectedObject)

        this.onGridReadyForTablesFields(this.paramstemp, this.allFields, e.value)

        this.columnDefsForReportingConfiguration = [];

      }

    });

  }

  groupconcattemp = []
  groupConcat() {
    let concat = {
      "objectId": "",
      "object": "",
      "attributeNameWithFields": "",
      "name": "",
      "label": "",
      "type": "",
      "isConcat":true  //added this flag to differntiate concat fields
    };

    this.columnname = {
      "columns": [],
      "label": "",
      "alias": "",
      "object": "",
      "type": "",
      "objectId": "",
      "reporting": "",
      "isConcat":true  //added this flag to differntiate concat fields
    }
    this.groupconcattemp = []
    console.log(this.fieldsDataToRemove)
    for (let i = 0; i < this.fieldsDataToRemove.length; i++) {
      if (concat.attributeNameWithFields === "") {
        let attributeElement = this.replaceCharecter(this.fieldsDataToRemove[i].attributeNameWithFields,
          this.constants.charecterDot, this.constants.charecterUnderScore);
        concat.attributeNameWithFields = attributeElement
        concat.label = this.fieldsDataToRemove[i].label;
        this.columnname.label = this.fieldsDataToRemove[i].label;
        if (this.fieldsDataToRemove[i].type === "__constant") {
          console.log("true");
          this.columnname.columns.push(this.fieldsDataToRemove[i].alias);
          concat.name = this.fieldsDataToRemove[i].attributeNameWithFields + "Seperator";
        } else {
          concat.name = this.fieldsDataToRemove[i].attributeNameWithFields;
          this.columnname.columns.push(concat.attributeNameWithFields)
        }

        this.columnname.alias = concat.attributeNameWithFields
        this.columnname.type = this.fieldsDataToRemove[i].type;
      } else {
        /**
        * Modified by Ashiwn M
        * 22/02/2023
        * modified alias to replace "." by "_"
        */
        let attributeElement = this.replaceCharecter(this.fieldsDataToRemove[i].attributeNameWithFields,
          this.constants.charecterDot, this.constants.charecterUnderScore);
        concat.attributeNameWithFields = concat.attributeNameWithFields + attributeElement
        concat.label = concat.label + "," + this.fieldsDataToRemove[i].label;
        this.columnname.label = this.columnname.label + "," + this.fieldsDataToRemove[i].label;
        if (this.fieldsDataToRemove[i].type === "__constant") {
          this.columnname.columns.push(this.fieldsDataToRemove[i].attributeNameWithFields + "Seperator")
        } else {
          concat.name = concat.name + "," + this.fieldsDataToRemove[i].attributeNameWithFields;
          this.columnname.columns.push(this.fieldsDataToRemove[i].attributeNameWithFields)
        }
        this.columnname.alias = concat.attributeNameWithFields;
        this.columnname.type = this.columnname.type + "," + this.fieldsDataToRemove[i].type;
      }
    }
    let objectName__v = "";
    if (this.butttonname === "Update Dataset") {
      objectName__v = this.fieldsDataToRemove[0].object;
    } else {
      this.ObjectsData.forEach(object => {
        if (object.object === this.fieldsDataToRemove[0].object) {
          objectName__v = object.objectname;
        }
        else{
          objectName__v =this.selectedObjectName;
        }
      })
    }
    console.log(this.fieldsDataToRemove[0]);
    console.log(objectName__v, this.fieldsDataToRemove[0].object);
    this.columnname.objectId = this.fieldsDataToRemove[0].objectId;
    this.columnname.object = objectName__v;
    this.columnname.reporting = "Y";
    concat.objectId = this.fieldsDataToRemove[0].objectId;
    concat.object = objectName__v;
    concat.type = this.fieldsDataToRemove[0].type;
    console.log(concat)
    let addConcat = true;
    this.concatination.forEach(eachConcat => {
      if (eachConcat.alias === this.columnname.alias) {
        addConcat = false;
      }
    })
    if (addConcat) {
      this.groupconcattemp.push(concat)
      console.log(this.groupconcattemp)
      this.concatination.push(this.columnname);
      console.log(this.concatination)
      this.temp.push(...this.groupconcattemp)
    } else {
      this.snackbar.open("Selected Concatination is already present", "OK", { "duration": 5000 });
    }
    this.selectedObjects(this.temp);
    console.log(this.temp)
    console.log(this.columns)
    console.log(this.concatination)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)
    this.fieldsDataToRemove = []
    this.groupconcattemp = []
  }

  replaceCharecter(field: any, charecterToReplace, chrecterToReplcaeWith) {
    if (field === undefined || field === "") {
      return "";
    }
    if (field.includes(charecterToReplace)) {
      field = field.replace(charecterToReplace, chrecterToReplcaeWith);
    }
    return field;
  }

  unGroupConcat() {
    this.finalunconcatination = [];
    console.log(this.fieldsDataToRemove)
    this.fieldsDataToRemove.forEach(eachconcat => {
      this.concatination.forEach(eachspliceconcat => {
        if (eachspliceconcat.label = eachconcat.label) {
          this.concatination.splice(this.concatination.indexOf(eachspliceconcat), 1)
        }
      })
    })
    this.temp.forEach(eachtemp => {
      this.fieldsDataToRemove.forEach(eachfield => {
        if (eachtemp.attributeNameWithFields === eachfield.attributeNameWithFields) {
          console.log(eachtemp)
          let index = this.temp.indexOf(eachtemp)
          this.temp.splice(index, 1);
        }
      })
    })
    console.log(this.temp)
    this.pushDataToUnconcatinateToGrid(this.finalunconcatination)
  }

  pushDataToUnconcatinateToGrid(selectedFieldsData) {
    this.fieldsDataToRemove = [];
    this.selectedObjectsData = []
    this.selectedFieldsDatatemp = [];
    this.selectedFieldsDataToPush = [];
    this.selectedFieldsDatatemp = selectedFieldsData;
    let uniq = {}
    console.log(this.selectedFieldsDatatemp);
    for (let i = 0; i < this.selectedFieldsDatatemp.length; i++) {
      this.addedColumnsTemp =
      {
        "name": "",
        "alias": "",
        "object": "",
        "type": "",
        "reporting": ""
      }
      /**
       * Modified by Ashwin M
       * 14/03/2023
       * modified to display object name
       */
      this.selectedFieldsDataToPush.push(this.selectedFieldsDatatemp[i]);
      this.addedColumnsTemp.name = this.selectedFieldsDatatemp[i].name
      this.addedColumnsTemp.alias = this.selectedFieldsDatatemp[i].attributeNameWithFields
      this.addedColumnsTemp.object = this.selectedFieldsDatatemp[i].object
      this.addedColumnsTemp.type = this.selectedFieldsDatatemp[i].type
      this.addedColumnsTemp.reporting = "Y"
      this.columns.push(this.addedColumnsTemp)
      console.log(this.columns)
    }
    console.log(this.columns)
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp.push(...this.selectedFieldsDataToPush)
    //this.temp = this.temp.filter(obj => !uniq[obj.attributeNameWithFields] && (uniq[obj.attributeNameWithFields] = true));
    console.log(this.temp)
    this.selectedFieldsData = [];
    console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
    this.selectedObjectsData = this.temp.filter(obj => !uniq[obj.object] && (uniq[obj.object] = true));
    console.log(this.selectedObjectsData)
    this.selectedObjects(this.selectedObjectsData)
    this.fieldsDataToRemove = []
  }


  onRowDragEnter(e: RowDragEnterEvent) {
    console.log('onRowDragEnter', e);
    console.log(this.temp)
    this.temp.splice(e.overIndex, 1)
    console.log(this.temp)

  }

  onRowDragEnd(e: RowDragEndEvent) {

    console.log('onRowDragEnd', e);
    let dropIndex  = e.overIndex;
    this.temp.splice(dropIndex , 0, e.node.data);
    //assignig index 
    this.temp.forEach((item,idx)=>{
      item.index = idx;
    });
    console.log(this.temp);
    this.onGridReadyForSelectedTableFields(this.selectedTableFields, this.temp)

  }

  onRowDragMove(e: RowDragMoveEvent) {
    console.log('onRowDragMove', e);
    console.log(this.temp)
  }

  onRowDragLeave(e: RowDragLeaveEvent) {
    console.log('onRowDragLeave', e);
    console.log(this.temp)
  }

  addicon() {
    this.isExpand = !this.isExpand;
  }

  changeGroupTypes(e) {
    if (e.value === "Object Group") {
      this.objectGroup = true;
      this.datasetGroup = false;
      this.spinner.start();
      this.vaultObjectService.retrieveAllObjectGroupForDataset(this.localStorageSettings.getSettings("dnsName")).subscribe(res => {
        this.vaultGroup = res;
        console.log(res);
        this.spinner.stop();
      })
    } else if (e.value === "Dataset Group") {
      this.objectGroup = false;
      this.datasetGroup = true;
      this.vaultObjectService.retrieveDatasetGroup().subscribe(res => {
        this.datasetGroups = res;
      })
    } else {
      this.objectGroup = false;
      this.datasetGroup = false;
    }

  }

  datasetOneAttributes: any = []
  objectChildData: any = []
  changeRollingUpDatasetNameOne(e) {
    this.datasetOneAttributes = []
    this.objectChildData = []
    console.log(e.value)
    let objectAlias = "";
    console.log(this.ObjectsData)
    this.ObjectsData.forEach(object => {
      if (object.objectname === e.value || object.objectlabel === e.value) {
        if (object.object != undefined) {
          objectAlias = object.object;
        } else if (object.objectlabel != undefined) {
          objectAlias = object.objectlabel;
        }
      }
    })
    console.log(objectAlias);

    this.temp.forEach(obj => {
      console.log(obj);
      if (obj.type != "__constant" && (obj.object === objectAlias || obj.object === e.value)) {
        this.datasetOneAttributes.push(obj)
      }
    })
  }

  datasetTwoAttributes = []
  changeRollingUpDatasetNameTwo(e) {
    console.log(e)
    this.datasetTwoAttributes = []
    if (e.value === this.rollingupdata.parentObjectName || this.rollingupdata.childObjectName === "" || this.rollingupdata.childObjectName === undefined) {
      this.rollingupdata.childObjectName = undefined;
      this.snackbar.open("Cannot apply rollup on same object. Please select a Child object", "OK", {
        duration: 5000
      })
      return;
    }
    this.reportCreationData.rollupExclusionObjects.forEach(object => {
      if (object.exclusionObject == e.value) {
        this.rollingupdata.childObjectName = undefined;
        this.snackbar.open("Cannot apply rollup on Exclusion objects. Please select a valid Child object", "OK", {
          duration: 5000
        })
        return;
      }
    })
    let objectAlias = "";
    this.ObjectsData.forEach(object => {
      if (object.objectname === e.value || object.objectlabel === e.value) {
        if (object.object != undefined) {
          objectAlias = object.object;
        } else if (object.objectlabel != undefined) {
          objectAlias = object.objectlabel;
        }
      }
    })
    console.log(objectAlias);
    this.temp.forEach(obj => {
      if (obj.type != "__constant" && (obj.object === objectAlias || obj.object === e.value)) {
        this.datasetTwoAttributes.push(obj)
      }
    })

  }

  filterCondition(event) {
    this.scheduleRange = false;
    if (event.value === "BETWEEN") {
      this.fieldChange = false;
      this.betweenField = true;
      if (this.dateField) {
        this.dateChange = true;
        this.dateField = false;
      } else {
        this.valueField = true;
      }
      this.multiselect = false;
    } else if (event.value === "IN") {
      if (this.dateField || this.dateChange) {
        console.log(this.dateField, ",", this.dateChange);

      } else {
        this.multiselect = true;
        this.betweenField = false;
        this.dateField = false;
        this.fieldChange = false;
      }
    } else if (event.value === "schedule range") {
      this.multiselect = false;
      this.betweenField = false;
      this.dateField = false;
      this.fieldChange = false;
      this.dateChange = false;
      this.valueField = false;
      this.scheduleRange = true;
    } else {
      this.multiselect = false;
      if (this.dateField) {
        this.fieldChange = false;
        this.dateField = true;
      } else {
        if (this.dateChange) {
          this.fieldChange = false;
          this.dateField = true;
          this.dateChange = false;
        } else {
          this.fieldChange = true;
          this.dateField = false;
        }
      }
      this.betweenField = false;
    }
  }

  attrbuteSelection(event) {
    /**
     * Modified by Ashwin M
     * 08/07/2024
     * code modified to hide all other entry fields and show only text field
     */
    this.betweenField = false;
    this.dateChange = false;
    this.dateField = false;
    this.multiselect = false;
    this.fieldChange = true;
    console.log(event.value);
    let objectName = "";
    this.filterData.forEach(object => {
      if (object.alias === this.whereData.fieldsWhere) {
        console.log(object);
        objectName = object.object + "_" + object.name.replace(".", "_");
      }
    })
    console.log(objectName);
    var multiselectElement = false;
    this.multiSelectKeyAttributes.forEach(value => {
      if (value === objectName) {
        multiselectElement = true;
      }
    });
    for (let objectIndex = 0; objectIndex < this.columns.length; objectIndex++) {
      const object = this.columns[objectIndex];
      if (object.alias === event.value) {
        /**
         * Modified by Ashwin M
         * 08/07/2024
         * code modified to match data for both 'DateTime' and 'Date' type
         */
        this.dateField = (object.type == "DateTime" || object.type == "Date")
        break;
      } else {
        this.dateField = false;
      }
    }
    if (this.dateField) {
      this.valueField = false;
      this.fieldChange = false;
      this.multiselect = false;
    } else {
      this.fieldChange = true;
      this.dateField = false;
      this.dateChange = false;
    }
    this.betweenField = false;
    this.whereData.conditionalOperatorWhere = "";
    if (multiselectElement) {
      if (objectName === undefined || objectName === '' || objectName.length === 0) {
        return;
      }
      this.spinner.start();
      this.betweenField = false;
      this.dateField = false;
      this.fieldChange = false;
      this.scheduleRange = false;
      this.multiselect = true;
      let event = { value: "IN" }
      this.whereData.conditionalOperatorWhere = "IN";
      this.recordFilterCondition(event);
      this.multiSelectVaules = [];
      console.log(this.localStorageSettings.getSettings("vaultDnsname"), this.reportCreationData.objectGroup, objectName);
      this.service.retrieveMultiselect(this.localStorageSettings.getSettings("vaultDnsname"), this.reportCreationData.objectGroup, objectName).subscribe(response => {
        console.log(response);
        if (response != null) {
          var sampleData = response;
          var data = sampleData[0].split(",");
          for (let elementIndex = 0; elementIndex < data.length; elementIndex++) {
            let element = data[elementIndex];
            if (element.includes("[")) {
              element = element.replace("[", "");
            }
            if (element.includes("]")) {
              element = element.replace("]", "");
            }
            if (element.includes("\"")) {
              element = element.replace("\"", "");
              element = element.replace("\"", "");
            }
            let dataTemplate = { "alias": "" };
            dataTemplate.alias = element;
            this.multiSelectVaules.push(dataTemplate);
          }
          console.log(this.multiSelectVaules);
        } else {
          this.snackbar.open("No Facet declared for selected attribute", "OK", { duration: 5000 });
        }
      });
      this.spinner.stop();
    }
  }

  recordFilterCondition(event) {
    this.recordscheduleRange = false;
    if (event.value === "BETWEEN") {
      this.recordValueField = false;
      this.recordBetweenField = true;
      if (this.recordDateField) {
        this.recordMultiDate = true;
        this.recordDateField = false;
      } else {
        this.recordMultiField = true;
      }
      this.recordMultiselect = false;
    } else if (event.value === "IN") {
      if (this.recordDateField || this.recordMultiDate) {
        console.log(this.recordDateField, ",", this.recordMultiDate);

      } else {
        this.recordMultiselect = true;
        this.recordBetweenField = false;
        this.recordDateField = false;
        this.recordValueField = false;
      }
    } else if (event.value === "schedule range") {
      this.recordValueField = false;
      this.recordBetweenField = false;
      this.recordMultiselect = false;
      this.recordDateField = false;
      this.recordMultiDate = false;
      this.recordMultiField = false;
      this.recordscheduleRange = true;
    } else {
      this.recordMultiselect = false;
      if (this.recordDateField) {
        this.recordValueField = false;
        this.recordDateField = true;
      } else {
        if (this.recordMultiDate) {
          this.recordValueField = false;
          this.recordDateField = true;
          this.recordMultiDate = false;
        } else {
          this.recordValueField = true;
          this.recordDateField = false;
        }
      }
      this.recordBetweenField = false;
    }
  }

  recordLevelAttrbuteSelection(event) {
    this.recordfilterData.fieldsWhere = event.value;
    console.log(this.recordfilterData.fieldsWhere);
    let filedName = "";
    this.recordLevelFilterData.forEach(object => {
      if (object.alias === this.recordfilterData.fieldsWhere) {
        filedName = object.object + "_" + object.filedName.replace(".", "_");
      }
    })
    console.log(filedName);
    console.log(this.multiSelectKeyAttributes);
    var multiselectElement = false;
    this.multiSelectKeyAttributes.forEach(value => {
      if (value === filedName) {
        multiselectElement = true;
      }
      if (event.value.includes("country")) {
        multiselectElement = true;
      }
    });
    console.log(multiselectElement);
    if (multiselectElement) {
      this.spinner.start();
      this.multiSelectVaules = [];
      console.log(filedName.includes("country") || filedName.includes("Country"));
      this.service.retrieveMultiselect(this.localStorageSettings.getSettings("vaultDnsname"), this.reportCreationData.objectGroup, filedName).subscribe(response => {
        if (response != null) {
          var sampleData = response;
          var data = sampleData[0].split(",");
          for (let elementIndex = 0; elementIndex < data.length; elementIndex++) {
            let element = data[elementIndex];
            if (element.includes("[")) {
              element = element.replace("[", "");
            }
            if (element.includes("]")) {
              element = element.replace("]", "");
            }
            if (element.includes("\"")) {
              element = element.replace("\"", "");
              element = element.replace("\"", "");
            }
            let dataTemplate = { "alias": "" };
            dataTemplate.alias = element;
            this.multiSelectVaules.push(dataTemplate);
          }
          console.log(this.multiSelectVaules);
        }
      });
      this.spinner.stop();
    }
    for (let objectIndex = 0; objectIndex < this.recordLevelFilterData.length; objectIndex++) {
      const object = this.recordLevelFilterData[objectIndex];
      if (object.alias === event.value) {
        console.log(object.type);
        /**
         * Modified by Ashwin M
         * 08/07/2024
         * code modified to match data for both 'DateTime' and 'Date' type
         */
        this.recordDateField = (object.type == "DateTime" || object.type == "Date")
        break;
      } else {
        this.recordDateField = false;
      }
    }
    console.log(this.recordDateField);
    if (this.recordDateField) {
      this.recordBetweenField = false;
      this.recordDateField = true;
      this.recordMultiDate = false;
      this.recordMultiField = false;
      this.recordMultiselect = false;
      this.recordValueField = false;
      this.recordscheduleRange = false;
    } else {
      this.recordBetweenField = false;
      this.recordDateField = false;
      this.recordMultiDate = false;
      this.recordMultiField = false;
      this.recordMultiselect = false;
      this.recordValueField = true;
      this.recordscheduleRange = false;
    }
    this.recordfilterData.conditionalOperatorWhere = "";
  }

  applyRecordFilterSelection() {
    if (this.applyRecordFilter) {
      this.applyRecordFilter = false;
    } else {
      this.applyRecordFilter = true;
      this.spinner.start();
      this.recordLevelFilterData = [];
      this.multiSelectKeyAttributes = [];
      this.service.retrieveMultiselect(this.localStorageSettings.getSettings("vaultDnsname"), this.reportCreationData.objectGroup, "Keys").subscribe(response => {
        if (response != null) {
          this.multiSelectKeyAttributes = response;
          console.log(this.multiSelectKeyAttributes);
        }
      });
      this.recordLevelFilterData = [];
      let objectName = this.rollingupdata.childObjectName;
      console.log(objectName);
      let recordFilter = [];
      this.columns.forEach(object => {
        if (object.object === objectName && object.type != "" && !object.type.includes(",")) {
          recordFilter.push(object);
        }
      });
      this.recordLevelFilterData = recordFilter;
      this.spinner.stop();
    }
  }

  addRecordFilter() {
    this.recordfilterData.objectWhere = this.rollingupdata.childObjectName;

    //api call to insert data
    // this.formFieldsTrimer.trimFormfieldsData(this.whereData);
    // this.formFieldsTrimer.clean(this.recordfilterData);
    if (this.recordfilterData.objectWhere == undefined || this.recordfilterData.fieldsWhere == undefined || this.recordfilterData.conditionalOperatorWhere == undefined) {
      this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });
    } else {
      this.recordfilterData.logicalOperatorWhere = "AND";
      console.log(this.recordfilterData.enterValueWhereDate)
      console.log(this.recordfilterData.enterValueWhere)
      let filedName = "";
      this.recordLevelFilterData.forEach(object => {
        if (object.alias === this.recordfilterData.fieldsWhere) {
          console.log(object);
          console.log(object.name);
          filedName = object.name;
        }
      })
      var whereValue = "";
      if (this.recordfilterData.conditionalOperatorWhere === "IN") {
        var multipleValue;
        var multiValue = "";
        multipleValue = this.recordfilterData.multiSelect;
        let value = multipleValue.split(",");
        if (value.length == 0) {
          this.snackbar.open("Not a valid filter. Please select value to Add filter", "OK", { duration: 5000 });
        } else {
          for (let index = 0; index < value.length; index++) {
            const element = value[index];
            multiValue = multiValue + "'" + element + "'";
            if (index != value.length - 1) {
              multiValue = multiValue + ",";
            }
          };
          whereValue = "(" + multiValue + ")";
          let tempWhere = {
            "objectWhere": this.recordfilterData.objectWhere,
            "whereKey": filedName,
            "whereKeyAlias": this.recordfilterData.fieldsWhere,
            "whereCondition": this.recordfilterData.conditionalOperatorWhere,
            "whereValue": whereValue,
            "whereValue1": "",
            "whereLogic": this.recordfilterData.logicalOperatorWhere
          }

          this.recordWhere.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        }
      } else if (this.recordfilterData.conditionalOperatorWhere === "BETWEEN") {
        if (this.dateChange) {
          this.whereValueDateFormat = moment(this.recordfilterData.enterValueBetweenStart)
          this.recordfilterData.enterValueBetweenStart = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
          console.log(this.recordfilterData.enterValueBetweenStart)
          this.whereValueDateFormat = moment(this.recordfilterData.enterValueBetweenEnd)
          this.recordfilterData.enterValueBetweenEnd = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
          console.log(this.recordfilterData.enterValueBetweenEnd)
          let tempWhere = {
            "objectWhere": this.recordfilterData.objectWhere,
            "whereKey": filedName,
            "whereKeyAlias": this.recordfilterData.fieldsWhere,
            "whereCondition": this.recordfilterData.conditionalOperatorWhere,
            "whereValue": "'" + this.recordfilterData.enterValueBetweenStart + "'",
            "whereValue1": "'" + this.recordfilterData.enterValueBetweenEnd + "'",
            "whereLogic": this.recordfilterData.logicalOperatorWhere
          }
          this.recordWhere.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        } else {
          let tempWhere = {
            "objectWhere": this.recordfilterData.objectWhere,
            "whereKey": filedName,
            "whereKeyAlias": this.recordfilterData.fieldsWhere,
            "whereCondition": this.recordfilterData.conditionalOperatorWhere,
            "whereValue": "'" + this.recordfilterData.enterValueBetweenStart + "'",
            "whereValue1": "'" + this.recordfilterData.enterValueBetweenEnd + "'",
            "whereLogic": this.recordfilterData.logicalOperatorWhere
          }
          this.recordWhere.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        }
      } else if (this.recordfilterData.conditionalOperatorWhere === "schedule range") {
        let tempWhere = {
          "objectWhere": this.recordfilterData.objectWhere,
          "whereKey": filedName,
          "whereKeyAlias": this.recordfilterData.fieldsWhere,
          "whereCondition": this.recordfilterData.conditionalOperatorWhere,
          "whereValue": "",
          "whereValue1": "",
          "whereLogic": this.recordfilterData.logicalOperatorWhere
        }
        this.recordWhere.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else if (this.recordfilterData.conditionalOperatorWhere === "Ends with") {
        whereValue = "'%" + this.recordfilterData.enterValueWhere + "'";
        let tempWhere = {
          "objectWhere": this.recordfilterData.objectWhere,
          "whereKey": filedName,
          "whereKeyAlias": this.recordfilterData.fieldsWhere,
          "whereCondition": "LIKE",
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.recordfilterData.logicalOperatorWhere
        }

        this.recordWhere.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else if (this.recordfilterData.conditionalOperatorWhere === "Starts with") {
        whereValue = "'" + this.recordfilterData.enterValueWhere + "%'";
        let tempWhere = {
          "objectWhere": this.recordfilterData.objectWhere,
          "whereKey": filedName,
          "whereKeyAlias": this.recordfilterData.fieldsWhere,
          "whereCondition": "LIKE",
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.recordfilterData.logicalOperatorWhere
        }

        this.recordWhere.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else if (this.recordfilterData.conditionalOperatorWhere === "contains") {
        whereValue = "'%" + this.recordfilterData.enterValueWhere + "%'";
        let tempWhere = {
          "objectWhere": this.recordfilterData.objectWhere,
          "whereKey": filedName,
          "whereKeyAlias": this.recordfilterData.fieldsWhere,
          "whereCondition": "LIKE",
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.recordfilterData.logicalOperatorWhere
        }

        this.recordWhere.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else {
        if (this.dateField) {
          this.whereValueDateFormat = moment(this.recordfilterData.enterValueWhereDate)
          whereValue = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
        } else {
          whereValue = "'" + this.recordfilterData.enterValueWhere + "'";
        }
        console.log(filedName);
        let tempWhere = {
          "objectWhere": this.recordfilterData.objectWhere,
          "whereKey": filedName,
          "whereKeyAlias": this.recordfilterData.fieldsWhere,
          "whereCondition": this.recordfilterData.conditionalOperatorWhere,
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.recordfilterData.logicalOperatorWhere
        }
        this.recordWhere.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      }
      console.log(this.recordWhere);
      // this.showFilter = true;
      this.recordfilterData = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };
      this.recordBetweenField = false;
      this.recordMultiField = false;
      this.recordMultiDate = false;
      this.recordDateField = false;
      this.recordValueField = true;
      this.recordMultiselect = false;
      this.recordscheduleRange = false;
    }
  }

  downloadDataset(type,event) {
    let data = event.rowData
    let s3path =data.templateS3Path;
    let fileName = data.templateS3Path.substring(data.templateS3Path.lastIndexOf("/") + 1);
    if(type==="wordTemplate"){
      s3path=data.wordTemplateS3Path
      fileName =data.wordTemplateS3Path.substring(data.templateS3Path.lastIndexOf("/") + 1);
    }
    else if(type=="excelConfig"){
     s3path=data.wordConfigFilePath;
    fileName =data.wordConfigFilePath.substring(data.templateS3Path.lastIndexOf("/") + 1);
    }
    if (s3path === undefined || s3path === "") {
      this.snackbar.open(data.datasetname + " file not present in S3", "OK", {
        duration: 5000
      })
    } else {
      this.service.downloadDatasetTemplate(data.reportcreationid,type).subscribe(response => {
        console.log(response);
        var dataBlob = new Blob([response]);
        const fileData = window.URL.createObjectURL(dataBlob);
        let link = document.createElement('a');
        link.href = fileData;
        link.download = fileName;
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      })
    }

  }

  rollupExclusionObjectSelection() {
    this.reportCreationData.rollupExclusionObjects = [];
    console.log(this.rollupExclusionObjects);
    for (let exclusionIndex = 0; exclusionIndex < this.rollupExclusionObjects.length; exclusionIndex++) {
      this.rollupExclusionObjectTemplate = { "exclusionObject": "" }
      const element = this.rollupExclusionObjects[exclusionIndex];
      if (this.reportCreationData.rollupExclusionObjects.length === 0) {
        this.rollupExclusionObjectTemplate.exclusionObject = element;
        this.reportCreationData.rollupExclusionObjects.push(this.rollupExclusionObjectTemplate);
      } else {
        this.reportCreationData.rollupExclusionObjects.forEach(object => {
          if (object.exclusionObject != element) {
            this.rollupExclusionObjectTemplate.exclusionObject = element;
            this.reportCreationData.rollupExclusionObjects.push(this.rollupExclusionObjectTemplate);
          }
        })
      }
    }
    console.log(this.reportCreationData.rollupExclusionObjects);
  }

  onRollupAliasChange(updatedRollupAlias) {
    console.log(updatedRollupAlias);
    let duplicate = false;
    for (let concatIndex = 0; concatIndex < this.concatination.length; concatIndex++) {
      const eachconcat = this.concatination[concatIndex];
      if (eachconcat.alias === updatedRollupAlias) {
        duplicate = true;
        break;
      }
    }
    console.log(duplicate);
    for (let columnIndex = 0; columnIndex < this.columns.length; columnIndex++) {
      const eachcolumn = this.columns[columnIndex];
      if (eachcolumn.alias === updatedRollupAlias) {
        duplicate = true;
        break;
      }
    }
    console.log(duplicate);
    for (let rollupIndex = 0; rollupIndex < this.rollingUp.length; rollupIndex++) {
      const rollup = this.rollingUp[rollupIndex];
      if (rollup.rollupColumnAlias === updatedRollupAlias) {
        duplicate = true;
        break;
      }
    }
    for (let aggregateByIndex = 0; aggregateByIndex < this.aggregateBy.length; aggregateByIndex++) {
      const agree = this.aggregateBy[aggregateByIndex];
      if (agree.alias === updatedRollupAlias) {
        duplicate = true;
        break;
      }
    }
    console.log(duplicate);
    if (duplicate) {
      this.rollingupdata.rollupColumnAlias = undefined;
      this.rollingupdata.rollupColumnAlias = this.rollingupdata.parentAttributesalias + "(" + this.rollingupdata.childAttributesalias + ")";
      this.snackbar.open("Please enter Unique Alias for Rollup", "OK", {
        duration: 10000,
      });
    }
  }
  duplicate = false

  onColumnAliasChange(columnAlias) {
    console.log(columnAlias);
    let duplicate = false;
    for (let columnIndex = 0; columnIndex < this.columns.length; columnIndex++) {
      const eachcolumn = this.columns[columnIndex];
      console.log(eachcolumn.alias);
      if (eachcolumn.alias === columnAlias) {
        duplicate = true;
        break;
      }
    }
    console.log(this.aggregateBy.length)
    for (let aggregateByIndex = 0; aggregateByIndex < this.aggregateBy.length; aggregateByIndex++) {
      console.log(this.aggregateBy[aggregateByIndex])
      const agree = this.aggregateBy[aggregateByIndex];
      console.log(agree.columnAlias + "==-=================" + columnAlias)
      if (agree.alias === columnAlias) {
        duplicate = true;
        break;
      }
    }
    for (let rollupIndex = 0; rollupIndex < this.rollingUp.length; rollupIndex++) {
      const rollup = this.rollingUp[rollupIndex];
      if (rollup.rollupColumnAlias === columnAlias) {
        duplicate = true;
        break;
      }
    }

    // if (duplicate) {
    //   this.snackbar.open("Please enter Unique Alias for Aggregate", "OK", {
    //     duration: 10,
    //   });




    // }

  }

  onTransformationObjectSelection(event) {
    console.log("transformation working.............")
    this.spinner.start();
    this.service.retrieveAllObjects(this.localStorageSettings.getSettings("dnsName")).subscribe(result => {
      console.log(result);
      this.referenceObjects = result;
    })
    console.log(this.filterObjects);
    this.filterData = []
    var tempColumnData = this.columns;
    var filterAttributes = [];
    var objectName = "";
    this.filterObjects.forEach((object) => {
      console.log(object.object);
      if (object.object === event.value) {
        objectName = object.object;
      }
    })
    console.log(objectName);
    tempColumnData.forEach((object) => {
      if (object.object === objectName && object.type != "" && !object.type.includes(",") && object.type != "__constant") {
        console.log(object);
        filterAttributes.push(object)
      }
    })
    this.filterData = filterAttributes;
    console.log(this.filterData);
    this.spinner.stop();
  }

  onTransformationReferenceObjectSelection(event) {
    console.log(event.value);
    this.transformationReferenceListTemp = event.value;
    console.log(this.transformationReferenceListTemp);
    console.log(this.columns, "===========ccccccccccccccccccccccccccccc======")


  }

  onPartitionChangeSelection(event: MatSelectChange) {

    this.orderedPartitionSelection = this.updateOrderedSelection(this.orderedPartitionSelection, event.value);
  }
  filteredColumns = [...this.columns];

  onHeaderChangeSelection(event: MatSelectChange) {
    // console.log(this.filteredColumns)
    // const selectedValues = this.headerTypeObj.headerKey;
    // this.filteredColumns = this.columns.filter(
    //   (col) => !selectedValues.includes(col.alias)
    // );
  }
  onOrderByChangeSelection(event) {
    console.log(event);
    console.log(this.subAggregateLevelData);
    this.orderedOrderBySelection = this.updateOrderedSelection(this.orderedOrderBySelection, event.value);
  }

  onOrderByChildColumns(event){
    this.orderedChildColumns=this.updateOrderedSelection(this.orderedChildColumns, event.value);
  }
  onOrderByorderedHeadersToNull(event){
    this.orderedHeadersToNull=this.updateOrderedSelection(this.orderedHeadersToNull, event.value);
  }

  onOrderByorderedOrderByColumn(event){
    this.orderedOrderByColumn=this.updateOrderedSelection(this.orderedOrderByColumn, event.value);
  }
  onOrderByorderedParentcolumns(event){
    this.orderedParentcolumns=this.updateOrderedSelection(this.orderedParentcolumns, event.value);
  }
  

  /**
   *@Author : Shyam
   * @Date :14-11-2024
   * @param currentSelection 
   * @param newSelection 
   * @returns  method to return the manage ordered selections from dropdowns
   */

  private updateOrderedSelection(currentSelection: string[], newSelection: string[]): string[] {
    const updatedSelection = [];


    currentSelection.forEach((value) => {
      if (newSelection.includes(value)) {
        updatedSelection.push(value);
      }
    });

    newSelection.forEach((value) => {
      if (!updatedSelection.includes(value)) {
        updatedSelection.push(value);
      }
    });

    return updatedSelection;
  }

  /**
   * Method: addTransformation
   * Last Modified By: Prasanna Jeebi
   * Last Modified Date: 25/06/2025
  */
  addTransformation() {
    //Removed the referenceObject is empty verification from the if condition
    if (this.transformationObjectData.object === "" || this.transformationObjectData.attribute === "" || this.transformationObjectData.sql === "") {
      this.snackbar.open("Not a valid Transformation", "OK", { duration: 5000 })
      return;
    } else {
      this.showTransform = true;
      let attributeAlias = this.transformationObjectData.alias;
      let tempReference = "";

      //Added the condition to verify the undifined transformationReferenceList
      if (this.transformationReferenceList !== null) {
        this.transformationReferenceList.forEach(obj => {
          if (tempReference === "") {
            tempReference = obj;
          } else {
            tempReference = tempReference + "," + obj;
          }
        });
      }
      let transformationTemp = {
        "object": this.transformationObjectData.object,
        "attribute": this.transformationObjectData.attribute,
        "alias": attributeAlias,
        "referenceObjects": tempReference,
        "sql": this.transformationObjectData.sql
      };

      this.transformation.push(transformationTemp);

      // Reseting transformationtemp and transformationObjectData object
      transformationTemp = {"object": "",
        "attribute": "",
        "alias": "",
        "referenceObjects": "",
        "sql": ""}
      this.transformationObjectData = { "object": "", "attribute": "", "alias":"", "referenceObjects": "", "sql": "" };
      tempReference = "";

      // Reset the form group fields
      this.transformationFormGroup.reset();
      this.formValidationForTranformation();
      
    }
  }

  /**
   * Method: onAttributeChange
   * Author: Prasanna Jeebi
   * Created Date: 2025-06-24
   * Description: Updates the transformation object with the selected field's name and alias.
   *              Also updates the selected field to reflect in the UI dropdown.
  */
  onAttributeChange(selected: any): void {
    this.transformationObjectData.attribute = selected.name;
    this.transformationObjectData.alias = selected.alias;
    this.transformationField = selected;
  }

  objectWhereKey(event) {
    this.columnLevelFilterData = []

    // this.wherefields=event
    // console.log(this.wherefields)
    this.columnFilterDataObject.fieldsWhere = "";
    var tempColumnData = this.columns;
    var filterAttributes = [];
    var objectName = "";
    this.filterObjects.forEach((object) => {
      console.log(object.object, ",", event.value);
      if (object.object === event.value) {
        objectName = object.object;
      }
    })
    console.log(objectName);

    console.log(this.columns);

    tempColumnData.forEach((object) => {
      if (object.object === objectName && object.type != "" && !object.type.includes(",") && object.type != "__constant") {
        console.log(object);
        filterAttributes.push(object)
      }
    })
    this.columnLevelFilterData = filterAttributes;
    this.service.retrieveMultiselect(this.localStorageSettings.getSettings("vaultDnsname"), this.reportCreationData.objectGroup, "Keys").subscribe(response => {
      if (response != null) { 
        console.log(response);
        this.multiSelectKeyAttributes = response;
        console.log(this.multiSelectKeyAttributes);
      }
    });
  }

  onColumnFilterAttributeSelection(event) {
    this.columnFilterData.name = "";
    this.temp.forEach(object => {
      if (object.attributeNameWithFields === event.value) {
        console.log(object);
        this.columnFilterData.name = object.name;
      }
    })
  }

  onColumnObjectSelection(event) {
    this.filterData = [];

    // this.wherefields=event
    // console.log(this.wherefields)
    this.columnFilterDataObject.fieldsWhere = "";
    var tempColumnData = this.columns;
    var filterAttributes = [];
    var objectName = "";
    this.filterObjects.forEach((object) => {
      console.log(object.object, ",", event.value);
      if (object.object === event.value) {
        objectName = object.object;
      }
    })
    console.log(objectName);
    tempColumnData.forEach((object) => {
      if (object.object === objectName && object.type != "" && !object.type.includes(",") && object.type != "__constant") {
        console.log(object);
        filterAttributes.push(object)
      }
    })
    this.filterData = filterAttributes;
    this.service.retrieveMultiselect(this.localStorageSettings.getSettings("vaultDnsname"), this.reportCreationData.objectGroup, "Keys").subscribe(response => {
      if (response != null) {
        console.log(response);
        this.multiSelectKeyAttributes = response;
        console.log(this.multiSelectKeyAttributes);
      }
    });
  }

  onColumnAttrbuteSelection(event) {
    this.columnFieldChange = false;
    this.columnMultiselect = false;
    this.columnBetweenField = false;
    this.columnDateChange = false;
    this.columnDateField = false;
    this.columnValueField = false;
    this.columnScheduleRange = false;
    
   /**
    * Modified by Renuka 
    * 20/11/2025
    * code modified to Handle "None" case.
    */
 
  if (!event || event.value === 'None') {
    this.columnFilterDataObject.fieldsWhere = '';
    this.columnFilterDataObject.conditionalOperatorWhere = '';
    this.columnFilterDataObject.enterValueWhere = '';
    this.columnFilterDataObject.enterValueBetweenStart = '';
    this.columnFilterDataObject.enterValueBetweenEnd = '';
    this.columnFilterDataObject.enterValueWhereDate = '';
    this.columnFilterDataObject.multiSelect = [];
    return;
  }
    /**
    * Modified by Ashwin M
    * 08/07/2024
    * code modified to reset conditional operator
    */
    this.columnFilterDataObject.conditionalOperatorWhere = '';
    this.columnFilterFormGroup.controls['columnLogicalOperatorWhere'].setValue('');
    console.log(event.value);
    let objectName = "";
    this.filterData.forEach(object => {
      if (object.alias === this.columnFilterDataObject.fieldsWhere) {
        console.log(object);
        objectName = object.object + "_" + object.name.replace(".", "_");
      }
    })
    console.log(objectName);
    /**
    * Modified by Ashwin M
    * 08/07/2024
    * code modified to set multiselect as false by default
    */
    var multiselectElement = false;
    this.multiSelectKeyAttributes.forEach(value => {
      if (value === objectName) {
        multiselectElement = true;
      }
    });
    if (multiselectElement) {
      this.spinner.start();
      this.multiSelectVaules = [];
      this.service.retrieveMultiselect(this.localStorageSettings.getSettings("vaultDnsname"), this.reportCreationData.objectGroup, objectName).subscribe(response => {
        if (response != null || response.length < 0) {
          var sampleData = response;
          var data = sampleData[0].split(",");
          for (let elementIndex = 0; elementIndex < data.length; elementIndex++) {
            let element = data[elementIndex];
            if (element.includes("[")) {
              element = element.replace("[", "");
            }
            if (element.includes("]")) {
              element = element.replace("]", "");
            }
            if (element.includes("\"")) {
              element = element.replace("\"", "");
              element = element.replace("\"", "");
            }
            let dataTemplate = { "alias": "" };
            dataTemplate.alias = element;
            this.multiSelectVaules.push(dataTemplate);
          }
          console.log(this.multiSelectVaules);
        } else {
          this.snackbar.open("No Facet deplcared for selected attribute", "OK", { duration: 5000 });
        }
      });
      this.spinner.stop();
    }
    for (let objectIndex = 0; objectIndex < this.columns.length; objectIndex++) {
      const object = this.columns[objectIndex];
      if (object.alias === event.value) {
        /**
         * Modified by Ashwin M
         * 08/07/2024
         * code modified to match data for both 'DateTime' and 'Date' type
         */
        this.columnDateField = (object.type == "DateTime" || object.type == "Date")
        break;
      } else {
        this.columnDateField = false;
        /**
         * Modified by Ashwin M
         * 08/07/2024
         * code modified to set date field as false when attribute selected is not of type date
         */
        this.columnDateChange = false;
      }
    }
    if (this.columnDateField) {
      this.columnValueField = false;
      this.columnFieldChange = false;
      this.columnMultiselect = false;
      /**
      * Modified by Ashwin M
      * 08/07/2024
      * code modified to automate multiselect on attribute selection
      */
    } else if (multiselectElement) {
      let event = { value: "IN" }
      this.columnFilterDataObject.conditionalOperatorWhere = "IN";
      this.columnFilterFormGroup.controls['columnLogicalOperatorWhere'].setValue("IN");
      this.onColumnFilterConditionSelection(event);
    } else {
      this.columnFieldChange = true;
      this.columnDateField = false;
      this.columnDateChange = false;
    }
    this.columnBetweenField = false;
     /**
         * Modified by Bhor S
         * 01/08/2025
         * code modified to make multiselect work
         */
 //   this.columnFilterDataObject.conditionalOperatorWhere = "";
  }

  onColumnFilterConditionSelection(event) {
    this.columnScheduleRange = false;
    if (event.value === "BETWEEN") {
      this.columnFieldChange = false;
      this.columnBetweenField = true;
      if (this.columnDateField) {
        this.columnDateChange = true;
        this.columnDateField = false;
      } else {
        this.columnValueField = true;
      }
      this.columnMultiselect = false;
    } else if (event.value === "IN") {
      if (this.columnDateField || this.columnDateChange) {
        console.log(this.columnDateField, ",", this.columnDateChange);

      } else {
        this.columnMultiselect = true;
        this.columnBetweenField = false;
        this.columnDateField = false;
        this.columnFieldChange = false;
      }
    } else if (event.value === "schedule range") {
      this.columnMultiselect = false;
      this.columnBetweenField = false;
      this.columnDateField = false;
      this.columnFieldChange = false;
      this.columnDateChange = false;
      this.columnValueField = false;
      this.columnScheduleRange = true;
    } else {
      this.columnMultiselect = false;
      if (this.columnDateField) {
        this.columnFieldChange = false;
        this.columnDateField = true;
      } else {
        if (this.columnDateChange) {
          this.columnFieldChange = false;
          this.columnDateField = true;
          this.columnDateChange = false;
        } else {
          this.columnFieldChange = true;
          this.columnDateField = false;
        }
      }
      this.columnBetweenField = false;
    }
  }

  addFilterForColumn() {
    /**
    * Modified by Renuka 
    * 20/11/2025
    * Code modified to validate Object, Attribute, Operator and value before adding filter.
    */
    if (this.columnFilterDataObject.objectWhere == undefined || this.columnFilterDataObject.fieldsWhere == undefined || this.columnFilterDataObject.conditionalOperatorWhere == undefined||  (
    !this.columnFilterDataObject.enterValueWhere &&
    !this.columnFilterDataObject.enterValueBetweenStart && 
    !this.columnFilterDataObject.enterValueWhereDate && 
    (!this.columnFilterDataObject.multiSelect || this.columnFilterDataObject.multiSelect.length === 0)
  )) {
      this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });
      return;
    } else {
      this.columnFilterDataObject.logicalOperatorWhere = "AND";
      console.log(this.columnFilterDataObject.enterValueWhereDate)
      console.log(this.columnFilterDataObject.enterValueWhere)
      if (!this.columnFilterData.filters) {
      this.columnFilterData.filters = [];
    }
      let objectName = "";
      this.filterData.forEach(object => {
        if (object.alias === this.columnFilterDataObject.fieldsWhere) {
          objectName = object.name;
        }
      })
      var whereValue;
      if (this.columnFilterDataObject.conditionalOperatorWhere === "IN") {
        var multipleValue;
        var multiValue = "";
        multipleValue = this.columnFilterDataObject.multiSelect;
         /**
         * Modified by Bhor S
         * 01/08/2025
         * code modifies to display multivalues correctly
         */
        let value = multipleValue;
        if (value.length == 0) {
          this.snackbar.open("Not a valid filter. Please select value to Add filter", "OK", { duration: 5000 });
        }
        for (let index = 0; index < value.length; index++) {
          const element = value[index];
          multiValue = multiValue + "'" + element + "'";
          if (index != value.length - 1) {
            multiValue = multiValue + ",";
          }
        };
        whereValue = "(" + multiValue + ")";
        let tempWhere = {
          "objectWhere": this.columnFilterDataObject.objectWhere,
          "whereKey": objectName,
          "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
          "whereCondition": this.columnFilterDataObject.conditionalOperatorWhere,
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
        }

        this.columnFilterData.filters.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else if (this.columnFilterDataObject.conditionalOperatorWhere === "BETWEEN") {
        if (this.columnDateChange) {
          this.whereValueDateFormat = moment(this.columnFilterDataObject.enterValueBetweenStart)
          this.columnFilterDataObject.enterValueBetweenStart = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
          console.log(this.columnFilterDataObject.enterValueBetweenStart)
          this.whereValueDateFormat = moment(this.columnFilterDataObject.enterValueBetweenEnd)
          this.columnFilterDataObject.enterValueBetweenEnd = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
          console.log(this.columnFilterDataObject.enterValueBetweenEnd)
          let tempWhere = {
            "objectWhere": this.columnFilterDataObject.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
            "whereCondition": this.columnFilterDataObject.conditionalOperatorWhere,
            "whereValue": "'" + this.columnFilterDataObject.enterValueBetweenStart + "'",
            "whereValue1": "'" + this.columnFilterDataObject.enterValueBetweenEnd + "'",
            "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
          }
          this.columnFilterData.filters.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        } else {
          let tempWhere = {
            "objectWhere": this.columnFilterDataObject.objectWhere,
            "whereKey": objectName,
            "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
            "whereCondition": this.columnFilterDataObject.conditionalOperatorWhere,
            "whereValue": "'" + this.columnFilterDataObject.enterValueBetweenStart + "'",
            "whereValue1": "'" + this.columnFilterDataObject.enterValueBetweenEnd + "'",
            "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
          }
          this.columnFilterData.filters.push(tempWhere);
          tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
        }
      } else if (this.columnFilterDataObject.conditionalOperatorWhere === "schedule range") {
        let tempWhere = {
          "objectWhere": this.columnFilterDataObject.objectWhere,
          "whereKey": objectName,
          "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
          "whereCondition": this.columnFilterDataObject.conditionalOperatorWhere,
          "whereValue": "",
          "whereValue1": "",
          "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
        }
        this.columnFilterData.filters.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else if (this.columnFilterDataObject.conditionalOperatorWhere === "Ends with") {
        whereValue = "'%" + this.columnFilterDataObject.enterValueWhere + "'";
        let tempWhere = {
          "objectWhere": this.columnFilterDataObject.objectWhere,
          "whereKey": objectName,
          "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
          "whereCondition": "LIKE",
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
        }

        this.columnFilterData.filters.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" };
      } else if (this.columnFilterDataObject.conditionalOperatorWhere === "Starts with") {
        whereValue = "'" + this.columnFilterDataObject.enterValueWhere + "%'";
        let tempWhere = {
          "objectWhere": this.columnFilterDataObject.objectWhere,
          "whereKey": objectName,
          "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
          "whereCondition": "LIKE",
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
        }

        this.columnFilterData.filters.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else if (this.columnFilterDataObject.conditionalOperatorWhere === "contains") {
        whereValue = "'%" + this.columnFilterDataObject.enterValueWhere + "%'";
        let tempWhere = {
          "objectWhere": this.columnFilterDataObject.objectWhere,
          "whereKey": objectName,
          "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
          "whereCondition": "LIKE",
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
        }

        this.columnFilterData.filters.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" }
      } else {
        if (this.columnDateField) {
          this.whereValueDateFormat = moment(this.columnFilterDataObject.enterValueWhereDate)
          whereValue = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
        } else {
          whereValue = "'" + this.columnFilterDataObject.enterValueWhere + "'";
          this.columnFilterDataObject.enterValueWhere = whereValue;
        }
        let tempWhere = {
          "objectWhere": this.columnFilterDataObject.objectWhere,
          "whereKey": objectName,
          "whereKeyAlias": this.columnFilterDataObject.fieldsWhere,
          "whereCondition": this.columnFilterDataObject.conditionalOperatorWhere,
          "whereValue": whereValue,
          "whereValue1": "",
          "whereLogic": this.columnFilterDataObject.logicalOperatorWhere
        }

        this.columnFilterData.filters.push(tempWhere);
        tempWhere = { "objectWhere": "", "whereKey": "", "whereKeyAlias": "", "whereCondition": "", "whereValue": "", "whereValue1": "", "whereLogic": "" };
      }
      this.columnFilterDataObject = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };
      this.columnDateChange = false;
      this.columnDateField = false;
      this.columnMultiselect = false;
      this.columnFieldChange = true;
      this.columnScheduleRange = false;
      this.columnBetweenField = false;
      console.log(this.columnFilterData);
      this.multiSelectVaules = [];
      this.filterData = [];
    }
  }

  addColumnFilter() {
  if (!this.columnFilterData) {
    this.columnFilterData = { "name": "", "object": "", "alias": "", "filters": [] };
  }

  if (!Array.isArray(this.columnFilterData.filters)) {
    this.columnFilterData.filters = [];
  }

   /**
    * Modified by Renuka 
    * 20/11/2025
    * Code updated to use simplified field validation.
    */
    if (!this.columnFilterData.object  || !this.columnFilterData.name  || !this.columnFilterData.alias || this.columnFilterData.filters.length === 0) {
      this.snackbar.open("Not a valid Column Filter", "OK", { duration: 5000 });
      return;
    } 

    /* Modified by Renuka chama
    * 16/10/2025
    * Updated to add view condition popup.
    */

    const existingFilter = this.columnFilter.find(f => f.object === this.columnFilterData.object && f.alias === this.columnFilterData.alias);
    if(existingFilter){
      existingFilter.filters.push(...this.columnFilterData.filters)
    }else{
      this.columnFilter.push({
        object: this.columnFilterData.object,
        alias: this.columnFilterData.alias,
        name: this.columnFilterData.name,
        filters: [...this.columnFilterData.filters]
      })
    }
      
      this.columnFilterData = { "name": "", "object": "", "alias": "", "filters": [] };
      this.columnFilterDataObject = { "objectWhere": "", "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "enterValueBetweenStart": "", "enterValueBetweenEnd": "", "enterValueWhereDate": "", "logicalOperatorWhere": "", "multiSelect": [] };
      this.showColumnFilter = true;
      this.columnFilterFormGroup.reset();
      this.validateColumnFilterFormGroup();

  }

  deleteIcon(updatedata) {
    console.log(updatedata)
    if (updatedata.rowData.status === "No") {
      this.snackbar.open(this.constants.Deleted_Dataset, "OK", { duration: 5000 });
      return;
    }



    console.log(updatedata)
    this.sharedData = updatedata.rowData;



    if (this.responserequest.roleName !== updatedata.rowData.dataset_ownerRoleid) {
      this.snackbar.open(this.constants.Access_Denied, "OK", { duration: 5000 });
      return;
    }
    else {
      if (confirm("Are you sure you want to delete dataset?")) {
        this.spinner.start();
        this.service.deleteDataset(updatedata.rowData.reportcreationid).subscribe(result => {
          if (result.statusMessage === "Successfully record is deleted") {
            this.snackbar.open(result.statusMessage, "OK", { duration: 5000 });
          } else {
            this.snackbar.open("Cannot delete selected dataset, it is linked to a report template", "OK", { duration: 5000 });
          }
          this.refreshRun();
          this.spinner.stop();
        });
      }


    }



  }

  /**
    * @author Ashwin M
    * 28/02/2024
    * method to send dataset refresh request to generate datasets on demand
  */
  refreshDataset(selectedDataset) {

  //   if (selectedDataset.rowData.status === "No") {
  //     this.snackbar.open("Cannot refersh deleted Dataset", "OK", { duration: 5000 });
  //     return;
  //   }
  //   /**
  //  * modified by Chandra R
  //  * 01/06/2024
  //  * added Validation for dataset refresh if any dataset generation is "In Progress" then it cannot be refreshed
  //  */
  //   if (selectedDataset.rowData.generationStatus == "In Progress") {
  //     this.snackbar.open("Dataset Generation is in Progress try Later", "OK", { duration: 5000 });
  //     return;
  //   }

  //   if (confirm("Are you sure you want to refresh dataset?")) {
  //     this.spinner.start();
  //     this.service.refreshDataset(selectedDataset.rowData.reportcreationid).subscribe(result => {
  //       if (result.error) {
  //         this.snackbar.open(result.statusMessage + result.data, "OK", { duration: 5000 });
  //       } else {
  //         this.snackbar.open(result.statusMessage, "OK", { duration: 5000 });
  //       }
  //       this.refreshRun();
  //       this.spinner.stop();
  //     });
    //   }
    
    console.log(selectedDataset);
    
        let dialogRef = this.dialog.open(IncrementalDataLoadSchedulePopupComponent, {
            panelClass: 'custom-dialog-container-materialFulfilment',
            width: "80%",
            autoFocus: false,
          data: { edata: selectedDataset,scheduleFor:'Dataset Refresh'  },
    
          disableClose: true,
            
    
          });
  }
  exportData(): void {
    this.spinner.start();
    let dialogRef: any;

    this.vaultObjectService.retrieveAllObjectGroupForDataset(this.localStorageSettings.getSettings("dnsName")).subscribe(res => {
      this.ExportObjectGroups = res;
      console.log(res);
      let width = "70%";
      // Open dialog with proper configurations
      dialogRef = this.dialog.open(ExportDialogComponent, {
        maxWidth: '100vw',
        height: '500px', // Set a fixed height
        width: '800px', // Set a fixed width
        data: { datasets: this.getdata, ObjectGroups: this.ExportObjectGroups },
        disableClose: true,
      });


      this.spinner.stop();

      // Handle dialog close
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // this.snackbar("Datasets exported as zip file. Please check.", "OK", { duration: 3000 });
          console.log('Selected datasets for export:', result);
          // Example: Pass the selected datasets to an export function
          // this.performExport(result);
        }
      });
    }, error => {
      this.spinner.stop();
      console.error('Error retrieving object groups:', error);
      //this.snackbar("Failed to retrieve data. Please try again.", "OK", { duration: 3000 });
    });
  }


  importData(): void {

    this.spinner.start();
    let dialogRef: any;
    this.vaultObjectService.retrieveAllObjectGroupForDataset(this.localStorageSettings.getSettings("dnsName")).subscribe(res => {
      this.ExportObjectGroups = res;
      console.log(res);
      let width = "90%";

      dialogRef = this.dialog.open(ImportDialogComponent, {
        maxWidth: '100vw',
        height: "80%",
        width: width,

        data: { ObjectGroups: this.ExportObjectGroups },
        disableClose: true,

      });
      this.spinner.stop();
    })


    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Handle the export logic here with selected datasets
        console.log('Selected datasets for export:', result);
        // Example: Pass the selected datasets to an export function
        // this.performExport(result);
      }
    });
  }


  copyDatasetandupdate(params) {
    console.log("Inside copy dataset...")



    console.log(this)
    console.log(params.data)

    this.sharedData = params.data;

    if (params.data.status === "No") {
      this.snackbar.open(this.constants.Deleted_Dataset, "OK", { duration: 5000 });
      return;
    }

    console.log(params.data.dataset_ownerRoleid)
    if (this.responserequest.roleName !== params.data.dataset_ownerRoleid) {
      this.snackbar.open(this.constants.Access_Denied, "OK", { duration: 5000 });
      return;
    }

    let dialogRef = this.dialog.open(CopydatasetDialogComponent, {
      maxWidth: "100vw",
      height: "30%",
      width: "40%",
      data: { data: params },
      disableClose: true,
    });

  }




  copyDataset(params) {
    console.log("Inside copy dataset...")
    // let flag = false;
    // if (confirm("Are you sure you want to copy the dataset?")) {

    // Stop further execution if user clicks "Cancel"


    //if(flag){ 
    console.log(params)
    this.spinner.start();
    let parentKey = 0;

    const reportCreationData = {
      "datasetname": "", "datasetObjectname": "", "datasetobjectattributes": [], "type": "", "datalakeType": "",
      "description": "", "objectGroup": "", "filters": [], "sorting": [], "aggregate": [], "columns": [], "concatination": [],
      "rollingUp": [], "rollupExclusionObjects": [], "transformation": [], "columnFilters": [], "headersType": [], "generateDefaultTemplate": "",
      "autoRefreshDataset": "", "datasetAccessType": "", "dataset_rolesIds": "", "createdBy": "", "createdDateAndTime": "","pivotAggregation":[],"datasetOutputFormat": ""
    }


    console.log(params.rowData.datasetname)

    reportCreationData.datasetname = params.rowData.datasetname
    reportCreationData.datasetObjectname = params.rowData.datasetObjectname;
    reportCreationData.datasetobjectattributes = JSON.parse(params.rowData.datasetobjectattributes);
    reportCreationData.type = params.rowData.type;
    reportCreationData.datalakeType = params.rowData.datalakeType;
    reportCreationData.description = params.rowData.description;
    reportCreationData.objectGroup = params.rowData.objectGroup;
    reportCreationData.filters = JSON.parse(params.rowData.filters);
    reportCreationData.sorting = JSON.parse(params.rowData.sorting);
    reportCreationData.aggregate = JSON.parse(params.rowData.aggregate);
    reportCreationData.columns = JSON.parse(params.rowData.columns);
    reportCreationData.concatination = JSON.parse(params.rowData.concatination);
    reportCreationData.rollingUp = JSON.parse(params.rowData.rollingUp);
    reportCreationData.rollupExclusionObjects = JSON.parse(params.rowData.rollupExclusionObjects);
    reportCreationData.transformation = JSON.parse(params.rowData.transformation);
    reportCreationData.columnFilters = JSON.parse(params.rowData.columnFilters);
    reportCreationData.generateDefaultTemplate = this.generateDefaultTemplate;
    reportCreationData.autoRefreshDataset = "false";
    reportCreationData.datasetAccessType = params.rowData.datasetAccessType;
    reportCreationData.dataset_rolesIds = params.rowData.dataset_rolesIds;
    reportCreationData.pivotAggregation = JSON.parse(params.rowData.pivotAggregation);
    reportCreationData.datasetOutputFormat = params.rowData.datasetOutputFormat;
    

    if (params.rowData.headersType != null || params.rowData.headersType != undefined) {
      reportCreationData.headersType = JSON.parse(params.rowData.headersType);
    }
    console.log(reportCreationData.aggregate)
    console.log(typeof reportCreationData.aggregate)

    for (let a = 0; a < reportCreationData.aggregate.length; a++) {
      const currentItem = reportCreationData.aggregate[a];
      if (currentItem.groupByNeeded === undefined || currentItem.groupByNeeded === null) {
        currentItem.groupByNeeded = false;
      }
    }


    console.log(reportCreationData)

    this.linkservice.insertreportlinks(reportCreationData, parentKey).subscribe(response => {
      console.log(response);
      // checking if response is true or not
      /**
       * modified by Ashwin M
       * 28/02/2024
       * code modified to show both stauts and associated data in the snackbar
       */
      this.snackbar.open(response.statusMessage + response.data, "OK", {
        duration: 5000,
      });
      this.spinner.stop();
      if (!response.error) {
        this.showRollingUp = false;
        this.objectGroup = false;
        this.datasetGroup = false;
        this.onGridReady(this.rowbindingdata);
        this.cancel();
      }
      this.aggregateBy = []
      this.pivotAggregateBy=[]
    });
    // } else {
    //   console.log("cancelled confirmation =====================")

    // }

  }





  // CopyDatasetandupdate(params){

  //   if (confirm("Are you sure you want to copy the dataset?")) {
  //     } else {
  //       return;
  //     }

  //   console.log(params)
  //   this.spinner.start();
  //   let parentKey = 0;
  //   const reportCreationData = { "datasetname": "", "datasetObjectname": "", "datasetobjectattributes": [], "type": "",
  //   "description": "", "objectGroup": "", "filters": [], "sorting": [], "aggregate": [], "columns": [], "concatination": [],
  //   "rollingUp": [], "rollupExclusionObjects": [], "transformation": [], "columnFilters": [], "generateDefaultTemplate": "", 
  //   "autoRefreshDataset": "" ,"datasetAccessType": "" ,"dataset_rolesIds": "","createdBy":"","createdDateAndTime":"" }

  //   console.log(params.rowData.datasetname)

  // reportCreationData.datasetname = params.rowData.datasetname
  // reportCreationData.datasetObjectname = params.rowData.datasetObjectname;
  // reportCreationData.datasetobjectattributes = JSON.parse(params.rowData.datasetobjectattributes);
  // reportCreationData.type = params.rowData.type;
  // reportCreationData.description = params.rowData.description;
  // reportCreationData.objectGroup = params.rowData.objectGroup;
  // reportCreationData.filters =JSON.parse( params.rowData.filters);
  // reportCreationData.sorting = JSON.parse(params.rowData.sorting);
  // reportCreationData.aggregate = JSON.parse(params.rowData.aggregate);
  // reportCreationData.columns =JSON.parse(params.rowData.columns);
  // reportCreationData.concatination =JSON.parse( params.rowData.concatination);
  // reportCreationData.rollingUp = JSON.parse(params.rowData.rollingUp);
  // reportCreationData.rollupExclusionObjects = JSON.parse(params.rowData.rollupExclusionObjects);
  // reportCreationData.transformation =JSON.parse( params.rowData.transformation);
  // reportCreationData.columnFilters =JSON.parse( params.rowData.columnFilters);
  // reportCreationData.generateDefaultTemplate = this.generateDefaultTemplate;
  // reportCreationData.autoRefreshDataset = "false";
  // reportCreationData.datasetAccessType = params.rowData.datasetAccessType;
  // reportCreationData.dataset_rolesIds = params.rowData.dataset_rolesIds;
  // console.log(reportCreationData)

  // this.linkservice.insertreportlinks(reportCreationData, parentKey).subscribe(response => {
  //   console.log(response);
  //   // checking if response is true or not
  //   /**
  //    * modified by Ashwin M
  //    * 28/02/2024
  //    * code modified to show both stauts and associated data in the snackbar
  //    */
  //   this.snackbar.open(response.statusMessage + response.data, "OK", {
  //     duration: 5000,
  //   });
  //   this.spinner.stop();
  //   if (!response.error){
  //     this.showRollingUp = false;
  //     this.objectGroup = false;
  //     this.datasetGroup = false;
  //     this.onGridReady(this.rowbindingdata);
  //     this.cancel();
  //   }
  //   this.aggregateBy=[]
  // });
  // }


  async updateButtonsPermission(screenPath) {
    var buttonIdList: any = await this.retrieveScreenAccess.find(screenPath);
    console.log('Button ID List:', buttonIdList);
    const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
    buttons.forEach(button => {
      const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
      if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
        if (!buttonIdList.includes(buttonId)) {
          button.setAttribute('disabled', 'true'); // Disable the button
        } else {
          button.removeAttribute('disabled'); // Enable the button
        }
      }
    });
  }

  retrieveLookupValuebyLookupType(lookuptype){
    this.service.retrieveLookupValuebyLookupType(lookuptype).subscribe(response => {
      console.log(response);
      if(response && response.length > 0) {
       response.forEach(lookup => {
          let object = {rollupseparator: lookup.lookupcode,rollupseperatorvalue: lookup.lookupvalue};
          // Find if key already exists
const index = this.rollupSeparatorList.findIndex(
  item => item.rollupseparator === object.rollupseparator
);

if (index !== -1) {
  // Key exists → overwrite the value
  this.rollupSeparatorList[index] = object;
} else {
  // Key does not exist → push new
  this.rollupSeparatorList.push(object);
}

        });
      }
    });
    //rollupSeparator
  }

  onSeparatorSelect(event){
   console.log(this.rollingupdata)
    this.rollingupdata.rollupseprator = event.value;
    console.log(this.rollingupdata)
}


}


// this is used for making the editable cell to enter only numeric values in ag grid table
function getNumericCellEditor() {


  // function isCharNumeric(charStr) {

  //   return !!/\d/.test(charStr);
  // }
  // function isKeyPressedNumeric(event) {
  //   var charCode = getCharCodeFromEvent(event);
  //   var charStr = String.fromCharCode(charCode);
  //   return isCharNumeric(charStr);
  // }

  function getCharCodeFromEvent(event) {

    event = event || window.event;
    return typeof event.which === 'undefined' ? event.keyCode : event.which;
  }
  function NumericCellEditor() { }
  NumericCellEditor.prototype.init = function (params) {
    this.focusAfterAttached = params.cellStartedEdit;
    this.eInput = document.createElement('input');
    this.eInput.style.width = '100%';
    this.eInput.style.height = '100%';

    // this.eInput.value = isCharNumeric(params.charPress)
    //   ? params.charPress
    //  : params.value;
    var that = this;

    // KeyDown event is used when the user clicks on the Control + V
    this.eInput.addEventListener('keydown', function (event) {
      if ((event.ctrlKey || event.metaKey) && event.keyCode == 86) {
        that.eInput.focus();
        if (event.preventDefault) event.preventDefault();
      }
    });

    this.eInput.addEventListener('keypress', function (event) {
      // if (!isKeyPressedNumeric(event)) {
      //   that.eInput.focus();
      //   if (event.preventDefault) event.preventDefault();
      // }


    });
  };
  NumericCellEditor.prototype.getGui = function () {
    return this.eInput;
  };
  NumericCellEditor.prototype.afterGuiAttached = function () {
    if (this.focusAfterAttached) {
      this.eInput.focus();
      this.eInput.select();
    }
  };
  NumericCellEditor.prototype.isCancelBeforeStart = function () {
    return this.cancelBeforeStart;
  };
  NumericCellEditor.prototype.isCancelAfterEnd = function () { };
  NumericCellEditor.prototype.getValue = function () {
    return this.eInput.value;
  };
  NumericCellEditor.prototype.focusIn = function () {
    var eInput = this.getGui();
    eInput.focus();
    eInput.select();
    console.log('NumericCellEditor.focusIn()');
  };
  NumericCellEditor.prototype.focusOut = function () {
    console.log('NumericCellEditor.focusOut()');
  };
  return NumericCellEditor;
}


function groupHeadersByType(headers) {
  const grouped: { [key: string]: string[] } = {};

  // Group header keys by headerKeyType
  headers.forEach((header) => {
    if (!grouped[header.headerKeyType]) {
      grouped[header.headerKeyType] = [];
    }
    grouped[header.headerKeyType].push(header.headerKey);
  });

  // Convert grouped object into the desired array format
  return Object.entries(grouped).map(([keyType, headerKeys]) => ({
    headerKey: headerKeys.join(","),
    headerKeyObject: "",
    headerKeyType: keyType,
    headerKeyAlias: ""
  }));
}
function findCommonValue(arr1: string[], arr2: string[]): string {
  // Use a Set for efficient lookups
  const set1 = new Set(arr1);

  // Iterate through the second array and check for common values
  for (const value of arr2) {
    if (set1.has(value)) {
      return value; // Return the first common value found
    }
  }

  // If no common value is found, return an empty string
  return "";
}
